/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * OmniMedia platform API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptInviteResult,
  AdBooking,
  AdBookingCheckoutResponse,
  AdBookingRejectInput,
  AdBookingReport,
  AdCampaign,
  AdCampaignDashboard,
  AdCampaignInput,
  AdCampaignSubmitInput,
  AdCampaignSummary,
  AdCampaignUpdate,
  AdCreativePreview,
  AdInventoryListing,
  AdInventoryListingInput,
  AdInventoryListingUpdate,
  AdPlacementResubmitInput,
  AdPlacementsInput,
  AddMemberInput,
  AdminCustomerDetail,
  AdminCustomersResponse,
  AdminFleetList,
  AdminGrowth,
  AdminGrowthBulkBody,
  AdminGrowthBulkResult,
  AdminGrowthPostUpdate,
  AdminGrowthSocialPost,
  AdminOverview,
  AdminSupportTicket,
  AdminSupportTicketDetail,
  AdminSupportTicketList,
  AllocateOrderInput,
  Audience,
  AudienceClausesInput,
  AudienceInput,
  AudienceUpdate,
  AudienceWithClauses,
  AuditLogList,
  BadGatewayResponse,
  BadRequestResponse,
  BillingCheckoutInput,
  BillingOverview,
  BillingRedirectInput,
  BillingSession,
  BrandingAssetUrl,
  BrandingUploadInput,
  BrandingUploadTicket,
  Broadcast,
  BroadcastListItem,
  BroadcastStartInput,
  BroadcastStartResponse,
  BrowseAdMarketplaceInventoryParams,
  BufferedTelemetryBatch,
  BufferedTelemetryResult,
  BulkCreateDevicesInput,
  BulkCreateDevicesResult,
  BulkDeviceActivationInput,
  BulkDeviceConfigInput,
  BulkDeviceLabelInput,
  BulkDeviceMoveInput,
  BulkDeviceResult,
  CatalogueArtist,
  CatalogueFacets,
  CatalogueGenre,
  CatalogueIndexInfo,
  CatalogueTrack,
  CatalogueTrackList,
  CatalogueTrackReactionInput,
  CatalogueTrackReactionState,
  Channel,
  ChannelUpdate,
  ConflictResponse,
  CreateInviteInput,
  Device,
  DeviceActivationUpdate,
  DeviceChannelsUpdate,
  DeviceClaimInput,
  DeviceCredentialResponse,
  DeviceDiagnostics,
  DeviceDisplaySettingsInput,
  DeviceEvent,
  DeviceExitPinVerify,
  DeviceExitPinVerifyResult,
  DeviceFeaturesUpdate,
  DeviceInfo,
  DeviceInput,
  DeviceInventoryItem,
  DeviceInventoryList,
  DeviceInventoryUpdate,
  DeviceList,
  DeviceMediaItem,
  DeviceOrder,
  DeviceOrderList,
  DeviceOrderUpdate,
  DevicePlayback,
  DevicePolicyUpdate,
  DeviceSync,
  DeviceTimeResponse,
  DeviceUpdate,
  DeviceUptimeRow,
  ErrorResponse,
  ExtendTrialInput,
  ExtendTrialResult,
  ForbiddenResponse,
  GetDevicePlanParams,
  GetDeviceSyncParams,
  GetLocationSyncStatusParams,
  GetPlaysReportParams,
  GetRecentActivityParams,
  GetUptimeReportParams,
  HardwareCheckoutInput,
  HealthStatus,
  HostAdEarnings,
  IceServersResponse,
  InviteByToken,
  ListAdminFleetParams,
  ListAuditLogsParams,
  ListCalendarPresetsParams,
  ListCalendarPresetsResponse,
  ListCatalogueArtistsParams,
  ListCatalogueTracksParams,
  ListDeviceEventsParams,
  ListDeviceInventoryParams,
  ListDeviceOrdersParams,
  ListDevicesParams,
  ListLocationsParams,
  ListMediaAssetsParams,
  ListPlatformAuditParams,
  ListPlayLogsParams,
  ListPlaylistsParams,
  ListProspectsParams,
  ListProvisioningProfilesParams,
  ListSchedulesParams,
  ListTicketsParams,
  Location,
  LocationInput,
  LocationList,
  LocationSyncStatus,
  LocationUpdate,
  MarketplaceInventoryItem,
  MediaAsset,
  MediaAssetList,
  MediaAssetUpdate,
  MediaBulkActionInput,
  MediaBulkActionResult,
  MediaDownloadUrl,
  MediaUploadInput,
  MediaUploadTicket,
  Member,
  MemberAccess,
  MemberAccessInput,
  MemberGroupUpdate,
  MergePlaylistsInput,
  MintInventoryInput,
  MintInventoryResult,
  NotFoundResponse,
  OnboardingInput,
  OnboardingResult,
  OperableDevice,
  OperationalHandoffInput,
  OperationalHandoffResult,
  PaymentRequiredResponse,
  PayoutOnboardingResponse,
  PermissionGroup,
  PermissionGroupInput,
  PermissionGroupUpdate,
  PilotInvoiceInput,
  PilotInvoiceResult,
  PlatformAuditLogList,
  PlayLog,
  PlayReportRow,
  Playlist,
  PlaylistDetail,
  PlaylistInput,
  PlaylistItem,
  PlaylistItemInput,
  PlaylistItemUpdate,
  PlaylistReorderInput,
  PlaylistRulesPreview,
  PlaylistRulesPreviewInput,
  PlaylistUpdate,
  PreviewScheduleParams,
  PricingCatalog,
  PromoProgramList,
  Prospect,
  ProspectImportInput,
  ProspectImportResult,
  ProspectInput,
  ProspectList,
  ProspectUpdate,
  ProvisioningInviteResult,
  ProvisioningPreview,
  ProvisioningProfile,
  ProvisioningProfileInput,
  ProvisioningProfileList,
  ProvisioningProfileUpdate,
  QuickPlay,
  QuickPlayInput,
  RecentActivity,
  ResendInviteResult,
  ResolveDeviceMediaParams,
  ResolveScheduleParams,
  ResolvedPlan,
  Schedule,
  ScheduleInput,
  SchedulePreview,
  ScheduleUpdate,
  ScreenSession,
  ScreenSessionActivateByCodeInput,
  ScreenSessionActivateInput,
  ScreenSessionStatus,
  ServiceAccountKey,
  ServiceAccountKeyCreated,
  ServiceAccountKeyInput,
  ServiceUnavailableResponse,
  Session,
  SignageContent,
  SignageContentInput,
  SignageContentUpdate,
  SignageFeedResponse,
  StationBuildInput,
  StationBuildResult,
  SupportTicket,
  TicketComment,
  TicketCommentInput,
  TicketDetail,
  TicketInput,
  TicketUpdate,
  TooManyRequestsResponse,
  TtsAnnouncementInput,
  TtsDraftInput,
  TtsDraftResponse,
  TtsPresetList,
  TtsVoiceList,
  UnauthorizedResponse,
  Workspace,
  WorkspaceInput,
  WorkspaceInvite,
  WorkspacePayoutAccount,
  WorkspaceSummary,
  WorkspaceUpdate,
  WorkspaceUsage,
  WorkspaceWithRole
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetDeviceInfoUrl = () => {




  return `/api/device/me`
}

/**
 * @summary Identity of the authenticated device
 */
export const getDeviceInfo = async ( options?: RequestInit): Promise<DeviceInfo> => {

  return customFetch<DeviceInfo>(getGetDeviceInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDeviceInfoQueryKey = () => {
    return [
    `/api/device/me`
    ] as const;
    }


export const getGetDeviceInfoQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceInfo>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceInfo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceInfo>>> = ({ signal }) => getDeviceInfo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDeviceInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceInfo>>>
export type GetDeviceInfoQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse>


/**
 * @summary Identity of the authenticated device
 */

export function useGetDeviceInfo<TData = Awaited<ReturnType<typeof getDeviceInfo>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceInfo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDeviceInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDevicePlanUrl = (params?: GetDevicePlanParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/device/plan?${stringifiedParams}` : `/api/device/plan`
}

/**
 * @summary Resolved schedule plan (now/next per channel) for the device
 */
export const getDevicePlan = async (params?: GetDevicePlanParams, options?: RequestInit): Promise<ResolvedPlan> => {

  return customFetch<ResolvedPlan>(getGetDevicePlanUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDevicePlanQueryKey = (params?: GetDevicePlanParams,) => {
    return [
    `/api/device/plan`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDevicePlanQueryOptions = <TData = Awaited<ReturnType<typeof getDevicePlan>>, TError = ErrorType<BadRequestResponse | UnauthorizedResponse | NotFoundResponse>>(params?: GetDevicePlanParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDevicePlan>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDevicePlanQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevicePlan>>> = ({ signal }) => getDevicePlan(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevicePlan>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDevicePlanQueryResult = NonNullable<Awaited<ReturnType<typeof getDevicePlan>>>
export type GetDevicePlanQueryError = ErrorType<BadRequestResponse | UnauthorizedResponse | NotFoundResponse>


/**
 * @summary Resolved schedule plan (now/next per channel) for the device
 */

export function useGetDevicePlan<TData = Awaited<ReturnType<typeof getDevicePlan>>, TError = ErrorType<BadRequestResponse | UnauthorizedResponse | NotFoundResponse>>(
 params?: GetDevicePlanParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDevicePlan>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDevicePlanQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDeviceSyncUrl = (params?: GetDeviceSyncParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/device/sync?${stringifiedParams}` : `/api/device/sync`
}

/**
 * @summary Full offline sync payload (plan + referenced playlists + media URLs)
 */
export const getDeviceSync = async (params?: GetDeviceSyncParams, options?: RequestInit): Promise<DeviceSync> => {

  return customFetch<DeviceSync>(getGetDeviceSyncUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDeviceSyncQueryKey = (params?: GetDeviceSyncParams,) => {
    return [
    `/api/device/sync`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDeviceSyncQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceSync>>, TError = ErrorType<void | BadRequestResponse | UnauthorizedResponse | NotFoundResponse>>(params?: GetDeviceSyncParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceSync>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceSyncQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceSync>>> = ({ signal }) => getDeviceSync(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceSync>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDeviceSyncQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceSync>>>
export type GetDeviceSyncQueryError = ErrorType<void | BadRequestResponse | UnauthorizedResponse | NotFoundResponse>


/**
 * @summary Full offline sync payload (plan + referenced playlists + media URLs)
 */

export function useGetDeviceSync<TData = Awaited<ReturnType<typeof getDeviceSync>>, TError = ErrorType<void | BadRequestResponse | UnauthorizedResponse | NotFoundResponse>>(
 params?: GetDeviceSyncParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceSync>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDeviceSyncQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDeviceBroadcastIceServersUrl = () => {




  return `/api/device/broadcast/ice-servers`
}

/**
 * @summary ICE servers (STUN/TURN) for receiving a live broadcast
 */
export const getDeviceBroadcastIceServers = async ( options?: RequestInit): Promise<IceServersResponse> => {

  return customFetch<IceServersResponse>(getGetDeviceBroadcastIceServersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDeviceBroadcastIceServersQueryKey = () => {
    return [
    `/api/device/broadcast/ice-servers`
    ] as const;
    }


export const getGetDeviceBroadcastIceServersQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceBroadcastIceServers>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceBroadcastIceServers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceBroadcastIceServersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceBroadcastIceServers>>> = ({ signal }) => getDeviceBroadcastIceServers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceBroadcastIceServers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDeviceBroadcastIceServersQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceBroadcastIceServers>>>
export type GetDeviceBroadcastIceServersQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary ICE servers (STUN/TURN) for receiving a live broadcast
 */

export function useGetDeviceBroadcastIceServers<TData = Awaited<ReturnType<typeof getDeviceBroadcastIceServers>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceBroadcastIceServers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDeviceBroadcastIceServersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDeviceSignageFeedUrl = (signageContentId: string,) => {




  return `/api/device/signage-feed/${signageContentId}`
}

/**
 * Server-side feed proxy for the news widget — browsers cannot fetch arbitrary RSS feeds cross-origin. The feed URL is read from the stored signage row (workspace-scoped, never a request parameter) and the parsed result is cached in-process for ~5 minutes.

 * @summary Cached RSS/Atom items for a news signage widget on this device
 */
export const getDeviceSignageFeed = async (signageContentId: string, options?: RequestInit): Promise<SignageFeedResponse> => {

  return customFetch<SignageFeedResponse>(getGetDeviceSignageFeedUrl(signageContentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDeviceSignageFeedQueryKey = (signageContentId: string,) => {
    return [
    `/api/device/signage-feed/${signageContentId}`
    ] as const;
    }


export const getGetDeviceSignageFeedQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceSignageFeed>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | void>>(signageContentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceSignageFeed>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceSignageFeedQueryKey(signageContentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceSignageFeed>>> = ({ signal }) => getDeviceSignageFeed(signageContentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(signageContentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceSignageFeed>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDeviceSignageFeedQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceSignageFeed>>>
export type GetDeviceSignageFeedQueryError = ErrorType<UnauthorizedResponse | NotFoundResponse | void>


/**
 * @summary Cached RSS/Atom items for a news signage widget on this device
 */

export function useGetDeviceSignageFeed<TData = Awaited<ReturnType<typeof getDeviceSignageFeed>>, TError = ErrorType<UnauthorizedResponse | NotFoundResponse | void>>(
 signageContentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceSignageFeed>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDeviceSignageFeedQueryOptions(signageContentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSignOutDeviceUrl = () => {




  return `/api/device/signout`
}

/**
 * @summary Revoke the current screen credential (sign this screen out)
 */
export const signOutDevice = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getSignOutDeviceUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSignOutDeviceMutationOptions = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOutDevice>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof signOutDevice>>, TError,void, TContext> => {

const mutationKey = ['signOutDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signOutDevice>>, void> = () => {


          return  signOutDevice(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignOutDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof signOutDevice>>>

    export type SignOutDeviceMutationError = ErrorType<UnauthorizedResponse>

    /**
 * @summary Revoke the current screen credential (sign this screen out)
 */
export const useSignOutDevice = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOutDevice>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof signOutDevice>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSignOutDeviceMutationOptions(options));
    }

export const getVerifyDeviceExitPinUrl = () => {




  return `/api/device/verify-exit-pin`
}

/**
 * @summary Verify the kiosk exit PIN for this screen
 */
export const verifyDeviceExitPin = async (deviceExitPinVerify: DeviceExitPinVerify, options?: RequestInit): Promise<DeviceExitPinVerifyResult> => {

  return customFetch<DeviceExitPinVerifyResult>(getVerifyDeviceExitPinUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceExitPinVerify,)
  }
);}




export const getVerifyDeviceExitPinMutationOptions = <TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyDeviceExitPin>>, TError,{data: BodyType<DeviceExitPinVerify>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyDeviceExitPin>>, TError,{data: BodyType<DeviceExitPinVerify>}, TContext> => {

const mutationKey = ['verifyDeviceExitPin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyDeviceExitPin>>, {data: BodyType<DeviceExitPinVerify>}> = (props) => {
          const {data} = props ?? {};

          return  verifyDeviceExitPin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyDeviceExitPinMutationResult = NonNullable<Awaited<ReturnType<typeof verifyDeviceExitPin>>>
    export type VerifyDeviceExitPinMutationBody = BodyType<DeviceExitPinVerify>
    export type VerifyDeviceExitPinMutationError = ErrorType<BadRequestResponse | UnauthorizedResponse>

    /**
 * @summary Verify the kiosk exit PIN for this screen
 */
export const useVerifyDeviceExitPin = <TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyDeviceExitPin>>, TError,{data: BodyType<DeviceExitPinVerify>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyDeviceExitPin>>,
        TError,
        {data: BodyType<DeviceExitPinVerify>},
        TContext
      > => {
      return useMutation(getVerifyDeviceExitPinMutationOptions(options));
    }

export const getResolveDeviceMediaUrl = (params: ResolveDeviceMediaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/device/resolve-media?${stringifiedParams}` : `/api/device/resolve-media`
}

/**
 * @summary Refresh a single playable media URL (catalogue track or workspace asset)
 */
export const resolveDeviceMedia = async (params: ResolveDeviceMediaParams, options?: RequestInit): Promise<DeviceMediaItem> => {

  return customFetch<DeviceMediaItem>(getResolveDeviceMediaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getResolveDeviceMediaQueryKey = (params?: ResolveDeviceMediaParams,) => {
    return [
    `/api/device/resolve-media`, ...(params ? [params] : [])
    ] as const;
    }


export const getResolveDeviceMediaQueryOptions = <TData = Awaited<ReturnType<typeof resolveDeviceMedia>>, TError = ErrorType<BadRequestResponse | UnauthorizedResponse | NotFoundResponse>>(params: ResolveDeviceMediaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof resolveDeviceMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveDeviceMediaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveDeviceMedia>>> = ({ signal }) => resolveDeviceMedia(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolveDeviceMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type ResolveDeviceMediaQueryResult = NonNullable<Awaited<ReturnType<typeof resolveDeviceMedia>>>
export type ResolveDeviceMediaQueryError = ErrorType<BadRequestResponse | UnauthorizedResponse | NotFoundResponse>


/**
 * @summary Refresh a single playable media URL (catalogue track or workspace asset)
 */

export function useResolveDeviceMedia<TData = Awaited<ReturnType<typeof resolveDeviceMedia>>, TError = ErrorType<BadRequestResponse | UnauthorizedResponse | NotFoundResponse>>(
 params: ResolveDeviceMediaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof resolveDeviceMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getResolveDeviceMediaQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPostDeviceTelemetryBatchUrl = () => {




  return `/api/device/telemetry/batch`
}

/**
 * @summary Ingest buffered offline telemetry (play logs, now-playing, status)
 */
export const postDeviceTelemetryBatch = async (bufferedTelemetryBatch: BufferedTelemetryBatch, options?: RequestInit): Promise<BufferedTelemetryResult> => {

  return customFetch<BufferedTelemetryResult>(getPostDeviceTelemetryBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bufferedTelemetryBatch,)
  }
);}




export const getPostDeviceTelemetryBatchMutationOptions = <TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDeviceTelemetryBatch>>, TError,{data: BodyType<BufferedTelemetryBatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postDeviceTelemetryBatch>>, TError,{data: BodyType<BufferedTelemetryBatch>}, TContext> => {

const mutationKey = ['postDeviceTelemetryBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDeviceTelemetryBatch>>, {data: BodyType<BufferedTelemetryBatch>}> = (props) => {
          const {data} = props ?? {};

          return  postDeviceTelemetryBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostDeviceTelemetryBatchMutationResult = NonNullable<Awaited<ReturnType<typeof postDeviceTelemetryBatch>>>
    export type PostDeviceTelemetryBatchMutationBody = BodyType<BufferedTelemetryBatch>
    export type PostDeviceTelemetryBatchMutationError = ErrorType<BadRequestResponse | UnauthorizedResponse>

    /**
 * @summary Ingest buffered offline telemetry (play logs, now-playing, status)
 */
export const usePostDeviceTelemetryBatch = <TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDeviceTelemetryBatch>>, TError,{data: BodyType<BufferedTelemetryBatch>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postDeviceTelemetryBatch>>,
        TError,
        {data: BodyType<BufferedTelemetryBatch>},
        TContext
      > => {
      return useMutation(getPostDeviceTelemetryBatchMutationOptions(options));
    }

export const getCreateScreenSessionUrl = () => {




  return `/api/screen-sessions`
}

/**
 * @summary Create a QR phone-handoff session for a signed-out screen
 */
export const createScreenSession = async ( options?: RequestInit): Promise<ScreenSession> => {

  return customFetch<ScreenSession>(getCreateScreenSessionUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreateScreenSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScreenSession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createScreenSession>>, TError,void, TContext> => {

const mutationKey = ['createScreenSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScreenSession>>, void> = () => {


          return  createScreenSession(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScreenSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createScreenSession>>>

    export type CreateScreenSessionMutationError = ErrorType<unknown>

    /**
 * @summary Create a QR phone-handoff session for a signed-out screen
 */
export const useCreateScreenSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScreenSession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createScreenSession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateScreenSessionMutationOptions(options));
    }

export const getGetScreenSessionUrl = (sessionId: string,) => {




  return `/api/screen-sessions/${sessionId}`
}

/**
 * @summary Poll a screen session for activation and the minted credential
 */
export const getScreenSession = async (sessionId: string, options?: RequestInit): Promise<ScreenSessionStatus> => {

  return customFetch<ScreenSessionStatus>(getGetScreenSessionUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScreenSessionQueryKey = (sessionId: string,) => {
    return [
    `/api/screen-sessions/${sessionId}`
    ] as const;
    }


export const getGetScreenSessionQueryOptions = <TData = Awaited<ReturnType<typeof getScreenSession>>, TError = ErrorType<NotFoundResponse>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScreenSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScreenSessionQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScreenSession>>> = ({ signal }) => getScreenSession(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScreenSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetScreenSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getScreenSession>>>
export type GetScreenSessionQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Poll a screen session for activation and the minted credential
 */

export function useGetScreenSession<TData = Awaited<ReturnType<typeof getScreenSession>>, TError = ErrorType<NotFoundResponse>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScreenSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetScreenSessionQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetPublicPricingUrl = () => {




  return `/api/pricing`
}

/**
 * Returns live per-unit billing rates for the marketing site and cost estimator
 * @summary Public pricing rate card
 */
export const getPublicPricing = async ( options?: RequestInit): Promise<PricingCatalog> => {

  return customFetch<PricingCatalog>(getGetPublicPricingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicPricingQueryKey = () => {
    return [
    `/api/pricing`
    ] as const;
    }


export const getGetPublicPricingQueryOptions = <TData = Awaited<ReturnType<typeof getPublicPricing>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicPricing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicPricingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicPricing>>> = ({ signal }) => getPublicPricing({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicPricing>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicPricingQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicPricing>>>
export type GetPublicPricingQueryError = ErrorType<unknown>


/**
 * @summary Public pricing rate card
 */

export function useGetPublicPricing<TData = Awaited<ReturnType<typeof getPublicPricing>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicPricing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicPricingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDeviceTimeUrl = () => {




  return `/api/device/time`
}

/**
 * Public and DB-free by design: player devices burst-sample this endpoint to estimate their round-trip clock offset against the server before following the segment timeline. Requiring auth here would add the exact latency noise the estimator removes.
 * @summary Server clock for multi-room sync clock-offset sampling
 */
export const getDeviceTime = async ( options?: RequestInit): Promise<DeviceTimeResponse> => {

  return customFetch<DeviceTimeResponse>(getGetDeviceTimeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDeviceTimeQueryKey = () => {
    return [
    `/api/device/time`
    ] as const;
    }


export const getGetDeviceTimeQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceTime>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceTime>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceTimeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceTime>>> = ({ signal }) => getDeviceTime({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceTime>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDeviceTimeQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceTime>>>
export type GetDeviceTimeQueryError = ErrorType<unknown>


/**
 * @summary Server clock for multi-room sync clock-offset sampling
 */

export function useGetDeviceTime<TData = Awaited<ReturnType<typeof getDeviceTime>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceTime>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDeviceTimeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetSessionUrl = () => {




  return `/api/me`
}

/**
 * @summary Get the current authenticated user and their workspaces
 */
export const getSession = async ( options?: RequestInit): Promise<Session> => {

  return customFetch<Session>(getGetSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSessionQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetSessionQueryOptions = <TData = Awaited<ReturnType<typeof getSession>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({ signal }) => getSession({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getSession>>>
export type GetSessionQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Get the current authenticated user and their workspaces
 */

export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSessionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDeleteAccountUrl = () => {




  return `/api/me`
}

/**
 * @summary Permanently delete the current user account
 */
export const deleteAccount = async ( options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAccountUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAccountMutationOptions = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext> => {

const mutationKey = ['deleteAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, void> = () => {


          return  deleteAccount(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>

    export type DeleteAccountMutationError = ErrorType<UnauthorizedResponse>

    /**
 * @summary Permanently delete the current user account
 */
export const useDeleteAccount = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteAccountMutationOptions(options));
    }

export const getGetInviteByTokenUrl = (token: string,) => {




  return `/api/invites/token/${token}`
}

/**
 * @summary Preview a workspace invite by token
 */
export const getInviteByToken = async (token: string, options?: RequestInit): Promise<InviteByToken> => {

  return customFetch<InviteByToken>(getGetInviteByTokenUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInviteByTokenQueryKey = (token: string,) => {
    return [
    `/api/invites/token/${token}`
    ] as const;
    }


export const getGetInviteByTokenQueryOptions = <TData = Awaited<ReturnType<typeof getInviteByToken>>, TError = ErrorType<NotFoundResponse>>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInviteByToken>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInviteByTokenQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInviteByToken>>> = ({ signal }) => getInviteByToken(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInviteByToken>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInviteByTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getInviteByToken>>>
export type GetInviteByTokenQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Preview a workspace invite by token
 */

export function useGetInviteByToken<TData = Awaited<ReturnType<typeof getInviteByToken>>, TError = ErrorType<NotFoundResponse>>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInviteByToken>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInviteByTokenQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAcceptInviteByTokenUrl = (token: string,) => {




  return `/api/invites/token/${token}`
}

/**
 * @summary Explicitly accept a workspace invite
 */
export const acceptInviteByToken = async (token: string, options?: RequestInit): Promise<AcceptInviteResult> => {

  return customFetch<AcceptInviteResult>(getAcceptInviteByTokenUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAcceptInviteByTokenMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInviteByToken>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInviteByToken>>, TError,{token: string}, TContext> => {

const mutationKey = ['acceptInviteByToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInviteByToken>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  acceptInviteByToken(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInviteByTokenMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInviteByToken>>>

    export type AcceptInviteByTokenMutationError = ErrorType<ForbiddenResponse | NotFoundResponse | ErrorResponse>

    /**
 * @summary Explicitly accept a workspace invite
 */
export const useAcceptInviteByToken = <TError = ErrorType<ForbiddenResponse | NotFoundResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInviteByToken>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptInviteByToken>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getAcceptInviteByTokenMutationOptions(options));
    }

export const getListWorkspacesUrl = () => {




  return `/api/workspaces`
}

/**
 * @summary List workspaces the current user belongs to
 */
export const listWorkspaces = async ( options?: RequestInit): Promise<WorkspaceWithRole[]> => {

  return customFetch<WorkspaceWithRole[]>(getListWorkspacesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWorkspacesQueryKey = () => {
    return [
    `/api/workspaces`
    ] as const;
    }


export const getListWorkspacesQueryOptions = <TData = Awaited<ReturnType<typeof listWorkspaces>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkspacesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkspaces>>> = ({ signal }) => listWorkspaces({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWorkspacesQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkspaces>>>
export type ListWorkspacesQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary List workspaces the current user belongs to
 */

export function useListWorkspaces<TData = Awaited<ReturnType<typeof listWorkspaces>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWorkspacesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateWorkspaceUrl = () => {




  return `/api/workspaces`
}

/**
 * @summary Create a workspace
 */
export const createWorkspace = async (workspaceInput: WorkspaceInput, options?: RequestInit): Promise<Workspace> => {

  return customFetch<Workspace>(getCreateWorkspaceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      workspaceInput,)
  }
);}




export const getCreateWorkspaceMutationOptions = <TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{data: BodyType<WorkspaceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{data: BodyType<WorkspaceInput>}, TContext> => {

const mutationKey = ['createWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkspace>>, {data: BodyType<WorkspaceInput>}> = (props) => {
          const {data} = props ?? {};

          return  createWorkspace(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkspace>>>
    export type CreateWorkspaceMutationBody = BodyType<WorkspaceInput>
    export type CreateWorkspaceMutationError = ErrorType<BadRequestResponse | UnauthorizedResponse>

    /**
 * @summary Create a workspace
 */
export const useCreateWorkspace = <TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{data: BodyType<WorkspaceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWorkspace>>,
        TError,
        {data: BodyType<WorkspaceInput>},
        TContext
      > => {
      return useMutation(getCreateWorkspaceMutationOptions(options));
    }

export const getGetWorkspaceUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}`
}

/**
 * @summary Get a workspace
 */
export const getWorkspace = async (workspaceId: string, options?: RequestInit): Promise<Workspace> => {

  return customFetch<Workspace>(getGetWorkspaceUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkspaceQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}`
    ] as const;
    }


export const getGetWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspace>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspace>>> = ({ signal }) => getWorkspace(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspace>>>
export type GetWorkspaceQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get a workspace
 */

export function useGetWorkspace<TData = Awaited<ReturnType<typeof getWorkspace>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWorkspaceQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateWorkspaceUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}`
}

/**
 * @summary Update a workspace
 */
export const updateWorkspace = async (workspaceId: string,
    workspaceUpdate: WorkspaceUpdate, options?: RequestInit): Promise<Workspace> => {

  return customFetch<Workspace>(getUpdateWorkspaceUrl(workspaceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      workspaceUpdate,)
  }
);}




export const getUpdateWorkspaceMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkspace>>, TError,{workspaceId: string;data: BodyType<WorkspaceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkspace>>, TError,{workspaceId: string;data: BodyType<WorkspaceUpdate>}, TContext> => {

const mutationKey = ['updateWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkspace>>, {workspaceId: string;data: BodyType<WorkspaceUpdate>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  updateWorkspace(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkspace>>>
    export type UpdateWorkspaceMutationBody = BodyType<WorkspaceUpdate>
    export type UpdateWorkspaceMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a workspace
 */
export const useUpdateWorkspace = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkspace>>, TError,{workspaceId: string;data: BodyType<WorkspaceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkspace>>,
        TError,
        {workspaceId: string;data: BodyType<WorkspaceUpdate>},
        TContext
      > => {
      return useMutation(getUpdateWorkspaceMutationOptions(options));
    }

export const getDeleteWorkspaceUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}`
}

/**
 * @summary Permanently delete a workspace
 */
export const deleteWorkspace = async (workspaceId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteWorkspaceUrl(workspaceId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteWorkspaceMutationOptions = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspace>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspace>>, TError,{workspaceId: string}, TContext> => {

const mutationKey = ['deleteWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkspace>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  deleteWorkspace(workspaceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkspace>>>

    export type DeleteWorkspaceMutationError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Permanently delete a workspace
 */
export const useDeleteWorkspace = <TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspace>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkspace>>,
        TError,
        {workspaceId: string},
        TContext
      > => {
      return useMutation(getDeleteWorkspaceMutationOptions(options));
    }

export const getCreateWorkspaceLogoUploadUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/branding/logo`
}

/**
 * @summary Create a presigned upload ticket for the workspace logo
 */
export const createWorkspaceLogoUpload = async (workspaceId: string,
    brandingUploadInput: BrandingUploadInput, options?: RequestInit): Promise<BrandingUploadTicket> => {

  return customFetch<BrandingUploadTicket>(getCreateWorkspaceLogoUploadUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      brandingUploadInput,)
  }
);}




export const getCreateWorkspaceLogoUploadMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspaceLogoUpload>>, TError,{workspaceId: string;data: BodyType<BrandingUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkspaceLogoUpload>>, TError,{workspaceId: string;data: BodyType<BrandingUploadInput>}, TContext> => {

const mutationKey = ['createWorkspaceLogoUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkspaceLogoUpload>>, {workspaceId: string;data: BodyType<BrandingUploadInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createWorkspaceLogoUpload(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkspaceLogoUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkspaceLogoUpload>>>
    export type CreateWorkspaceLogoUploadMutationBody = BodyType<BrandingUploadInput>
    export type CreateWorkspaceLogoUploadMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>

    /**
 * @summary Create a presigned upload ticket for the workspace logo
 */
export const useCreateWorkspaceLogoUpload = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspaceLogoUpload>>, TError,{workspaceId: string;data: BodyType<BrandingUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWorkspaceLogoUpload>>,
        TError,
        {workspaceId: string;data: BodyType<BrandingUploadInput>},
        TContext
      > => {
      return useMutation(getCreateWorkspaceLogoUploadMutationOptions(options));
    }

export const getDeleteWorkspaceLogoUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/branding/logo`
}

/**
 * @summary Remove the workspace logo
 */
export const deleteWorkspaceLogo = async (workspaceId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteWorkspaceLogoUrl(workspaceId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteWorkspaceLogoMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceLogo>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceLogo>>, TError,{workspaceId: string}, TContext> => {

const mutationKey = ['deleteWorkspaceLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkspaceLogo>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  deleteWorkspaceLogo(workspaceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkspaceLogoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkspaceLogo>>>

    export type DeleteWorkspaceLogoMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Remove the workspace logo
 */
export const useDeleteWorkspaceLogo = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceLogo>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkspaceLogo>>,
        TError,
        {workspaceId: string},
        TContext
      > => {
      return useMutation(getDeleteWorkspaceLogoMutationOptions(options));
    }

export const getCreateWorkspaceIconUploadUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/branding/icon`
}

/**
 * @summary Create a presigned upload ticket for the workspace icon
 */
export const createWorkspaceIconUpload = async (workspaceId: string,
    brandingUploadInput: BrandingUploadInput, options?: RequestInit): Promise<BrandingUploadTicket> => {

  return customFetch<BrandingUploadTicket>(getCreateWorkspaceIconUploadUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      brandingUploadInput,)
  }
);}




export const getCreateWorkspaceIconUploadMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspaceIconUpload>>, TError,{workspaceId: string;data: BodyType<BrandingUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkspaceIconUpload>>, TError,{workspaceId: string;data: BodyType<BrandingUploadInput>}, TContext> => {

const mutationKey = ['createWorkspaceIconUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkspaceIconUpload>>, {workspaceId: string;data: BodyType<BrandingUploadInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createWorkspaceIconUpload(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkspaceIconUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkspaceIconUpload>>>
    export type CreateWorkspaceIconUploadMutationBody = BodyType<BrandingUploadInput>
    export type CreateWorkspaceIconUploadMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>

    /**
 * @summary Create a presigned upload ticket for the workspace icon
 */
export const useCreateWorkspaceIconUpload = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspaceIconUpload>>, TError,{workspaceId: string;data: BodyType<BrandingUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWorkspaceIconUpload>>,
        TError,
        {workspaceId: string;data: BodyType<BrandingUploadInput>},
        TContext
      > => {
      return useMutation(getCreateWorkspaceIconUploadMutationOptions(options));
    }

export const getDeleteWorkspaceIconUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/branding/icon`
}

/**
 * @summary Remove the workspace icon
 */
export const deleteWorkspaceIcon = async (workspaceId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteWorkspaceIconUrl(workspaceId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteWorkspaceIconMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceIcon>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceIcon>>, TError,{workspaceId: string}, TContext> => {

const mutationKey = ['deleteWorkspaceIcon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkspaceIcon>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  deleteWorkspaceIcon(workspaceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkspaceIconMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkspaceIcon>>>

    export type DeleteWorkspaceIconMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Remove the workspace icon
 */
export const useDeleteWorkspaceIcon = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspaceIcon>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkspaceIcon>>,
        TError,
        {workspaceId: string},
        TContext
      > => {
      return useMutation(getDeleteWorkspaceIconMutationOptions(options));
    }

export const getGetWorkspaceLogoUrlUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/branding/logo-url`
}

/**
 * @summary Get a presigned download URL for the workspace logo
 */
export const getWorkspaceLogoUrl = async (workspaceId: string, options?: RequestInit): Promise<BrandingAssetUrl> => {

  return customFetch<BrandingAssetUrl>(getGetWorkspaceLogoUrlUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkspaceLogoUrlQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/branding/logo-url`
    ] as const;
    }


export const getGetWorkspaceLogoUrlQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceLogoUrl>>, TError = ErrorType<NotFoundResponse | ServiceUnavailableResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceLogoUrl>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceLogoUrlQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceLogoUrl>>> = ({ signal }) => getWorkspaceLogoUrl(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceLogoUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkspaceLogoUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceLogoUrl>>>
export type GetWorkspaceLogoUrlQueryError = ErrorType<NotFoundResponse | ServiceUnavailableResponse>


/**
 * @summary Get a presigned download URL for the workspace logo
 */

export function useGetWorkspaceLogoUrl<TData = Awaited<ReturnType<typeof getWorkspaceLogoUrl>>, TError = ErrorType<NotFoundResponse | ServiceUnavailableResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceLogoUrl>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWorkspaceLogoUrlQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetWorkspaceIconUrlUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/branding/icon-url`
}

/**
 * @summary Get a presigned download URL for the workspace icon
 */
export const getWorkspaceIconUrl = async (workspaceId: string, options?: RequestInit): Promise<BrandingAssetUrl> => {

  return customFetch<BrandingAssetUrl>(getGetWorkspaceIconUrlUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkspaceIconUrlQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/branding/icon-url`
    ] as const;
    }


export const getGetWorkspaceIconUrlQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceIconUrl>>, TError = ErrorType<NotFoundResponse | ServiceUnavailableResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceIconUrl>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceIconUrlQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceIconUrl>>> = ({ signal }) => getWorkspaceIconUrl(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceIconUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkspaceIconUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceIconUrl>>>
export type GetWorkspaceIconUrlQueryError = ErrorType<NotFoundResponse | ServiceUnavailableResponse>


/**
 * @summary Get a presigned download URL for the workspace icon
 */

export function useGetWorkspaceIconUrl<TData = Awaited<ReturnType<typeof getWorkspaceIconUrl>>, TError = ErrorType<NotFoundResponse | ServiceUnavailableResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceIconUrl>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWorkspaceIconUrlQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetWorkspaceSummaryUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/summary`
}

/**
 * @summary Get a high-level summary of a workspace
 */
export const getWorkspaceSummary = async (workspaceId: string, options?: RequestInit): Promise<WorkspaceSummary> => {

  return customFetch<WorkspaceSummary>(getGetWorkspaceSummaryUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkspaceSummaryQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/summary`
    ] as const;
    }


export const getGetWorkspaceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceSummary>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceSummaryQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceSummary>>> = ({ signal }) => getWorkspaceSummary(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkspaceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceSummary>>>
export type GetWorkspaceSummaryQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get a high-level summary of a workspace
 */

export function useGetWorkspaceSummary<TData = Awaited<ReturnType<typeof getWorkspaceSummary>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWorkspaceSummaryQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetRecentActivityUrl = (workspaceId: string,
    params?: GetRecentActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/activity?${stringifiedParams}` : `/api/workspaces/${workspaceId}/activity`
}

/**
 * @summary Get a recent activity feed for a workspace
 */
export const getRecentActivity = async (workspaceId: string,
    params?: GetRecentActivityParams, options?: RequestInit): Promise<RecentActivity> => {

  return customFetch<RecentActivity>(getGetRecentActivityUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRecentActivityQueryKey = (workspaceId: string,
    params?: GetRecentActivityParams,) => {
    return [
    `/api/workspaces/${workspaceId}/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRecentActivityQueryOptions = <TData = Awaited<ReturnType<typeof getRecentActivity>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    params?: GetRecentActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecentActivityQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentActivity>>> = ({ signal }) => getRecentActivity(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecentActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRecentActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getRecentActivity>>>
export type GetRecentActivityQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get a recent activity feed for a workspace
 */

export function useGetRecentActivity<TData = Awaited<ReturnType<typeof getRecentActivity>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    params?: GetRecentActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRecentActivityQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMembersUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/members`
}

/**
 * @summary List workspace members
 */
export const listMembers = async (workspaceId: string, options?: RequestInit): Promise<Member[]> => {

  return customFetch<Member[]>(getListMembersUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMembersQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/members`
    ] as const;
    }


export const getListMembersQueryOptions = <TData = Awaited<ReturnType<typeof listMembers>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMembersQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMembers>>> = ({ signal }) => listMembers(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listMembers>>>
export type ListMembersQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List workspace members
 */

export function useListMembers<TData = Awaited<ReturnType<typeof listMembers>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMembersQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAddMemberUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/members`
}

/**
 * @summary Add an existing user to the workspace by email
 */
export const addMember = async (workspaceId: string,
    addMemberInput: AddMemberInput, options?: RequestInit): Promise<Member> => {

  return customFetch<Member>(getAddMemberUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addMemberInput,)
  }
);}




export const getAddMemberMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addMember>>, TError,{workspaceId: string;data: BodyType<AddMemberInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addMember>>, TError,{workspaceId: string;data: BodyType<AddMemberInput>}, TContext> => {

const mutationKey = ['addMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addMember>>, {workspaceId: string;data: BodyType<AddMemberInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  addMember(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddMemberMutationResult = NonNullable<Awaited<ReturnType<typeof addMember>>>
    export type AddMemberMutationBody = BodyType<AddMemberInput>
    export type AddMemberMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse>

    /**
 * @summary Add an existing user to the workspace by email
 */
export const useAddMember = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addMember>>, TError,{workspaceId: string;data: BodyType<AddMemberInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addMember>>,
        TError,
        {workspaceId: string;data: BodyType<AddMemberInput>},
        TContext
      > => {
      return useMutation(getAddMemberMutationOptions(options));
    }

export const getListInvitesUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/invites`
}

/**
 * @summary List pending workspace invites
 */
export const listInvites = async (workspaceId: string, options?: RequestInit): Promise<WorkspaceInvite[]> => {

  return customFetch<WorkspaceInvite[]>(getListInvitesUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvitesQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/invites`
    ] as const;
    }


export const getListInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listInvites>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvitesQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvites>>> = ({ signal }) => listInvites(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listInvites>>>
export type ListInvitesQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List pending workspace invites
 */

export function useListInvites<TData = Awaited<ReturnType<typeof listInvites>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInvitesQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateInviteUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/invites`
}

/**
 * @summary Invite a user to the workspace by email
 */
export const createInvite = async (workspaceId: string,
    createInviteInput: CreateInviteInput, options?: RequestInit): Promise<WorkspaceInvite> => {

  return customFetch<WorkspaceInvite>(getCreateInviteUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createInviteInput,)
  }
);}




export const getCreateInviteMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvite>>, TError,{workspaceId: string;data: BodyType<CreateInviteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvite>>, TError,{workspaceId: string;data: BodyType<CreateInviteInput>}, TContext> => {

const mutationKey = ['createInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvite>>, {workspaceId: string;data: BodyType<CreateInviteInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createInvite(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createInvite>>>
    export type CreateInviteMutationBody = BodyType<CreateInviteInput>
    export type CreateInviteMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | ErrorResponse>

    /**
 * @summary Invite a user to the workspace by email
 */
export const useCreateInvite = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvite>>, TError,{workspaceId: string;data: BodyType<CreateInviteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInvite>>,
        TError,
        {workspaceId: string;data: BodyType<CreateInviteInput>},
        TContext
      > => {
      return useMutation(getCreateInviteMutationOptions(options));
    }

export const getRevokeInviteUrl = (workspaceId: string,
    inviteId: string,) => {




  return `/api/workspaces/${workspaceId}/invites/${inviteId}`
}

/**
 * @summary Revoke a pending workspace invite
 */
export const revokeInvite = async (workspaceId: string,
    inviteId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRevokeInviteUrl(workspaceId,inviteId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRevokeInviteMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeInvite>>, TError,{workspaceId: string;inviteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeInvite>>, TError,{workspaceId: string;inviteId: string}, TContext> => {

const mutationKey = ['revokeInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeInvite>>, {workspaceId: string;inviteId: string}> = (props) => {
          const {workspaceId,inviteId} = props ?? {};

          return  revokeInvite(workspaceId,inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeInviteMutationResult = NonNullable<Awaited<ReturnType<typeof revokeInvite>>>

    export type RevokeInviteMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Revoke a pending workspace invite
 */
export const useRevokeInvite = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeInvite>>, TError,{workspaceId: string;inviteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeInvite>>,
        TError,
        {workspaceId: string;inviteId: string},
        TContext
      > => {
      return useMutation(getRevokeInviteMutationOptions(options));
    }

export const getResendInviteUrl = (workspaceId: string,
    inviteId: string,) => {




  return `/api/workspaces/${workspaceId}/invites/${inviteId}/resend`
}

/**
 * @summary Resend invite email with accept link
 */
export const resendInvite = async (workspaceId: string,
    inviteId: string, options?: RequestInit): Promise<ResendInviteResult> => {

  return customFetch<ResendInviteResult>(getResendInviteUrl(workspaceId,inviteId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResendInviteMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvite>>, TError,{workspaceId: string;inviteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendInvite>>, TError,{workspaceId: string;inviteId: string}, TContext> => {

const mutationKey = ['resendInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInvite>>, {workspaceId: string;inviteId: string}> = (props) => {
          const {workspaceId,inviteId} = props ?? {};

          return  resendInvite(workspaceId,inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendInviteMutationResult = NonNullable<Awaited<ReturnType<typeof resendInvite>>>

    export type ResendInviteMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Resend invite email with accept link
 */
export const useResendInvite = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvite>>, TError,{workspaceId: string;inviteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendInvite>>,
        TError,
        {workspaceId: string;inviteId: string},
        TContext
      > => {
      return useMutation(getResendInviteMutationOptions(options));
    }

export const getListPermissionGroupsUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/permission-groups`
}

/**
 * @summary List permission groups in the workspace
 */
export const listPermissionGroups = async (workspaceId: string, options?: RequestInit): Promise<PermissionGroup[]> => {

  return customFetch<PermissionGroup[]>(getListPermissionGroupsUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPermissionGroupsQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/permission-groups`
    ] as const;
    }


export const getListPermissionGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listPermissionGroups>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPermissionGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPermissionGroupsQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPermissionGroups>>> = ({ signal }) => listPermissionGroups(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPermissionGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPermissionGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listPermissionGroups>>>
export type ListPermissionGroupsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List permission groups in the workspace
 */

export function useListPermissionGroups<TData = Awaited<ReturnType<typeof listPermissionGroups>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPermissionGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPermissionGroupsQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePermissionGroupUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/permission-groups`
}

/**
 * @summary Create a permission group
 */
export const createPermissionGroup = async (workspaceId: string,
    permissionGroupInput: PermissionGroupInput, options?: RequestInit): Promise<PermissionGroup> => {

  return customFetch<PermissionGroup>(getCreatePermissionGroupUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      permissionGroupInput,)
  }
);}




export const getCreatePermissionGroupMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPermissionGroup>>, TError,{workspaceId: string;data: BodyType<PermissionGroupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPermissionGroup>>, TError,{workspaceId: string;data: BodyType<PermissionGroupInput>}, TContext> => {

const mutationKey = ['createPermissionGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPermissionGroup>>, {workspaceId: string;data: BodyType<PermissionGroupInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createPermissionGroup(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePermissionGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createPermissionGroup>>>
    export type CreatePermissionGroupMutationBody = BodyType<PermissionGroupInput>
    export type CreatePermissionGroupMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Create a permission group
 */
export const useCreatePermissionGroup = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPermissionGroup>>, TError,{workspaceId: string;data: BodyType<PermissionGroupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPermissionGroup>>,
        TError,
        {workspaceId: string;data: BodyType<PermissionGroupInput>},
        TContext
      > => {
      return useMutation(getCreatePermissionGroupMutationOptions(options));
    }

export const getUpdatePermissionGroupUrl = (workspaceId: string,
    groupId: string,) => {




  return `/api/workspaces/${workspaceId}/permission-groups/${groupId}`
}

/**
 * @summary Update a permission group
 */
export const updatePermissionGroup = async (workspaceId: string,
    groupId: string,
    permissionGroupUpdate: PermissionGroupUpdate, options?: RequestInit): Promise<PermissionGroup> => {

  return customFetch<PermissionGroup>(getUpdatePermissionGroupUrl(workspaceId,groupId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      permissionGroupUpdate,)
  }
);}




export const getUpdatePermissionGroupMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePermissionGroup>>, TError,{workspaceId: string;groupId: string;data: BodyType<PermissionGroupUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePermissionGroup>>, TError,{workspaceId: string;groupId: string;data: BodyType<PermissionGroupUpdate>}, TContext> => {

const mutationKey = ['updatePermissionGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePermissionGroup>>, {workspaceId: string;groupId: string;data: BodyType<PermissionGroupUpdate>}> = (props) => {
          const {workspaceId,groupId,data} = props ?? {};

          return  updatePermissionGroup(workspaceId,groupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePermissionGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updatePermissionGroup>>>
    export type UpdatePermissionGroupMutationBody = BodyType<PermissionGroupUpdate>
    export type UpdatePermissionGroupMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a permission group
 */
export const useUpdatePermissionGroup = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePermissionGroup>>, TError,{workspaceId: string;groupId: string;data: BodyType<PermissionGroupUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePermissionGroup>>,
        TError,
        {workspaceId: string;groupId: string;data: BodyType<PermissionGroupUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePermissionGroupMutationOptions(options));
    }

export const getDeletePermissionGroupUrl = (workspaceId: string,
    groupId: string,) => {




  return `/api/workspaces/${workspaceId}/permission-groups/${groupId}`
}

/**
 * @summary Delete a permission group
 */
export const deletePermissionGroup = async (workspaceId: string,
    groupId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePermissionGroupUrl(workspaceId,groupId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePermissionGroupMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePermissionGroup>>, TError,{workspaceId: string;groupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePermissionGroup>>, TError,{workspaceId: string;groupId: string}, TContext> => {

const mutationKey = ['deletePermissionGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePermissionGroup>>, {workspaceId: string;groupId: string}> = (props) => {
          const {workspaceId,groupId} = props ?? {};

          return  deletePermissionGroup(workspaceId,groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePermissionGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deletePermissionGroup>>>

    export type DeletePermissionGroupMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Delete a permission group
 */
export const useDeletePermissionGroup = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePermissionGroup>>, TError,{workspaceId: string;groupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePermissionGroup>>,
        TError,
        {workspaceId: string;groupId: string},
        TContext
      > => {
      return useMutation(getDeletePermissionGroupMutationOptions(options));
    }

export const getListServiceAccountKeysUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/service-account-keys`
}

/**
 * Returns service-account keys (never the plaintext token or hash). Used by headless clients (SDK/MCP/CLI/AI agents). Requires manage.settings.

 * @summary List machine API keys for the workspace
 */
export const listServiceAccountKeys = async (workspaceId: string, options?: RequestInit): Promise<ServiceAccountKey[]> => {

  return customFetch<ServiceAccountKey[]>(getListServiceAccountKeysUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListServiceAccountKeysQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/service-account-keys`
    ] as const;
    }


export const getListServiceAccountKeysQueryOptions = <TData = Awaited<ReturnType<typeof listServiceAccountKeys>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listServiceAccountKeys>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceAccountKeysQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceAccountKeys>>> = ({ signal }) => listServiceAccountKeys(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listServiceAccountKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type ListServiceAccountKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceAccountKeys>>>
export type ListServiceAccountKeysQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List machine API keys for the workspace
 */

export function useListServiceAccountKeys<TData = Awaited<ReturnType<typeof listServiceAccountKeys>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listServiceAccountKeys>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListServiceAccountKeysQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateServiceAccountKeyUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/service-account-keys`
}

/**
 * Creates a service-account key and returns the plaintext token EXACTLY ONCE. Minted capabilities must be a subset of the caller's own capabilities. Requires manage.settings.

 * @summary Mint a machine API key
 */
export const createServiceAccountKey = async (workspaceId: string,
    serviceAccountKeyInput: ServiceAccountKeyInput, options?: RequestInit): Promise<ServiceAccountKeyCreated> => {

  return customFetch<ServiceAccountKeyCreated>(getCreateServiceAccountKeyUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      serviceAccountKeyInput,)
  }
);}




export const getCreateServiceAccountKeyMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceAccountKey>>, TError,{workspaceId: string;data: BodyType<ServiceAccountKeyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createServiceAccountKey>>, TError,{workspaceId: string;data: BodyType<ServiceAccountKeyInput>}, TContext> => {

const mutationKey = ['createServiceAccountKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createServiceAccountKey>>, {workspaceId: string;data: BodyType<ServiceAccountKeyInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createServiceAccountKey(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateServiceAccountKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createServiceAccountKey>>>
    export type CreateServiceAccountKeyMutationBody = BodyType<ServiceAccountKeyInput>
    export type CreateServiceAccountKeyMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Mint a machine API key
 */
export const useCreateServiceAccountKey = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceAccountKey>>, TError,{workspaceId: string;data: BodyType<ServiceAccountKeyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createServiceAccountKey>>,
        TError,
        {workspaceId: string;data: BodyType<ServiceAccountKeyInput>},
        TContext
      > => {
      return useMutation(getCreateServiceAccountKeyMutationOptions(options));
    }

export const getRevokeServiceAccountKeyUrl = (workspaceId: string,
    keyId: string,) => {




  return `/api/workspaces/${workspaceId}/service-account-keys/${keyId}`
}

/**
 * Soft-revokes the key (sets revokedAt). Requires manage.settings.
 * @summary Revoke a machine API key
 */
export const revokeServiceAccountKey = async (workspaceId: string,
    keyId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRevokeServiceAccountKeyUrl(workspaceId,keyId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRevokeServiceAccountKeyMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeServiceAccountKey>>, TError,{workspaceId: string;keyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeServiceAccountKey>>, TError,{workspaceId: string;keyId: string}, TContext> => {

const mutationKey = ['revokeServiceAccountKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeServiceAccountKey>>, {workspaceId: string;keyId: string}> = (props) => {
          const {workspaceId,keyId} = props ?? {};

          return  revokeServiceAccountKey(workspaceId,keyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeServiceAccountKeyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeServiceAccountKey>>>

    export type RevokeServiceAccountKeyMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Revoke a machine API key
 */
export const useRevokeServiceAccountKey = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeServiceAccountKey>>, TError,{workspaceId: string;keyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeServiceAccountKey>>,
        TError,
        {workspaceId: string;keyId: string},
        TContext
      > => {
      return useMutation(getRevokeServiceAccountKeyMutationOptions(options));
    }

export const getHandoffOperationalPermissionsUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/members/handoff`
}

/**
 * @summary Transfer creator-level operational permissions to another member (billing unchanged)
 */
export const handoffOperationalPermissions = async (workspaceId: string,
    operationalHandoffInput: OperationalHandoffInput, options?: RequestInit): Promise<OperationalHandoffResult> => {

  return customFetch<OperationalHandoffResult>(getHandoffOperationalPermissionsUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      operationalHandoffInput,)
  }
);}




export const getHandoffOperationalPermissionsMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handoffOperationalPermissions>>, TError,{workspaceId: string;data: BodyType<OperationalHandoffInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof handoffOperationalPermissions>>, TError,{workspaceId: string;data: BodyType<OperationalHandoffInput>}, TContext> => {

const mutationKey = ['handoffOperationalPermissions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handoffOperationalPermissions>>, {workspaceId: string;data: BodyType<OperationalHandoffInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  handoffOperationalPermissions(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandoffOperationalPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof handoffOperationalPermissions>>>
    export type HandoffOperationalPermissionsMutationBody = BodyType<OperationalHandoffInput>
    export type HandoffOperationalPermissionsMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Transfer creator-level operational permissions to another member (billing unchanged)
 */
export const useHandoffOperationalPermissions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handoffOperationalPermissions>>, TError,{workspaceId: string;data: BodyType<OperationalHandoffInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof handoffOperationalPermissions>>,
        TError,
        {workspaceId: string;data: BodyType<OperationalHandoffInput>},
        TContext
      > => {
      return useMutation(getHandoffOperationalPermissionsMutationOptions(options));
    }

export const getUpdateMemberGroupUrl = (workspaceId: string,
    userId: string,) => {




  return `/api/workspaces/${workspaceId}/members/${userId}`
}

/**
 * @summary Update a member's permission group
 */
export const updateMemberGroup = async (workspaceId: string,
    userId: string,
    memberGroupUpdate: MemberGroupUpdate, options?: RequestInit): Promise<Member> => {

  return customFetch<Member>(getUpdateMemberGroupUrl(workspaceId,userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      memberGroupUpdate,)
  }
);}




export const getUpdateMemberGroupMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberGroup>>, TError,{workspaceId: string;userId: string;data: BodyType<MemberGroupUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMemberGroup>>, TError,{workspaceId: string;userId: string;data: BodyType<MemberGroupUpdate>}, TContext> => {

const mutationKey = ['updateMemberGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMemberGroup>>, {workspaceId: string;userId: string;data: BodyType<MemberGroupUpdate>}> = (props) => {
          const {workspaceId,userId,data} = props ?? {};

          return  updateMemberGroup(workspaceId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMemberGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateMemberGroup>>>
    export type UpdateMemberGroupMutationBody = BodyType<MemberGroupUpdate>
    export type UpdateMemberGroupMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a member's permission group
 */
export const useUpdateMemberGroup = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberGroup>>, TError,{workspaceId: string;userId: string;data: BodyType<MemberGroupUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMemberGroup>>,
        TError,
        {workspaceId: string;userId: string;data: BodyType<MemberGroupUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMemberGroupMutationOptions(options));
    }

export const getRemoveMemberUrl = (workspaceId: string,
    userId: string,) => {




  return `/api/workspaces/${workspaceId}/members/${userId}`
}

/**
 * @summary Remove a member from the workspace
 */
export const removeMember = async (workspaceId: string,
    userId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRemoveMemberUrl(workspaceId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveMemberMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeMember>>, TError,{workspaceId: string;userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeMember>>, TError,{workspaceId: string;userId: string}, TContext> => {

const mutationKey = ['removeMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeMember>>, {workspaceId: string;userId: string}> = (props) => {
          const {workspaceId,userId} = props ?? {};

          return  removeMember(workspaceId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeMember>>>

    export type RemoveMemberMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Remove a member from the workspace
 */
export const useRemoveMember = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeMember>>, TError,{workspaceId: string;userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeMember>>,
        TError,
        {workspaceId: string;userId: string},
        TContext
      > => {
      return useMutation(getRemoveMemberMutationOptions(options));
    }

export const getGetMemberAccessUrl = (workspaceId: string,
    userId: string,) => {




  return `/api/workspaces/${workspaceId}/members/${userId}/access`
}

/**
 * @summary Get a member's granular location/device access scope
 */
export const getMemberAccess = async (workspaceId: string,
    userId: string, options?: RequestInit): Promise<MemberAccess> => {

  return customFetch<MemberAccess>(getGetMemberAccessUrl(workspaceId,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMemberAccessQueryKey = (workspaceId: string,
    userId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/members/${userId}/access`
    ] as const;
    }


export const getGetMemberAccessQueryOptions = <TData = Awaited<ReturnType<typeof getMemberAccess>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMemberAccess>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberAccessQueryKey(workspaceId,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberAccess>>> = ({ signal }) => getMemberAccess(workspaceId,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberAccess>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMemberAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberAccess>>>
export type GetMemberAccessQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get a member's granular location/device access scope
 */

export function useGetMemberAccess<TData = Awaited<ReturnType<typeof getMemberAccess>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMemberAccess>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMemberAccessQueryOptions(workspaceId,userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSetMemberAccessUrl = (workspaceId: string,
    userId: string,) => {




  return `/api/workspaces/${workspaceId}/members/${userId}/access`
}

/**
 * @summary Replace a member's granular location/device access scope
 */
export const setMemberAccess = async (workspaceId: string,
    userId: string,
    memberAccessInput: MemberAccessInput, options?: RequestInit): Promise<MemberAccess> => {

  return customFetch<MemberAccess>(getSetMemberAccessUrl(workspaceId,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      memberAccessInput,)
  }
);}




export const getSetMemberAccessMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMemberAccess>>, TError,{workspaceId: string;userId: string;data: BodyType<MemberAccessInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setMemberAccess>>, TError,{workspaceId: string;userId: string;data: BodyType<MemberAccessInput>}, TContext> => {

const mutationKey = ['setMemberAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMemberAccess>>, {workspaceId: string;userId: string;data: BodyType<MemberAccessInput>}> = (props) => {
          const {workspaceId,userId,data} = props ?? {};

          return  setMemberAccess(workspaceId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetMemberAccessMutationResult = NonNullable<Awaited<ReturnType<typeof setMemberAccess>>>
    export type SetMemberAccessMutationBody = BodyType<MemberAccessInput>
    export type SetMemberAccessMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Replace a member's granular location/device access scope
 */
export const useSetMemberAccess = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMemberAccess>>, TError,{workspaceId: string;userId: string;data: BodyType<MemberAccessInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setMemberAccess>>,
        TError,
        {workspaceId: string;userId: string;data: BodyType<MemberAccessInput>},
        TContext
      > => {
      return useMutation(getSetMemberAccessMutationOptions(options));
    }

export const getListOperableDevicesUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/operable-devices`
}

/**
 * @summary Devices the current member is permitted to operate (player selection)
 */
export const listOperableDevices = async (workspaceId: string, options?: RequestInit): Promise<OperableDevice[]> => {

  return customFetch<OperableDevice[]>(getListOperableDevicesUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOperableDevicesQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/operable-devices`
    ] as const;
    }


export const getListOperableDevicesQueryOptions = <TData = Awaited<ReturnType<typeof listOperableDevices>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOperableDevices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOperableDevicesQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOperableDevices>>> = ({ signal }) => listOperableDevices(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOperableDevices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOperableDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof listOperableDevices>>>
export type ListOperableDevicesQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Devices the current member is permitted to operate (player selection)
 */

export function useListOperableDevices<TData = Awaited<ReturnType<typeof listOperableDevices>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOperableDevices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOperableDevicesQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getClaimDeviceUrl = (workspaceId: string,
    deviceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/${deviceId}/claim`
}

/**
 * @summary Mint a durable per-screen credential bound to this device
 */
export const claimDevice = async (workspaceId: string,
    deviceId: string,
    deviceClaimInput?: DeviceClaimInput, options?: RequestInit): Promise<DeviceCredentialResponse> => {

  return customFetch<DeviceCredentialResponse>(getClaimDeviceUrl(workspaceId,deviceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceClaimInput,)
  }
);}




export const getClaimDeviceMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimDevice>>, TError,{workspaceId: string;deviceId: string;data?: BodyType<DeviceClaimInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof claimDevice>>, TError,{workspaceId: string;deviceId: string;data?: BodyType<DeviceClaimInput>}, TContext> => {

const mutationKey = ['claimDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimDevice>>, {workspaceId: string;deviceId: string;data?: BodyType<DeviceClaimInput>}> = (props) => {
          const {workspaceId,deviceId,data} = props ?? {};

          return  claimDevice(workspaceId,deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClaimDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof claimDevice>>>
    export type ClaimDeviceMutationBody = BodyType<DeviceClaimInput> | undefined
    export type ClaimDeviceMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Mint a durable per-screen credential bound to this device
 */
export const useClaimDevice = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimDevice>>, TError,{workspaceId: string;deviceId: string;data?: BodyType<DeviceClaimInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof claimDevice>>,
        TError,
        {workspaceId: string;deviceId: string;data?: BodyType<DeviceClaimInput>},
        TContext
      > => {
      return useMutation(getClaimDeviceMutationOptions(options));
    }

export const getActivateScreenSessionUrl = (workspaceId: string,
    sessionId: string,) => {




  return `/api/workspaces/${workspaceId}/screen-sessions/${sessionId}/activate`
}

/**
 * @summary Activate a pending screen session by selecting a device (phone handoff)
 */
export const activateScreenSession = async (workspaceId: string,
    sessionId: string,
    screenSessionActivateInput: ScreenSessionActivateInput, options?: RequestInit): Promise<DeviceCredentialResponse> => {

  return customFetch<DeviceCredentialResponse>(getActivateScreenSessionUrl(workspaceId,sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      screenSessionActivateInput,)
  }
);}




export const getActivateScreenSessionMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateScreenSession>>, TError,{workspaceId: string;sessionId: string;data: BodyType<ScreenSessionActivateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activateScreenSession>>, TError,{workspaceId: string;sessionId: string;data: BodyType<ScreenSessionActivateInput>}, TContext> => {

const mutationKey = ['activateScreenSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateScreenSession>>, {workspaceId: string;sessionId: string;data: BodyType<ScreenSessionActivateInput>}> = (props) => {
          const {workspaceId,sessionId,data} = props ?? {};

          return  activateScreenSession(workspaceId,sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateScreenSessionMutationResult = NonNullable<Awaited<ReturnType<typeof activateScreenSession>>>
    export type ActivateScreenSessionMutationBody = BodyType<ScreenSessionActivateInput>
    export type ActivateScreenSessionMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Activate a pending screen session by selecting a device (phone handoff)
 */
export const useActivateScreenSession = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateScreenSession>>, TError,{workspaceId: string;sessionId: string;data: BodyType<ScreenSessionActivateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof activateScreenSession>>,
        TError,
        {workspaceId: string;sessionId: string;data: BodyType<ScreenSessionActivateInput>},
        TContext
      > => {
      return useMutation(getActivateScreenSessionMutationOptions(options));
    }

export const getActivateScreenSessionByCodeUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/screen-sessions/activate-by-code`
}

/**
 * @summary Activate a pending screen session by typing its short code (no scan)
 */
export const activateScreenSessionByCode = async (workspaceId: string,
    screenSessionActivateByCodeInput: ScreenSessionActivateByCodeInput, options?: RequestInit): Promise<DeviceCredentialResponse> => {

  return customFetch<DeviceCredentialResponse>(getActivateScreenSessionByCodeUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      screenSessionActivateByCodeInput,)
  }
);}




export const getActivateScreenSessionByCodeMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateScreenSessionByCode>>, TError,{workspaceId: string;data: BodyType<ScreenSessionActivateByCodeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activateScreenSessionByCode>>, TError,{workspaceId: string;data: BodyType<ScreenSessionActivateByCodeInput>}, TContext> => {

const mutationKey = ['activateScreenSessionByCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateScreenSessionByCode>>, {workspaceId: string;data: BodyType<ScreenSessionActivateByCodeInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  activateScreenSessionByCode(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateScreenSessionByCodeMutationResult = NonNullable<Awaited<ReturnType<typeof activateScreenSessionByCode>>>
    export type ActivateScreenSessionByCodeMutationBody = BodyType<ScreenSessionActivateByCodeInput>
    export type ActivateScreenSessionByCodeMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Activate a pending screen session by typing its short code (no scan)
 */
export const useActivateScreenSessionByCode = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateScreenSessionByCode>>, TError,{workspaceId: string;data: BodyType<ScreenSessionActivateByCodeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof activateScreenSessionByCode>>,
        TError,
        {workspaceId: string;data: BodyType<ScreenSessionActivateByCodeInput>},
        TContext
      > => {
      return useMutation(getActivateScreenSessionByCodeMutationOptions(options));
    }

export const getListLocationsUrl = (workspaceId: string,
    params?: ListLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/locations?${stringifiedParams}` : `/api/workspaces/${workspaceId}/locations`
}

/**
 * @summary List locations
 */
export const listLocations = async (workspaceId: string,
    params?: ListLocationsParams, options?: RequestInit): Promise<LocationList> => {

  return customFetch<LocationList>(getListLocationsUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLocationsQueryKey = (workspaceId: string,
    params?: ListLocationsParams,) => {
    return [
    `/api/workspaces/${workspaceId}/locations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLocationsQueryOptions = <TData = Awaited<ReturnType<typeof listLocations>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: ListLocationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLocationsQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLocations>>> = ({ signal }) => listLocations(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof listLocations>>>
export type ListLocationsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List locations
 */

export function useListLocations<TData = Awaited<ReturnType<typeof listLocations>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: ListLocationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLocations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLocationsQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateLocationUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/locations`
}

/**
 * @summary Create a location
 */
export const createLocation = async (workspaceId: string,
    locationInput: LocationInput, options?: RequestInit): Promise<Location> => {

  return customFetch<Location>(getCreateLocationUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      locationInput,)
  }
);}




export const getCreateLocationMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{workspaceId: string;data: BodyType<LocationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{workspaceId: string;data: BodyType<LocationInput>}, TContext> => {

const mutationKey = ['createLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLocation>>, {workspaceId: string;data: BodyType<LocationInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createLocation(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof createLocation>>>
    export type CreateLocationMutationBody = BodyType<LocationInput>
    export type CreateLocationMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Create a location
 */
export const useCreateLocation = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{workspaceId: string;data: BodyType<LocationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLocation>>,
        TError,
        {workspaceId: string;data: BodyType<LocationInput>},
        TContext
      > => {
      return useMutation(getCreateLocationMutationOptions(options));
    }

export const getGetLocationUrl = (workspaceId: string,
    locationId: string,) => {




  return `/api/workspaces/${workspaceId}/locations/${locationId}`
}

/**
 * @summary Get a location
 */
export const getLocation = async (workspaceId: string,
    locationId: string, options?: RequestInit): Promise<Location> => {

  return customFetch<Location>(getGetLocationUrl(workspaceId,locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLocationQueryKey = (workspaceId: string,
    locationId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/locations/${locationId}`
    ] as const;
    }


export const getGetLocationQueryOptions = <TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    locationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationQueryKey(workspaceId,locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocation>>> = ({ signal }) => getLocation(workspaceId,locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && locationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getLocation>>>
export type GetLocationQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get a location
 */

export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    locationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLocationQueryOptions(workspaceId,locationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateLocationUrl = (workspaceId: string,
    locationId: string,) => {




  return `/api/workspaces/${workspaceId}/locations/${locationId}`
}

/**
 * @summary Update a location
 */
export const updateLocation = async (workspaceId: string,
    locationId: string,
    locationUpdate: LocationUpdate, options?: RequestInit): Promise<Location> => {

  return customFetch<Location>(getUpdateLocationUrl(workspaceId,locationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      locationUpdate,)
  }
);}




export const getUpdateLocationMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{workspaceId: string;locationId: string;data: BodyType<LocationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{workspaceId: string;locationId: string;data: BodyType<LocationUpdate>}, TContext> => {

const mutationKey = ['updateLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocation>>, {workspaceId: string;locationId: string;data: BodyType<LocationUpdate>}> = (props) => {
          const {workspaceId,locationId,data} = props ?? {};

          return  updateLocation(workspaceId,locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocation>>>
    export type UpdateLocationMutationBody = BodyType<LocationUpdate>
    export type UpdateLocationMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a location
 */
export const useUpdateLocation = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{workspaceId: string;locationId: string;data: BodyType<LocationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLocation>>,
        TError,
        {workspaceId: string;locationId: string;data: BodyType<LocationUpdate>},
        TContext
      > => {
      return useMutation(getUpdateLocationMutationOptions(options));
    }

export const getDeleteLocationUrl = (workspaceId: string,
    locationId: string,) => {




  return `/api/workspaces/${workspaceId}/locations/${locationId}`
}

/**
 * @summary Delete a location
 */
export const deleteLocation = async (workspaceId: string,
    locationId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLocationUrl(workspaceId,locationId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLocationMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{workspaceId: string;locationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{workspaceId: string;locationId: string}, TContext> => {

const mutationKey = ['deleteLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLocation>>, {workspaceId: string;locationId: string}> = (props) => {
          const {workspaceId,locationId} = props ?? {};

          return  deleteLocation(workspaceId,locationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLocationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLocation>>>

    export type DeleteLocationMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Delete a location
 */
export const useDeleteLocation = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{workspaceId: string;locationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLocation>>,
        TError,
        {workspaceId: string;locationId: string},
        TContext
      > => {
      return useMutation(getDeleteLocationMutationOptions(options));
    }

export const getGetLocationSyncStatusUrl = (workspaceId: string,
    locationId: string,
    params?: GetLocationSyncStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/locations/${locationId}/sync-status?${stringifiedParams}` : `/api/workspaces/${workspaceId}/locations/${locationId}/sync-status`
}

/**
 * @summary Aggregate now-playing and drift hints for a location sync group
 */
export const getLocationSyncStatus = async (workspaceId: string,
    locationId: string,
    params?: GetLocationSyncStatusParams, options?: RequestInit): Promise<LocationSyncStatus> => {

  return customFetch<LocationSyncStatus>(getGetLocationSyncStatusUrl(workspaceId,locationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLocationSyncStatusQueryKey = (workspaceId: string,
    locationId: string,
    params?: GetLocationSyncStatusParams,) => {
    return [
    `/api/workspaces/${workspaceId}/locations/${locationId}/sync-status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLocationSyncStatusQueryOptions = <TData = Awaited<ReturnType<typeof getLocationSyncStatus>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    locationId: string,
    params?: GetLocationSyncStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocationSyncStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationSyncStatusQueryKey(workspaceId,locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationSyncStatus>>> = ({ signal }) => getLocationSyncStatus(workspaceId,locationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && locationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationSyncStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLocationSyncStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationSyncStatus>>>
export type GetLocationSyncStatusQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Aggregate now-playing and drift hints for a location sync group
 */

export function useGetLocationSyncStatus<TData = Awaited<ReturnType<typeof getLocationSyncStatus>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    locationId: string,
    params?: GetLocationSyncStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocationSyncStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLocationSyncStatusQueryOptions(workspaceId,locationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListDevicesUrl = (workspaceId: string,
    params?: ListDevicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/devices?${stringifiedParams}` : `/api/workspaces/${workspaceId}/devices`
}

/**
 * @summary List devices
 */
export const listDevices = async (workspaceId: string,
    params?: ListDevicesParams, options?: RequestInit): Promise<DeviceList> => {

  return customFetch<DeviceList>(getListDevicesUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDevicesQueryKey = (workspaceId: string,
    params?: ListDevicesParams,) => {
    return [
    `/api/workspaces/${workspaceId}/devices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDevicesQueryOptions = <TData = Awaited<ReturnType<typeof listDevices>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: ListDevicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDevicesQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDevices>>> = ({ signal }) => listDevices(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof listDevices>>>
export type ListDevicesQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List devices
 */

export function useListDevices<TData = Awaited<ReturnType<typeof listDevices>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: ListDevicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDevices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDevicesQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateDeviceUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices`
}

/**
 * @summary Create (register) a device
 */
export const createDevice = async (workspaceId: string,
    deviceInput: DeviceInput, options?: RequestInit): Promise<Device> => {

  return customFetch<Device>(getCreateDeviceUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceInput,)
  }
);}




export const getCreateDeviceMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDevice>>, TError,{workspaceId: string;data: BodyType<DeviceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDevice>>, TError,{workspaceId: string;data: BodyType<DeviceInput>}, TContext> => {

const mutationKey = ['createDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDevice>>, {workspaceId: string;data: BodyType<DeviceInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createDevice(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof createDevice>>>
    export type CreateDeviceMutationBody = BodyType<DeviceInput>
    export type CreateDeviceMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Create (register) a device
 */
export const useCreateDevice = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDevice>>, TError,{workspaceId: string;data: BodyType<DeviceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDevice>>,
        TError,
        {workspaceId: string;data: BodyType<DeviceInput>},
        TContext
      > => {
      return useMutation(getCreateDeviceMutationOptions(options));
    }

export const getGetDeviceUrl = (workspaceId: string,
    deviceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/${deviceId}`
}

/**
 * @summary Get a device
 */
export const getDevice = async (workspaceId: string,
    deviceId: string, options?: RequestInit): Promise<Device> => {

  return customFetch<Device>(getGetDeviceUrl(workspaceId,deviceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDeviceQueryKey = (workspaceId: string,
    deviceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/devices/${deviceId}`
    ] as const;
    }


export const getGetDeviceQueryOptions = <TData = Awaited<ReturnType<typeof getDevice>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    deviceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceQueryKey(workspaceId,deviceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevice>>> = ({ signal }) => getDevice(workspaceId,deviceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && deviceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof getDevice>>>
export type GetDeviceQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get a device
 */

export function useGetDevice<TData = Awaited<ReturnType<typeof getDevice>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    deviceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDevice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDeviceQueryOptions(workspaceId,deviceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateDeviceUrl = (workspaceId: string,
    deviceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/${deviceId}`
}

/**
 * @summary Update a device
 */
export const updateDevice = async (workspaceId: string,
    deviceId: string,
    deviceUpdate: DeviceUpdate, options?: RequestInit): Promise<Device> => {

  return customFetch<Device>(getUpdateDeviceUrl(workspaceId,deviceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceUpdate,)
  }
);}




export const getUpdateDeviceMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDevice>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDevice>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceUpdate>}, TContext> => {

const mutationKey = ['updateDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDevice>>, {workspaceId: string;deviceId: string;data: BodyType<DeviceUpdate>}> = (props) => {
          const {workspaceId,deviceId,data} = props ?? {};

          return  updateDevice(workspaceId,deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof updateDevice>>>
    export type UpdateDeviceMutationBody = BodyType<DeviceUpdate>
    export type UpdateDeviceMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a device
 */
export const useUpdateDevice = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDevice>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDevice>>,
        TError,
        {workspaceId: string;deviceId: string;data: BodyType<DeviceUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDeviceMutationOptions(options));
    }

export const getDeleteDeviceUrl = (workspaceId: string,
    deviceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/${deviceId}`
}

/**
 * @summary Delete a device
 */
export const deleteDevice = async (workspaceId: string,
    deviceId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteDeviceUrl(workspaceId,deviceId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDeviceMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDevice>>, TError,{workspaceId: string;deviceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDevice>>, TError,{workspaceId: string;deviceId: string}, TContext> => {

const mutationKey = ['deleteDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDevice>>, {workspaceId: string;deviceId: string}> = (props) => {
          const {workspaceId,deviceId} = props ?? {};

          return  deleteDevice(workspaceId,deviceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDevice>>>

    export type DeleteDeviceMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Delete a device
 */
export const useDeleteDevice = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDevice>>, TError,{workspaceId: string;deviceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDevice>>,
        TError,
        {workspaceId: string;deviceId: string},
        TContext
      > => {
      return useMutation(getDeleteDeviceMutationOptions(options));
    }

export const getBulkCreateDevicesUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/bulk`
}

/**
 * @summary Register multiple devices at once (each consumes a license)
 */
export const bulkCreateDevices = async (workspaceId: string,
    bulkCreateDevicesInput: BulkCreateDevicesInput, options?: RequestInit): Promise<BulkCreateDevicesResult> => {

  return customFetch<BulkCreateDevicesResult>(getBulkCreateDevicesUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkCreateDevicesInput,)
  }
);}




export const getBulkCreateDevicesMutationOptions = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateDevices>>, TError,{workspaceId: string;data: BodyType<BulkCreateDevicesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkCreateDevices>>, TError,{workspaceId: string;data: BodyType<BulkCreateDevicesInput>}, TContext> => {

const mutationKey = ['bulkCreateDevices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkCreateDevices>>, {workspaceId: string;data: BodyType<BulkCreateDevicesInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  bulkCreateDevices(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkCreateDevicesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkCreateDevices>>>
    export type BulkCreateDevicesMutationBody = BodyType<BulkCreateDevicesInput>
    export type BulkCreateDevicesMutationError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse>

    /**
 * @summary Register multiple devices at once (each consumes a license)
 */
export const useBulkCreateDevices = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateDevices>>, TError,{workspaceId: string;data: BodyType<BulkCreateDevicesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkCreateDevices>>,
        TError,
        {workspaceId: string;data: BodyType<BulkCreateDevicesInput>},
        TContext
      > => {
      return useMutation(getBulkCreateDevicesMutationOptions(options));
    }

export const getBulkUpdateDeviceActivationUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/bulk/activation`
}

/**
 * @summary Activate or deactivate multiple devices at once
 */
export const bulkUpdateDeviceActivation = async (workspaceId: string,
    bulkDeviceActivationInput: BulkDeviceActivationInput, options?: RequestInit): Promise<BulkDeviceResult> => {

  return customFetch<BulkDeviceResult>(getBulkUpdateDeviceActivationUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkDeviceActivationInput,)
  }
);}




export const getBulkUpdateDeviceActivationMutationOptions = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateDeviceActivation>>, TError,{workspaceId: string;data: BodyType<BulkDeviceActivationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateDeviceActivation>>, TError,{workspaceId: string;data: BodyType<BulkDeviceActivationInput>}, TContext> => {

const mutationKey = ['bulkUpdateDeviceActivation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateDeviceActivation>>, {workspaceId: string;data: BodyType<BulkDeviceActivationInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  bulkUpdateDeviceActivation(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateDeviceActivationMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateDeviceActivation>>>
    export type BulkUpdateDeviceActivationMutationBody = BodyType<BulkDeviceActivationInput>
    export type BulkUpdateDeviceActivationMutationError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse>

    /**
 * @summary Activate or deactivate multiple devices at once
 */
export const useBulkUpdateDeviceActivation = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateDeviceActivation>>, TError,{workspaceId: string;data: BodyType<BulkDeviceActivationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateDeviceActivation>>,
        TError,
        {workspaceId: string;data: BodyType<BulkDeviceActivationInput>},
        TContext
      > => {
      return useMutation(getBulkUpdateDeviceActivationMutationOptions(options));
    }

export const getBulkMoveDevicesUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/bulk/move`
}

/**
 * @summary Move multiple devices to a location (or unassign)
 */
export const bulkMoveDevices = async (workspaceId: string,
    bulkDeviceMoveInput: BulkDeviceMoveInput, options?: RequestInit): Promise<BulkDeviceResult> => {

  return customFetch<BulkDeviceResult>(getBulkMoveDevicesUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkDeviceMoveInput,)
  }
);}




export const getBulkMoveDevicesMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMoveDevices>>, TError,{workspaceId: string;data: BodyType<BulkDeviceMoveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkMoveDevices>>, TError,{workspaceId: string;data: BodyType<BulkDeviceMoveInput>}, TContext> => {

const mutationKey = ['bulkMoveDevices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkMoveDevices>>, {workspaceId: string;data: BodyType<BulkDeviceMoveInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  bulkMoveDevices(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkMoveDevicesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkMoveDevices>>>
    export type BulkMoveDevicesMutationBody = BodyType<BulkDeviceMoveInput>
    export type BulkMoveDevicesMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Move multiple devices to a location (or unassign)
 */
export const useBulkMoveDevices = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMoveDevices>>, TError,{workspaceId: string;data: BodyType<BulkDeviceMoveInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkMoveDevices>>,
        TError,
        {workspaceId: string;data: BodyType<BulkDeviceMoveInput>},
        TContext
      > => {
      return useMutation(getBulkMoveDevicesMutationOptions(options));
    }

export const getBulkLabelDevicesUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/bulk/labels`
}

/**
 * @summary Set or remove key:value labels on multiple devices
 */
export const bulkLabelDevices = async (workspaceId: string,
    bulkDeviceLabelInput: BulkDeviceLabelInput, options?: RequestInit): Promise<BulkDeviceResult> => {

  return customFetch<BulkDeviceResult>(getBulkLabelDevicesUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkDeviceLabelInput,)
  }
);}




export const getBulkLabelDevicesMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkLabelDevices>>, TError,{workspaceId: string;data: BodyType<BulkDeviceLabelInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkLabelDevices>>, TError,{workspaceId: string;data: BodyType<BulkDeviceLabelInput>}, TContext> => {

const mutationKey = ['bulkLabelDevices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkLabelDevices>>, {workspaceId: string;data: BodyType<BulkDeviceLabelInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  bulkLabelDevices(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkLabelDevicesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkLabelDevices>>>
    export type BulkLabelDevicesMutationBody = BodyType<BulkDeviceLabelInput>
    export type BulkLabelDevicesMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Set or remove key:value labels on multiple devices
 */
export const useBulkLabelDevices = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkLabelDevices>>, TError,{workspaceId: string;data: BodyType<BulkDeviceLabelInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkLabelDevices>>,
        TError,
        {workspaceId: string;data: BodyType<BulkDeviceLabelInput>},
        TContext
      > => {
      return useMutation(getBulkLabelDevicesMutationOptions(options));
    }

export const getBulkConfigureDevicesUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/bulk/config`
}

/**
 * @summary Apply channel/feature config to multiple devices at once
 */
export const bulkConfigureDevices = async (workspaceId: string,
    bulkDeviceConfigInput: BulkDeviceConfigInput, options?: RequestInit): Promise<BulkDeviceResult> => {

  return customFetch<BulkDeviceResult>(getBulkConfigureDevicesUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkDeviceConfigInput,)
  }
);}




export const getBulkConfigureDevicesMutationOptions = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkConfigureDevices>>, TError,{workspaceId: string;data: BodyType<BulkDeviceConfigInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkConfigureDevices>>, TError,{workspaceId: string;data: BodyType<BulkDeviceConfigInput>}, TContext> => {

const mutationKey = ['bulkConfigureDevices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkConfigureDevices>>, {workspaceId: string;data: BodyType<BulkDeviceConfigInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  bulkConfigureDevices(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkConfigureDevicesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkConfigureDevices>>>
    export type BulkConfigureDevicesMutationBody = BodyType<BulkDeviceConfigInput>
    export type BulkConfigureDevicesMutationError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse>

    /**
 * @summary Apply channel/feature config to multiple devices at once
 */
export const useBulkConfigureDevices = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkConfigureDevices>>, TError,{workspaceId: string;data: BodyType<BulkDeviceConfigInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkConfigureDevices>>,
        TError,
        {workspaceId: string;data: BodyType<BulkDeviceConfigInput>},
        TContext
      > => {
      return useMutation(getBulkConfigureDevicesMutationOptions(options));
    }

export const getListAudiencesUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/audiences`
}

/**
 * @summary List audiences (reusable targeting selectors) with live counts
 */
export const listAudiences = async (workspaceId: string, options?: RequestInit): Promise<Audience[]> => {

  return customFetch<Audience[]>(getListAudiencesUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAudiencesQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/audiences`
    ] as const;
    }


export const getListAudiencesQueryOptions = <TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAudiencesQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAudiences>>> = ({ signal }) => listAudiences(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAudiencesQueryResult = NonNullable<Awaited<ReturnType<typeof listAudiences>>>
export type ListAudiencesQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List audiences (reusable targeting selectors) with live counts
 */

export function useListAudiences<TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAudiencesQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAudienceUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/audiences`
}

/**
 * @summary Create an audience (optionally with clauses)
 */
export const createAudience = async (workspaceId: string,
    audienceInput: AudienceInput, options?: RequestInit): Promise<AudienceWithClauses> => {

  return customFetch<AudienceWithClauses>(getCreateAudienceUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      audienceInput,)
  }
);}




export const getCreateAudienceMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAudience>>, TError,{workspaceId: string;data: BodyType<AudienceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAudience>>, TError,{workspaceId: string;data: BodyType<AudienceInput>}, TContext> => {

const mutationKey = ['createAudience'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAudience>>, {workspaceId: string;data: BodyType<AudienceInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createAudience(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAudienceMutationResult = NonNullable<Awaited<ReturnType<typeof createAudience>>>
    export type CreateAudienceMutationBody = BodyType<AudienceInput>
    export type CreateAudienceMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Create an audience (optionally with clauses)
 */
export const useCreateAudience = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAudience>>, TError,{workspaceId: string;data: BodyType<AudienceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAudience>>,
        TError,
        {workspaceId: string;data: BodyType<AudienceInput>},
        TContext
      > => {
      return useMutation(getCreateAudienceMutationOptions(options));
    }

export const getGetAudienceUrl = (workspaceId: string,
    audienceId: string,) => {




  return `/api/workspaces/${workspaceId}/audiences/${audienceId}`
}

/**
 * @summary Get an audience with its clauses
 */
export const getAudience = async (workspaceId: string,
    audienceId: string, options?: RequestInit): Promise<AudienceWithClauses> => {

  return customFetch<AudienceWithClauses>(getGetAudienceUrl(workspaceId,audienceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAudienceQueryKey = (workspaceId: string,
    audienceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/audiences/${audienceId}`
    ] as const;
    }


export const getGetAudienceQueryOptions = <TData = Awaited<ReturnType<typeof getAudience>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    audienceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAudience>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAudienceQueryKey(workspaceId,audienceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAudience>>> = ({ signal }) => getAudience(workspaceId,audienceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && audienceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAudience>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAudienceQueryResult = NonNullable<Awaited<ReturnType<typeof getAudience>>>
export type GetAudienceQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get an audience with its clauses
 */

export function useGetAudience<TData = Awaited<ReturnType<typeof getAudience>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    audienceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAudience>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAudienceQueryOptions(workspaceId,audienceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAudienceUrl = (workspaceId: string,
    audienceId: string,) => {




  return `/api/workspaces/${workspaceId}/audiences/${audienceId}`
}

/**
 * @summary Update an audience; replacing clauses re-materializes the selector
 */
export const updateAudience = async (workspaceId: string,
    audienceId: string,
    audienceUpdate: AudienceUpdate, options?: RequestInit): Promise<AudienceWithClauses> => {

  return customFetch<AudienceWithClauses>(getUpdateAudienceUrl(workspaceId,audienceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      audienceUpdate,)
  }
);}




export const getUpdateAudienceMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAudience>>, TError,{workspaceId: string;audienceId: string;data: BodyType<AudienceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAudience>>, TError,{workspaceId: string;audienceId: string;data: BodyType<AudienceUpdate>}, TContext> => {

const mutationKey = ['updateAudience'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAudience>>, {workspaceId: string;audienceId: string;data: BodyType<AudienceUpdate>}> = (props) => {
          const {workspaceId,audienceId,data} = props ?? {};

          return  updateAudience(workspaceId,audienceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAudienceMutationResult = NonNullable<Awaited<ReturnType<typeof updateAudience>>>
    export type UpdateAudienceMutationBody = BodyType<AudienceUpdate>
    export type UpdateAudienceMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update an audience; replacing clauses re-materializes the selector
 */
export const useUpdateAudience = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAudience>>, TError,{workspaceId: string;audienceId: string;data: BodyType<AudienceUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAudience>>,
        TError,
        {workspaceId: string;audienceId: string;data: BodyType<AudienceUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAudienceMutationOptions(options));
    }

export const getDeleteAudienceUrl = (workspaceId: string,
    audienceId: string,) => {




  return `/api/workspaces/${workspaceId}/audiences/${audienceId}`
}

/**
 * @summary Delete an audience
 */
export const deleteAudience = async (workspaceId: string,
    audienceId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAudienceUrl(workspaceId,audienceId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAudienceMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAudience>>, TError,{workspaceId: string;audienceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAudience>>, TError,{workspaceId: string;audienceId: string}, TContext> => {

const mutationKey = ['deleteAudience'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAudience>>, {workspaceId: string;audienceId: string}> = (props) => {
          const {workspaceId,audienceId} = props ?? {};

          return  deleteAudience(workspaceId,audienceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAudienceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAudience>>>

    export type DeleteAudienceMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Delete an audience
 */
export const useDeleteAudience = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAudience>>, TError,{workspaceId: string;audienceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAudience>>,
        TError,
        {workspaceId: string;audienceId: string},
        TContext
      > => {
      return useMutation(getDeleteAudienceMutationOptions(options));
    }

export const getReplaceAudienceClausesUrl = (workspaceId: string,
    audienceId: string,) => {




  return `/api/workspaces/${workspaceId}/audiences/${audienceId}/clauses`
}

/**
 * @summary Replace an audience's clauses and re-materialize the selector
 */
export const replaceAudienceClauses = async (workspaceId: string,
    audienceId: string,
    audienceClausesInput: AudienceClausesInput, options?: RequestInit): Promise<AudienceWithClauses> => {

  return customFetch<AudienceWithClauses>(getReplaceAudienceClausesUrl(workspaceId,audienceId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      audienceClausesInput,)
  }
);}




export const getReplaceAudienceClausesMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAudienceClauses>>, TError,{workspaceId: string;audienceId: string;data: BodyType<AudienceClausesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceAudienceClauses>>, TError,{workspaceId: string;audienceId: string;data: BodyType<AudienceClausesInput>}, TContext> => {

const mutationKey = ['replaceAudienceClauses'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceAudienceClauses>>, {workspaceId: string;audienceId: string;data: BodyType<AudienceClausesInput>}> = (props) => {
          const {workspaceId,audienceId,data} = props ?? {};

          return  replaceAudienceClauses(workspaceId,audienceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceAudienceClausesMutationResult = NonNullable<Awaited<ReturnType<typeof replaceAudienceClauses>>>
    export type ReplaceAudienceClausesMutationBody = BodyType<AudienceClausesInput>
    export type ReplaceAudienceClausesMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Replace an audience's clauses and re-materialize the selector
 */
export const useReplaceAudienceClauses = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAudienceClauses>>, TError,{workspaceId: string;audienceId: string;data: BodyType<AudienceClausesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replaceAudienceClauses>>,
        TError,
        {workspaceId: string;audienceId: string;data: BodyType<AudienceClausesInput>},
        TContext
      > => {
      return useMutation(getReplaceAudienceClausesMutationOptions(options));
    }

export const getListAdInventoryListingsUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/listings`
}

/**
 * @summary List this host workspace's ad-rental inventory listings
 */
export const listAdInventoryListings = async (workspaceId: string, options?: RequestInit): Promise<AdInventoryListing[]> => {

  return customFetch<AdInventoryListing[]>(getListAdInventoryListingsUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdInventoryListingsQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-inventory/listings`
    ] as const;
    }


export const getListAdInventoryListingsQueryOptions = <TData = Awaited<ReturnType<typeof listAdInventoryListings>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdInventoryListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdInventoryListingsQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdInventoryListings>>> = ({ signal }) => listAdInventoryListings(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdInventoryListings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdInventoryListingsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdInventoryListings>>>
export type ListAdInventoryListingsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List this host workspace's ad-rental inventory listings
 */

export function useListAdInventoryListings<TData = Awaited<ReturnType<typeof listAdInventoryListings>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdInventoryListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdInventoryListingsQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAdInventoryListingUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/listings`
}

/**
 * @summary List a venue (location) as available to rent for ads
 */
export const createAdInventoryListing = async (workspaceId: string,
    adInventoryListingInput: AdInventoryListingInput, options?: RequestInit): Promise<AdInventoryListing> => {

  return customFetch<AdInventoryListing>(getCreateAdInventoryListingUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adInventoryListingInput,)
  }
);}




export const getCreateAdInventoryListingMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdInventoryListing>>, TError,{workspaceId: string;data: BodyType<AdInventoryListingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdInventoryListing>>, TError,{workspaceId: string;data: BodyType<AdInventoryListingInput>}, TContext> => {

const mutationKey = ['createAdInventoryListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdInventoryListing>>, {workspaceId: string;data: BodyType<AdInventoryListingInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createAdInventoryListing(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdInventoryListingMutationResult = NonNullable<Awaited<ReturnType<typeof createAdInventoryListing>>>
    export type CreateAdInventoryListingMutationBody = BodyType<AdInventoryListingInput>
    export type CreateAdInventoryListingMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary List a venue (location) as available to rent for ads
 */
export const useCreateAdInventoryListing = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdInventoryListing>>, TError,{workspaceId: string;data: BodyType<AdInventoryListingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdInventoryListing>>,
        TError,
        {workspaceId: string;data: BodyType<AdInventoryListingInput>},
        TContext
      > => {
      return useMutation(getCreateAdInventoryListingMutationOptions(options));
    }

export const getUpdateAdInventoryListingUrl = (workspaceId: string,
    listingId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/listings/${listingId}`
}

/**
 * @summary Update an inventory listing (price, blurb, active)
 */
export const updateAdInventoryListing = async (workspaceId: string,
    listingId: string,
    adInventoryListingUpdate: AdInventoryListingUpdate, options?: RequestInit): Promise<AdInventoryListing> => {

  return customFetch<AdInventoryListing>(getUpdateAdInventoryListingUrl(workspaceId,listingId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adInventoryListingUpdate,)
  }
);}




export const getUpdateAdInventoryListingMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdInventoryListing>>, TError,{workspaceId: string;listingId: string;data: BodyType<AdInventoryListingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdInventoryListing>>, TError,{workspaceId: string;listingId: string;data: BodyType<AdInventoryListingUpdate>}, TContext> => {

const mutationKey = ['updateAdInventoryListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdInventoryListing>>, {workspaceId: string;listingId: string;data: BodyType<AdInventoryListingUpdate>}> = (props) => {
          const {workspaceId,listingId,data} = props ?? {};

          return  updateAdInventoryListing(workspaceId,listingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdInventoryListingMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdInventoryListing>>>
    export type UpdateAdInventoryListingMutationBody = BodyType<AdInventoryListingUpdate>
    export type UpdateAdInventoryListingMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update an inventory listing (price, blurb, active)
 */
export const useUpdateAdInventoryListing = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdInventoryListing>>, TError,{workspaceId: string;listingId: string;data: BodyType<AdInventoryListingUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdInventoryListing>>,
        TError,
        {workspaceId: string;listingId: string;data: BodyType<AdInventoryListingUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAdInventoryListingMutationOptions(options));
    }

export const getDeleteAdInventoryListingUrl = (workspaceId: string,
    listingId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/listings/${listingId}`
}

/**
 * @summary Remove a venue from ad-rental inventory
 */
export const deleteAdInventoryListing = async (workspaceId: string,
    listingId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAdInventoryListingUrl(workspaceId,listingId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAdInventoryListingMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdInventoryListing>>, TError,{workspaceId: string;listingId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdInventoryListing>>, TError,{workspaceId: string;listingId: string}, TContext> => {

const mutationKey = ['deleteAdInventoryListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdInventoryListing>>, {workspaceId: string;listingId: string}> = (props) => {
          const {workspaceId,listingId} = props ?? {};

          return  deleteAdInventoryListing(workspaceId,listingId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdInventoryListingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdInventoryListing>>>

    export type DeleteAdInventoryListingMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Remove a venue from ad-rental inventory
 */
export const useDeleteAdInventoryListing = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdInventoryListing>>, TError,{workspaceId: string;listingId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdInventoryListing>>,
        TError,
        {workspaceId: string;listingId: string},
        TContext
      > => {
      return useMutation(getDeleteAdInventoryListingMutationOptions(options));
    }

export const getGetPayoutAccountUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/payout-account`
}

/**
 * @summary Get this workspace's Stripe Connect payout account status
 */
export const getPayoutAccount = async (workspaceId: string, options?: RequestInit): Promise<WorkspacePayoutAccount> => {

  return customFetch<WorkspacePayoutAccount>(getGetPayoutAccountUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPayoutAccountQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-inventory/payout-account`
    ] as const;
    }


export const getGetPayoutAccountQueryOptions = <TData = Awaited<ReturnType<typeof getPayoutAccount>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPayoutAccount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutAccountQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutAccount>>> = ({ signal }) => getPayoutAccount(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayoutAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPayoutAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutAccount>>>
export type GetPayoutAccountQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Get this workspace's Stripe Connect payout account status
 */

export function useGetPayoutAccount<TData = Awaited<ReturnType<typeof getPayoutAccount>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPayoutAccount>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPayoutAccountQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getStartPayoutOnboardingUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/payout-account/onboard`
}

/**
 * @summary Begin/continue Stripe Connect onboarding; returns an Account Link URL
 */
export const startPayoutOnboarding = async (workspaceId: string, options?: RequestInit): Promise<PayoutOnboardingResponse> => {

  return customFetch<PayoutOnboardingResponse>(getStartPayoutOnboardingUrl(workspaceId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getStartPayoutOnboardingMutationOptions = <TError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPayoutOnboarding>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startPayoutOnboarding>>, TError,{workspaceId: string}, TContext> => {

const mutationKey = ['startPayoutOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startPayoutOnboarding>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  startPayoutOnboarding(workspaceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartPayoutOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof startPayoutOnboarding>>>

    export type StartPayoutOnboardingMutationError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>

    /**
 * @summary Begin/continue Stripe Connect onboarding; returns an Account Link URL
 */
export const useStartPayoutOnboarding = <TError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPayoutOnboarding>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startPayoutOnboarding>>,
        TError,
        {workspaceId: string},
        TContext
      > => {
      return useMutation(getStartPayoutOnboardingMutationOptions(options));
    }

export const getRefreshPayoutAccountUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/payout-account/refresh`
}

/**
 * @summary Sync the connected account's live capability flags from Stripe
 */
export const refreshPayoutAccount = async (workspaceId: string, options?: RequestInit): Promise<WorkspacePayoutAccount> => {

  return customFetch<WorkspacePayoutAccount>(getRefreshPayoutAccountUrl(workspaceId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRefreshPayoutAccountMutationOptions = <TError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPayoutAccount>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshPayoutAccount>>, TError,{workspaceId: string}, TContext> => {

const mutationKey = ['refreshPayoutAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshPayoutAccount>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  refreshPayoutAccount(workspaceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshPayoutAccountMutationResult = NonNullable<Awaited<ReturnType<typeof refreshPayoutAccount>>>

    export type RefreshPayoutAccountMutationError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>

    /**
 * @summary Sync the connected account's live capability flags from Stripe
 */
export const useRefreshPayoutAccount = <TError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPayoutAccount>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshPayoutAccount>>,
        TError,
        {workspaceId: string},
        TContext
      > => {
      return useMutation(getRefreshPayoutAccountMutationOptions(options));
    }

export const getListIncomingAdBookingsUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/bookings`
}

/**
 * @summary List ad bookings targeting this host workspace's venues
 */
export const listIncomingAdBookings = async (workspaceId: string, options?: RequestInit): Promise<AdBooking[]> => {

  return customFetch<AdBooking[]>(getListIncomingAdBookingsUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIncomingAdBookingsQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-inventory/bookings`
    ] as const;
    }


export const getListIncomingAdBookingsQueryOptions = <TData = Awaited<ReturnType<typeof listIncomingAdBookings>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIncomingAdBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIncomingAdBookingsQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIncomingAdBookings>>> = ({ signal }) => listIncomingAdBookings(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIncomingAdBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListIncomingAdBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof listIncomingAdBookings>>>
export type ListIncomingAdBookingsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List ad bookings targeting this host workspace's venues
 */

export function useListIncomingAdBookings<TData = Awaited<ReturnType<typeof listIncomingAdBookings>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIncomingAdBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListIncomingAdBookingsQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getApproveAdBookingUrl = (workspaceId: string,
    bookingId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/bookings/${bookingId}/approve`
}

/**
 * @summary Approve a booking; copies the creative into this workspace
 */
export const approveAdBooking = async (workspaceId: string,
    bookingId: string, options?: RequestInit): Promise<AdBooking> => {

  return customFetch<AdBooking>(getApproveAdBookingUrl(workspaceId,bookingId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApproveAdBookingMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdBooking>>, TError,{workspaceId: string;bookingId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveAdBooking>>, TError,{workspaceId: string;bookingId: string}, TContext> => {

const mutationKey = ['approveAdBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAdBooking>>, {workspaceId: string;bookingId: string}> = (props) => {
          const {workspaceId,bookingId} = props ?? {};

          return  approveAdBooking(workspaceId,bookingId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAdBookingMutationResult = NonNullable<Awaited<ReturnType<typeof approveAdBooking>>>

    export type ApproveAdBookingMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Approve a booking; copies the creative into this workspace
 */
export const useApproveAdBooking = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdBooking>>, TError,{workspaceId: string;bookingId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveAdBooking>>,
        TError,
        {workspaceId: string;bookingId: string},
        TContext
      > => {
      return useMutation(getApproveAdBookingMutationOptions(options));
    }

export const getRejectAdBookingUrl = (workspaceId: string,
    bookingId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/bookings/${bookingId}/reject`
}

/**
 * @summary Reject a booking with an optional reason
 */
export const rejectAdBooking = async (workspaceId: string,
    bookingId: string,
    adBookingRejectInput?: AdBookingRejectInput, options?: RequestInit): Promise<AdBooking> => {

  return customFetch<AdBooking>(getRejectAdBookingUrl(workspaceId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adBookingRejectInput,)
  }
);}




export const getRejectAdBookingMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAdBooking>>, TError,{workspaceId: string;bookingId: string;data?: BodyType<AdBookingRejectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectAdBooking>>, TError,{workspaceId: string;bookingId: string;data?: BodyType<AdBookingRejectInput>}, TContext> => {

const mutationKey = ['rejectAdBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAdBooking>>, {workspaceId: string;bookingId: string;data?: BodyType<AdBookingRejectInput>}> = (props) => {
          const {workspaceId,bookingId,data} = props ?? {};

          return  rejectAdBooking(workspaceId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectAdBookingMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAdBooking>>>
    export type RejectAdBookingMutationBody = BodyType<AdBookingRejectInput> | undefined
    export type RejectAdBookingMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Reject a booking with an optional reason
 */
export const useRejectAdBooking = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAdBooking>>, TError,{workspaceId: string;bookingId: string;data?: BodyType<AdBookingRejectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectAdBooking>>,
        TError,
        {workspaceId: string;bookingId: string;data?: BodyType<AdBookingRejectInput>},
        TContext
      > => {
      return useMutation(getRejectAdBookingMutationOptions(options));
    }

export const getGetIncomingAdBookingReportUrl = (workspaceId: string,
    bookingId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/bookings/${bookingId}/report`
}

/**
 * @summary Proof-of-play report for a booking targeting this host's venue
 */
export const getIncomingAdBookingReport = async (workspaceId: string,
    bookingId: string, options?: RequestInit): Promise<AdBookingReport> => {

  return customFetch<AdBookingReport>(getGetIncomingAdBookingReportUrl(workspaceId,bookingId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetIncomingAdBookingReportQueryKey = (workspaceId: string,
    bookingId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-inventory/bookings/${bookingId}/report`
    ] as const;
    }


export const getGetIncomingAdBookingReportQueryOptions = <TData = Awaited<ReturnType<typeof getIncomingAdBookingReport>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    bookingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIncomingAdBookingReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIncomingAdBookingReportQueryKey(workspaceId,bookingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIncomingAdBookingReport>>> = ({ signal }) => getIncomingAdBookingReport(workspaceId,bookingId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && bookingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIncomingAdBookingReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIncomingAdBookingReportQueryResult = NonNullable<Awaited<ReturnType<typeof getIncomingAdBookingReport>>>
export type GetIncomingAdBookingReportQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Proof-of-play report for a booking targeting this host's venue
 */

export function useGetIncomingAdBookingReport<TData = Awaited<ReturnType<typeof getIncomingAdBookingReport>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    bookingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIncomingAdBookingReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIncomingAdBookingReportQueryOptions(workspaceId,bookingId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdBookingCreativeUrlUrl = (workspaceId: string,
    bookingId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/bookings/${bookingId}/creative-url`
}

/**
 * @summary Presigned URL to preview the advertiser's creative before approving
 */
export const getAdBookingCreativeUrl = async (workspaceId: string,
    bookingId: string, options?: RequestInit): Promise<AdCreativePreview> => {

  return customFetch<AdCreativePreview>(getGetAdBookingCreativeUrlUrl(workspaceId,bookingId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdBookingCreativeUrlQueryKey = (workspaceId: string,
    bookingId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-inventory/bookings/${bookingId}/creative-url`
    ] as const;
    }


export const getGetAdBookingCreativeUrlQueryOptions = <TData = Awaited<ReturnType<typeof getAdBookingCreativeUrl>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse | ServiceUnavailableResponse>>(workspaceId: string,
    bookingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdBookingCreativeUrl>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdBookingCreativeUrlQueryKey(workspaceId,bookingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdBookingCreativeUrl>>> = ({ signal }) => getAdBookingCreativeUrl(workspaceId,bookingId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && bookingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdBookingCreativeUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdBookingCreativeUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getAdBookingCreativeUrl>>>
export type GetAdBookingCreativeUrlQueryError = ErrorType<ForbiddenResponse | NotFoundResponse | ServiceUnavailableResponse>


/**
 * @summary Presigned URL to preview the advertiser's creative before approving
 */

export function useGetAdBookingCreativeUrl<TData = Awaited<ReturnType<typeof getAdBookingCreativeUrl>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse | ServiceUnavailableResponse>>(
 workspaceId: string,
    bookingId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdBookingCreativeUrl>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdBookingCreativeUrlQueryOptions(workspaceId,bookingId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetHostAdEarningsUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-inventory/earnings`
}

/**
 * @summary This venue's ad earnings (net payout after the platform fee)
 */
export const getHostAdEarnings = async (workspaceId: string, options?: RequestInit): Promise<HostAdEarnings> => {

  return customFetch<HostAdEarnings>(getGetHostAdEarningsUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHostAdEarningsQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-inventory/earnings`
    ] as const;
    }


export const getGetHostAdEarningsQueryOptions = <TData = Awaited<ReturnType<typeof getHostAdEarnings>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHostAdEarnings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHostAdEarningsQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHostAdEarnings>>> = ({ signal }) => getHostAdEarnings(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHostAdEarnings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHostAdEarningsQueryResult = NonNullable<Awaited<ReturnType<typeof getHostAdEarnings>>>
export type GetHostAdEarningsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary This venue's ad earnings (net payout after the platform fee)
 */

export function useGetHostAdEarnings<TData = Awaited<ReturnType<typeof getHostAdEarnings>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHostAdEarnings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHostAdEarningsQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAdminAdBookingsUrl = () => {




  return `/api/admin/ad-bookings`
}

/**
 * @summary (Platform operator) List every ad booking across all workspaces
 */
export const listAdminAdBookings = async ( options?: RequestInit): Promise<AdBooking[]> => {

  return customFetch<AdBooking[]>(getListAdminAdBookingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminAdBookingsQueryKey = () => {
    return [
    `/api/admin/ad-bookings`
    ] as const;
    }


export const getListAdminAdBookingsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminAdBookings>>, TError = ErrorType<ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminAdBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminAdBookingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAdBookings>>> = ({ signal }) => listAdminAdBookings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminAdBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminAdBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminAdBookings>>>
export type ListAdminAdBookingsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) List every ad booking across all workspaces
 */

export function useListAdminAdBookings<TData = Awaited<ReturnType<typeof listAdminAdBookings>>, TError = ErrorType<ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminAdBookings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminAdBookingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRefundAdminAdBookingUrl = (bookingId: string,) => {




  return `/api/admin/ad-bookings/${bookingId}/refund`
}

/**
 * @summary (Platform operator) Refund a booking and stop its playback
 */
export const refundAdminAdBooking = async (bookingId: string, options?: RequestInit): Promise<AdBooking> => {

  return customFetch<AdBooking>(getRefundAdminAdBookingUrl(bookingId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRefundAdminAdBookingMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundAdminAdBooking>>, TError,{bookingId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refundAdminAdBooking>>, TError,{bookingId: string}, TContext> => {

const mutationKey = ['refundAdminAdBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refundAdminAdBooking>>, {bookingId: string}> = (props) => {
          const {bookingId} = props ?? {};

          return  refundAdminAdBooking(bookingId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefundAdminAdBookingMutationResult = NonNullable<Awaited<ReturnType<typeof refundAdminAdBooking>>>

    export type RefundAdminAdBookingMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Refund a booking and stop its playback
 */
export const useRefundAdminAdBooking = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundAdminAdBooking>>, TError,{bookingId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refundAdminAdBooking>>,
        TError,
        {bookingId: string},
        TContext
      > => {
      return useMutation(getRefundAdminAdBookingMutationOptions(options));
    }

export const getEndAdminAdBookingUrl = (bookingId: string,) => {




  return `/api/admin/ad-bookings/${bookingId}/end`
}

/**
 * @summary (Platform operator) Force-end an active flight and tear it down
 */
export const endAdminAdBooking = async (bookingId: string, options?: RequestInit): Promise<AdBooking> => {

  return customFetch<AdBooking>(getEndAdminAdBookingUrl(bookingId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getEndAdminAdBookingMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endAdminAdBooking>>, TError,{bookingId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof endAdminAdBooking>>, TError,{bookingId: string}, TContext> => {

const mutationKey = ['endAdminAdBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endAdminAdBooking>>, {bookingId: string}> = (props) => {
          const {bookingId} = props ?? {};

          return  endAdminAdBooking(bookingId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndAdminAdBookingMutationResult = NonNullable<Awaited<ReturnType<typeof endAdminAdBooking>>>

    export type EndAdminAdBookingMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Force-end an active flight and tear it down
 */
export const useEndAdminAdBooking = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endAdminAdBooking>>, TError,{bookingId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof endAdminAdBooking>>,
        TError,
        {bookingId: string},
        TContext
      > => {
      return useMutation(getEndAdminAdBookingMutationOptions(options));
    }

export const getListDeviceInventoryUrl = (params?: ListDeviceInventoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/inventory?${stringifiedParams}` : `/api/admin/inventory`
}

/**
 * @summary (Platform operator) List physical device inventory units
 */
export const listDeviceInventory = async (params?: ListDeviceInventoryParams, options?: RequestInit): Promise<DeviceInventoryList> => {

  return customFetch<DeviceInventoryList>(getListDeviceInventoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDeviceInventoryQueryKey = (params?: ListDeviceInventoryParams,) => {
    return [
    `/api/admin/inventory`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDeviceInventoryQueryOptions = <TData = Awaited<ReturnType<typeof listDeviceInventory>>, TError = ErrorType<ForbiddenResponse>>(params?: ListDeviceInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDeviceInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDeviceInventoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDeviceInventory>>> = ({ signal }) => listDeviceInventory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDeviceInventory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDeviceInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof listDeviceInventory>>>
export type ListDeviceInventoryQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) List physical device inventory units
 */

export function useListDeviceInventory<TData = Awaited<ReturnType<typeof listDeviceInventory>>, TError = ErrorType<ForbiddenResponse>>(
 params?: ListDeviceInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDeviceInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDeviceInventoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getMintDeviceInventoryUrl = () => {




  return `/api/admin/inventory`
}

/**
 * @summary (Platform operator) Mint a block of new inventory units + serials
 */
export const mintDeviceInventory = async (mintInventoryInput: MintInventoryInput, options?: RequestInit): Promise<MintInventoryResult> => {

  return customFetch<MintInventoryResult>(getMintDeviceInventoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mintInventoryInput,)
  }
);}




export const getMintDeviceInventoryMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintDeviceInventory>>, TError,{data: BodyType<MintInventoryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mintDeviceInventory>>, TError,{data: BodyType<MintInventoryInput>}, TContext> => {

const mutationKey = ['mintDeviceInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mintDeviceInventory>>, {data: BodyType<MintInventoryInput>}> = (props) => {
          const {data} = props ?? {};

          return  mintDeviceInventory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MintDeviceInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof mintDeviceInventory>>>
    export type MintDeviceInventoryMutationBody = BodyType<MintInventoryInput>
    export type MintDeviceInventoryMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary (Platform operator) Mint a block of new inventory units + serials
 */
export const useMintDeviceInventory = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mintDeviceInventory>>, TError,{data: BodyType<MintInventoryInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof mintDeviceInventory>>,
        TError,
        {data: BodyType<MintInventoryInput>},
        TContext
      > => {
      return useMutation(getMintDeviceInventoryMutationOptions(options));
    }

export const getUpdateDeviceInventoryUrl = (inventoryId: string,) => {




  return `/api/admin/inventory/${inventoryId}`
}

/**
 * @summary (Platform operator) Update an inventory unit's status / notes
 */
export const updateDeviceInventory = async (inventoryId: string,
    deviceInventoryUpdate: DeviceInventoryUpdate, options?: RequestInit): Promise<DeviceInventoryItem> => {

  return customFetch<DeviceInventoryItem>(getUpdateDeviceInventoryUrl(inventoryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceInventoryUpdate,)
  }
);}




export const getUpdateDeviceInventoryMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceInventory>>, TError,{inventoryId: string;data: BodyType<DeviceInventoryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDeviceInventory>>, TError,{inventoryId: string;data: BodyType<DeviceInventoryUpdate>}, TContext> => {

const mutationKey = ['updateDeviceInventory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDeviceInventory>>, {inventoryId: string;data: BodyType<DeviceInventoryUpdate>}> = (props) => {
          const {inventoryId,data} = props ?? {};

          return  updateDeviceInventory(inventoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDeviceInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeviceInventory>>>
    export type UpdateDeviceInventoryMutationBody = BodyType<DeviceInventoryUpdate>
    export type UpdateDeviceInventoryMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Update an inventory unit's status / notes
 */
export const useUpdateDeviceInventory = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceInventory>>, TError,{inventoryId: string;data: BodyType<DeviceInventoryUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDeviceInventory>>,
        TError,
        {inventoryId: string;data: BodyType<DeviceInventoryUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDeviceInventoryMutationOptions(options));
    }

export const getListDeviceOrdersUrl = (params?: ListDeviceOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/orders?${stringifiedParams}` : `/api/admin/orders`
}

/**
 * @summary (Platform operator) List device fulfilment orders
 */
export const listDeviceOrders = async (params?: ListDeviceOrdersParams, options?: RequestInit): Promise<DeviceOrderList> => {

  return customFetch<DeviceOrderList>(getListDeviceOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDeviceOrdersQueryKey = (params?: ListDeviceOrdersParams,) => {
    return [
    `/api/admin/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDeviceOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listDeviceOrders>>, TError = ErrorType<ForbiddenResponse>>(params?: ListDeviceOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDeviceOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDeviceOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDeviceOrders>>> = ({ signal }) => listDeviceOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDeviceOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDeviceOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listDeviceOrders>>>
export type ListDeviceOrdersQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) List device fulfilment orders
 */

export function useListDeviceOrders<TData = Awaited<ReturnType<typeof listDeviceOrders>>, TError = ErrorType<ForbiddenResponse>>(
 params?: ListDeviceOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDeviceOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDeviceOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateDeviceOrderUrl = (orderId: string,) => {




  return `/api/admin/orders/${orderId}`
}

/**
 * @summary (Platform operator) Update an order's status / notes
 */
export const updateDeviceOrder = async (orderId: string,
    deviceOrderUpdate: DeviceOrderUpdate, options?: RequestInit): Promise<DeviceOrder> => {

  return customFetch<DeviceOrder>(getUpdateDeviceOrderUrl(orderId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceOrderUpdate,)
  }
);}




export const getUpdateDeviceOrderMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceOrder>>, TError,{orderId: string;data: BodyType<DeviceOrderUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDeviceOrder>>, TError,{orderId: string;data: BodyType<DeviceOrderUpdate>}, TContext> => {

const mutationKey = ['updateDeviceOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDeviceOrder>>, {orderId: string;data: BodyType<DeviceOrderUpdate>}> = (props) => {
          const {orderId,data} = props ?? {};

          return  updateDeviceOrder(orderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDeviceOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeviceOrder>>>
    export type UpdateDeviceOrderMutationBody = BodyType<DeviceOrderUpdate>
    export type UpdateDeviceOrderMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Update an order's status / notes
 */
export const useUpdateDeviceOrder = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceOrder>>, TError,{orderId: string;data: BodyType<DeviceOrderUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDeviceOrder>>,
        TError,
        {orderId: string;data: BodyType<DeviceOrderUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDeviceOrderMutationOptions(options));
    }

export const getAllocateDeviceOrderUrl = (orderId: string,) => {




  return `/api/admin/orders/${orderId}/allocate`
}

/**
 * @summary (Platform operator) Allocate in-stock units to an order
 */
export const allocateDeviceOrder = async (orderId: string,
    allocateOrderInput: AllocateOrderInput, options?: RequestInit): Promise<DeviceOrder> => {

  return customFetch<DeviceOrder>(getAllocateDeviceOrderUrl(orderId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      allocateOrderInput,)
  }
);}




export const getAllocateDeviceOrderMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocateDeviceOrder>>, TError,{orderId: string;data: BodyType<AllocateOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof allocateDeviceOrder>>, TError,{orderId: string;data: BodyType<AllocateOrderInput>}, TContext> => {

const mutationKey = ['allocateDeviceOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocateDeviceOrder>>, {orderId: string;data: BodyType<AllocateOrderInput>}> = (props) => {
          const {orderId,data} = props ?? {};

          return  allocateDeviceOrder(orderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AllocateDeviceOrderMutationResult = NonNullable<Awaited<ReturnType<typeof allocateDeviceOrder>>>
    export type AllocateDeviceOrderMutationBody = BodyType<AllocateOrderInput>
    export type AllocateDeviceOrderMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Allocate in-stock units to an order
 */
export const useAllocateDeviceOrder = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocateDeviceOrder>>, TError,{orderId: string;data: BodyType<AllocateOrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof allocateDeviceOrder>>,
        TError,
        {orderId: string;data: BodyType<AllocateOrderInput>},
        TContext
      > => {
      return useMutation(getAllocateDeviceOrderMutationOptions(options));
    }

export const getListAdminCustomersUrl = () => {




  return `/api/admin/customers`
}

/**
 * @summary (Platform operator) Every customer/workspace with device + subscription rollups
 */
export const listAdminCustomers = async ( options?: RequestInit): Promise<AdminCustomersResponse> => {

  return customFetch<AdminCustomersResponse>(getListAdminCustomersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminCustomersQueryKey = () => {
    return [
    `/api/admin/customers`
    ] as const;
    }


export const getListAdminCustomersQueryOptions = <TData = Awaited<ReturnType<typeof listAdminCustomers>>, TError = ErrorType<ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminCustomersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminCustomers>>> = ({ signal }) => listAdminCustomers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminCustomers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminCustomers>>>
export type ListAdminCustomersQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) Every customer/workspace with device + subscription rollups
 */

export function useListAdminCustomers<TData = Awaited<ReturnType<typeof listAdminCustomers>>, TError = ErrorType<ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminCustomersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getExtendTrialUrl = (userId: string,) => {




  return `/api/admin/customers/${userId}/extend-trial`
}

/**
 * @summary (Platform operator) Extend an account's free trial by N days
 */
export const extendTrial = async (userId: string,
    extendTrialInput: ExtendTrialInput, options?: RequestInit): Promise<ExtendTrialResult> => {

  return customFetch<ExtendTrialResult>(getExtendTrialUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      extendTrialInput,)
  }
);}




export const getExtendTrialMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extendTrial>>, TError,{userId: string;data: BodyType<ExtendTrialInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof extendTrial>>, TError,{userId: string;data: BodyType<ExtendTrialInput>}, TContext> => {

const mutationKey = ['extendTrial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extendTrial>>, {userId: string;data: BodyType<ExtendTrialInput>}> = (props) => {
          const {userId,data} = props ?? {};

          return  extendTrial(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtendTrialMutationResult = NonNullable<Awaited<ReturnType<typeof extendTrial>>>
    export type ExtendTrialMutationBody = BodyType<ExtendTrialInput>
    export type ExtendTrialMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Extend an account's free trial by N days
 */
export const useExtendTrial = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extendTrial>>, TError,{userId: string;data: BodyType<ExtendTrialInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof extendTrial>>,
        TError,
        {userId: string;data: BodyType<ExtendTrialInput>},
        TContext
      > => {
      return useMutation(getExtendTrialMutationOptions(options));
    }

export const getListPromoProgramsUrl = () => {




  return `/api/admin/promo-programs`
}

/**
 * @summary (Platform operator) Active promo/pilot pricing programs, for the pilot-invoice picker
 */
export const listPromoPrograms = async ( options?: RequestInit): Promise<PromoProgramList> => {

  return customFetch<PromoProgramList>(getListPromoProgramsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPromoProgramsQueryKey = () => {
    return [
    `/api/admin/promo-programs`
    ] as const;
    }


export const getListPromoProgramsQueryOptions = <TData = Awaited<ReturnType<typeof listPromoPrograms>>, TError = ErrorType<ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPromoPrograms>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPromoProgramsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPromoPrograms>>> = ({ signal }) => listPromoPrograms({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPromoPrograms>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPromoProgramsQueryResult = NonNullable<Awaited<ReturnType<typeof listPromoPrograms>>>
export type ListPromoProgramsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) Active promo/pilot pricing programs, for the pilot-invoice picker
 */

export function useListPromoPrograms<TData = Awaited<ReturnType<typeof listPromoPrograms>>, TError = ErrorType<ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPromoPrograms>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPromoProgramsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePilotInvoiceUrl = (userId: string,) => {




  return `/api/admin/customers/${userId}/pilot-invoice`
}

/**
 * @summary (Platform operator) Create a discounted annual/monthly license invoice payable by bank transfer, from a promo program
 */
export const createPilotInvoice = async (userId: string,
    pilotInvoiceInput: PilotInvoiceInput, options?: RequestInit): Promise<PilotInvoiceResult> => {

  return customFetch<PilotInvoiceResult>(getCreatePilotInvoiceUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pilotInvoiceInput,)
  }
);}




export const getCreatePilotInvoiceMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPilotInvoice>>, TError,{userId: string;data: BodyType<PilotInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPilotInvoice>>, TError,{userId: string;data: BodyType<PilotInvoiceInput>}, TContext> => {

const mutationKey = ['createPilotInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPilotInvoice>>, {userId: string;data: BodyType<PilotInvoiceInput>}> = (props) => {
          const {userId,data} = props ?? {};

          return  createPilotInvoice(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePilotInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof createPilotInvoice>>>
    export type CreatePilotInvoiceMutationBody = BodyType<PilotInvoiceInput>
    export type CreatePilotInvoiceMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Create a discounted annual/monthly license invoice payable by bank transfer, from a promo program
 */
export const useCreatePilotInvoice = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPilotInvoice>>, TError,{userId: string;data: BodyType<PilotInvoiceInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPilotInvoice>>,
        TError,
        {userId: string;data: BodyType<PilotInvoiceInput>},
        TContext
      > => {
      return useMutation(getCreatePilotInvoiceMutationOptions(options));
    }

export const getGetAdminOverviewUrl = () => {




  return `/api/admin/overview`
}

/**
 * @summary (Platform operator) Cross-tenant platform health/overview snapshot
 */
export const getAdminOverview = async ( options?: RequestInit): Promise<AdminOverview> => {

  return customFetch<AdminOverview>(getGetAdminOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminOverviewQueryKey = () => {
    return [
    `/api/admin/overview`
    ] as const;
    }


export const getGetAdminOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOverview>>, TError = ErrorType<ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOverview>>> = ({ signal }) => getAdminOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOverview>>>
export type GetAdminOverviewQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) Cross-tenant platform health/overview snapshot
 */

export function useGetAdminOverview<TData = Awaited<ReturnType<typeof getAdminOverview>>, TError = ErrorType<ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdminGrowthUrl = () => {




  return `/api/admin/growth`
}

/**
 * @summary (Platform operator) Live growth board — product, money, social, outreach emails
 */
export const getAdminGrowth = async ( options?: RequestInit): Promise<AdminGrowth> => {

  return customFetch<AdminGrowth>(getGetAdminGrowthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminGrowthQueryKey = () => {
    return [
    `/api/admin/growth`
    ] as const;
    }


export const getGetAdminGrowthQueryOptions = <TData = Awaited<ReturnType<typeof getAdminGrowth>>, TError = ErrorType<ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminGrowth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminGrowthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminGrowth>>> = ({ signal }) => getAdminGrowth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminGrowth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminGrowthQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminGrowth>>>
export type GetAdminGrowthQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) Live growth board — product, money, social, outreach emails
 */

export function useGetAdminGrowth<TData = Awaited<ReturnType<typeof getAdminGrowth>>, TError = ErrorType<ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminGrowth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminGrowthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdminGrowthMediaUrl = (mediaId: string,) => {




  return `/api/admin/growth/media/${mediaId}`
}

/**
 * @summary (Platform operator) Redirect to the signed Post Bridge file for a growth-board preview
 */
export const getAdminGrowthMedia = async (mediaId: string, options?: RequestInit): Promise<unknown> => {

  return customFetch<unknown>(getGetAdminGrowthMediaUrl(mediaId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminGrowthMediaQueryKey = (mediaId: string,) => {
    return [
    `/api/admin/growth/media/${mediaId}`
    ] as const;
    }


export const getGetAdminGrowthMediaQueryOptions = <TData = Awaited<ReturnType<typeof getAdminGrowthMedia>>, TError = ErrorType<void | ForbiddenResponse | NotFoundResponse>>(mediaId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminGrowthMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminGrowthMediaQueryKey(mediaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminGrowthMedia>>> = ({ signal }) => getAdminGrowthMedia(mediaId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(mediaId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminGrowthMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminGrowthMediaQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminGrowthMedia>>>
export type GetAdminGrowthMediaQueryError = ErrorType<void | ForbiddenResponse | NotFoundResponse>


/**
 * @summary (Platform operator) Redirect to the signed Post Bridge file for a growth-board preview
 */

export function useGetAdminGrowthMedia<TData = Awaited<ReturnType<typeof getAdminGrowthMedia>>, TError = ErrorType<void | ForbiddenResponse | NotFoundResponse>>(
 mediaId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminGrowthMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminGrowthMediaQueryOptions(mediaId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getBulkAdminGrowthPostsUrl = () => {




  return `/api/admin/growth/posts/bulk`
}

/**
 * @summary (Platform operator) Approve or remove many draft/queued Post Bridge posts
 */
export const bulkAdminGrowthPosts = async (adminGrowthBulkBody: AdminGrowthBulkBody, options?: RequestInit): Promise<AdminGrowthBulkResult> => {

  return customFetch<AdminGrowthBulkResult>(getBulkAdminGrowthPostsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminGrowthBulkBody,)
  }
);}




export const getBulkAdminGrowthPostsMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAdminGrowthPosts>>, TError,{data: BodyType<AdminGrowthBulkBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkAdminGrowthPosts>>, TError,{data: BodyType<AdminGrowthBulkBody>}, TContext> => {

const mutationKey = ['bulkAdminGrowthPosts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkAdminGrowthPosts>>, {data: BodyType<AdminGrowthBulkBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkAdminGrowthPosts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkAdminGrowthPostsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkAdminGrowthPosts>>>
    export type BulkAdminGrowthPostsMutationBody = BodyType<AdminGrowthBulkBody>
    export type BulkAdminGrowthPostsMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>

    /**
 * @summary (Platform operator) Approve or remove many draft/queued Post Bridge posts
 */
export const useBulkAdminGrowthPosts = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAdminGrowthPosts>>, TError,{data: BodyType<AdminGrowthBulkBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkAdminGrowthPosts>>,
        TError,
        {data: BodyType<AdminGrowthBulkBody>},
        TContext
      > => {
      return useMutation(getBulkAdminGrowthPostsMutationOptions(options));
    }

export const getUpdateAdminGrowthPostUrl = (postId: string,) => {




  return `/api/admin/growth/posts/${postId}`
}

/**
 * @summary (Platform operator) Approve or edit a draft/queued Post Bridge post
 */
export const updateAdminGrowthPost = async (postId: string,
    adminGrowthPostUpdate: AdminGrowthPostUpdate, options?: RequestInit): Promise<AdminGrowthSocialPost> => {

  return customFetch<AdminGrowthSocialPost>(getUpdateAdminGrowthPostUrl(postId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminGrowthPostUpdate,)
  }
);}




export const getUpdateAdminGrowthPostMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminGrowthPost>>, TError,{postId: string;data: BodyType<AdminGrowthPostUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminGrowthPost>>, TError,{postId: string;data: BodyType<AdminGrowthPostUpdate>}, TContext> => {

const mutationKey = ['updateAdminGrowthPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminGrowthPost>>, {postId: string;data: BodyType<AdminGrowthPostUpdate>}> = (props) => {
          const {postId,data} = props ?? {};

          return  updateAdminGrowthPost(postId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminGrowthPostMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminGrowthPost>>>
    export type UpdateAdminGrowthPostMutationBody = BodyType<AdminGrowthPostUpdate>
    export type UpdateAdminGrowthPostMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Approve or edit a draft/queued Post Bridge post
 */
export const useUpdateAdminGrowthPost = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminGrowthPost>>, TError,{postId: string;data: BodyType<AdminGrowthPostUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminGrowthPost>>,
        TError,
        {postId: string;data: BodyType<AdminGrowthPostUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAdminGrowthPostMutationOptions(options));
    }

export const getDeleteAdminGrowthPostUrl = (postId: string,) => {




  return `/api/admin/growth/posts/${postId}`
}

/**
 * @summary (Platform operator) Remove a draft or queued post so it does not publish
 */
export const deleteAdminGrowthPost = async (postId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAdminGrowthPostUrl(postId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAdminGrowthPostMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminGrowthPost>>, TError,{postId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminGrowthPost>>, TError,{postId: string}, TContext> => {

const mutationKey = ['deleteAdminGrowthPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminGrowthPost>>, {postId: string}> = (props) => {
          const {postId} = props ?? {};

          return  deleteAdminGrowthPost(postId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminGrowthPostMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminGrowthPost>>>

    export type DeleteAdminGrowthPostMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Remove a draft or queued post so it does not publish
 */
export const useDeleteAdminGrowthPost = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminGrowthPost>>, TError,{postId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminGrowthPost>>,
        TError,
        {postId: string},
        TContext
      > => {
      return useMutation(getDeleteAdminGrowthPostMutationOptions(options));
    }

export const getGetAdminCustomerDetailUrl = (workspaceId: string,) => {




  return `/api/admin/customers/${workspaceId}`
}

/**
 * @summary (Platform operator) Per-workspace drill-in — devices, locations, schedules, subscription
 */
export const getAdminCustomerDetail = async (workspaceId: string, options?: RequestInit): Promise<AdminCustomerDetail> => {

  return customFetch<AdminCustomerDetail>(getGetAdminCustomerDetailUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminCustomerDetailQueryKey = (workspaceId: string,) => {
    return [
    `/api/admin/customers/${workspaceId}`
    ] as const;
    }


export const getGetAdminCustomerDetailQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCustomerDetail>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminCustomerDetail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminCustomerDetailQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCustomerDetail>>> = ({ signal }) => getAdminCustomerDetail(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCustomerDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminCustomerDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCustomerDetail>>>
export type GetAdminCustomerDetailQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary (Platform operator) Per-workspace drill-in — devices, locations, schedules, subscription
 */

export function useGetAdminCustomerDetail<TData = Awaited<ReturnType<typeof getAdminCustomerDetail>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminCustomerDetail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminCustomerDetailQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAdminFleetUrl = (params?: ListAdminFleetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/fleet?${stringifiedParams}` : `/api/admin/fleet`
}

/**
 * @summary (Platform operator) Every device across all workspaces, with owner + license state
 */
export const listAdminFleet = async (params?: ListAdminFleetParams, options?: RequestInit): Promise<AdminFleetList> => {

  return customFetch<AdminFleetList>(getListAdminFleetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminFleetQueryKey = (params?: ListAdminFleetParams,) => {
    return [
    `/api/admin/fleet`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminFleetQueryOptions = <TData = Awaited<ReturnType<typeof listAdminFleet>>, TError = ErrorType<ForbiddenResponse>>(params?: ListAdminFleetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminFleet>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminFleetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminFleet>>> = ({ signal }) => listAdminFleet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminFleet>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminFleetQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminFleet>>>
export type ListAdminFleetQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) Every device across all workspaces, with owner + license state
 */

export function useListAdminFleet<TData = Awaited<ReturnType<typeof listAdminFleet>>, TError = ErrorType<ForbiddenResponse>>(
 params?: ListAdminFleetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminFleet>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminFleetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAdminSupportTicketsUrl = () => {




  return `/api/admin/support`
}

/**
 * @summary (Platform operator) Escalated support tickets across all workspaces, newest first
 */
export const listAdminSupportTickets = async ( options?: RequestInit): Promise<AdminSupportTicketList> => {

  return customFetch<AdminSupportTicketList>(getListAdminSupportTicketsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminSupportTicketsQueryKey = () => {
    return [
    `/api/admin/support`
    ] as const;
    }


export const getListAdminSupportTicketsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminSupportTickets>>, TError = ErrorType<ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminSupportTickets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminSupportTicketsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminSupportTickets>>> = ({ signal }) => listAdminSupportTickets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminSupportTickets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminSupportTicketsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminSupportTickets>>>
export type ListAdminSupportTicketsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) Escalated support tickets across all workspaces, newest first
 */

export function useListAdminSupportTickets<TData = Awaited<ReturnType<typeof listAdminSupportTickets>>, TError = ErrorType<ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminSupportTickets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminSupportTicketsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdminSupportTicketUrl = (ticketId: string,) => {




  return `/api/admin/support/${ticketId}`
}

/**
 * @summary (Platform operator) An escalated ticket with its full comment thread
 */
export const getAdminSupportTicket = async (ticketId: string, options?: RequestInit): Promise<AdminSupportTicketDetail> => {

  return customFetch<AdminSupportTicketDetail>(getGetAdminSupportTicketUrl(ticketId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminSupportTicketQueryKey = (ticketId: string,) => {
    return [
    `/api/admin/support/${ticketId}`
    ] as const;
    }


export const getGetAdminSupportTicketQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSupportTicket>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(ticketId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSupportTicket>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSupportTicketQueryKey(ticketId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSupportTicket>>> = ({ signal }) => getAdminSupportTicket(ticketId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(ticketId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSupportTicket>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminSupportTicketQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSupportTicket>>>
export type GetAdminSupportTicketQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary (Platform operator) An escalated ticket with its full comment thread
 */

export function useGetAdminSupportTicket<TData = Awaited<ReturnType<typeof getAdminSupportTicket>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 ticketId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSupportTicket>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminSupportTicketQueryOptions(ticketId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAdminSupportTicketUrl = (ticketId: string,) => {




  return `/api/admin/support/${ticketId}`
}

/**
 * @summary (Platform operator) Update an escalated ticket's status or priority
 */
export const updateAdminSupportTicket = async (ticketId: string,
    ticketUpdate: TicketUpdate, options?: RequestInit): Promise<AdminSupportTicket> => {

  return customFetch<AdminSupportTicket>(getUpdateAdminSupportTicketUrl(ticketId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketUpdate,)
  }
);}




export const getUpdateAdminSupportTicketMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSupportTicket>>, TError,{ticketId: string;data: BodyType<TicketUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminSupportTicket>>, TError,{ticketId: string;data: BodyType<TicketUpdate>}, TContext> => {

const mutationKey = ['updateAdminSupportTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminSupportTicket>>, {ticketId: string;data: BodyType<TicketUpdate>}> = (props) => {
          const {ticketId,data} = props ?? {};

          return  updateAdminSupportTicket(ticketId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminSupportTicketMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminSupportTicket>>>
    export type UpdateAdminSupportTicketMutationBody = BodyType<TicketUpdate>
    export type UpdateAdminSupportTicketMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Update an escalated ticket's status or priority
 */
export const useUpdateAdminSupportTicket = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminSupportTicket>>, TError,{ticketId: string;data: BodyType<TicketUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminSupportTicket>>,
        TError,
        {ticketId: string;data: BodyType<TicketUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAdminSupportTicketMutationOptions(options));
    }

export const getCreateAdminSupportTicketCommentUrl = (ticketId: string,) => {




  return `/api/admin/support/${ticketId}/comments`
}

/**
 * @summary (Platform operator) Reply on an escalated ticket (always a staff comment)
 */
export const createAdminSupportTicketComment = async (ticketId: string,
    ticketCommentInput: TicketCommentInput, options?: RequestInit): Promise<TicketComment> => {

  return customFetch<TicketComment>(getCreateAdminSupportTicketCommentUrl(ticketId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketCommentInput,)
  }
);}




export const getCreateAdminSupportTicketCommentMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminSupportTicketComment>>, TError,{ticketId: string;data: BodyType<TicketCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminSupportTicketComment>>, TError,{ticketId: string;data: BodyType<TicketCommentInput>}, TContext> => {

const mutationKey = ['createAdminSupportTicketComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminSupportTicketComment>>, {ticketId: string;data: BodyType<TicketCommentInput>}> = (props) => {
          const {ticketId,data} = props ?? {};

          return  createAdminSupportTicketComment(ticketId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminSupportTicketCommentMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminSupportTicketComment>>>
    export type CreateAdminSupportTicketCommentMutationBody = BodyType<TicketCommentInput>
    export type CreateAdminSupportTicketCommentMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Reply on an escalated ticket (always a staff comment)
 */
export const useCreateAdminSupportTicketComment = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminSupportTicketComment>>, TError,{ticketId: string;data: BodyType<TicketCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdminSupportTicketComment>>,
        TError,
        {ticketId: string;data: BodyType<TicketCommentInput>},
        TContext
      > => {
      return useMutation(getCreateAdminSupportTicketCommentMutationOptions(options));
    }

export const getListProspectsUrl = (params?: ListProspectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/prospects?${stringifiedParams}` : `/api/admin/prospects`
}

/**
 * @summary (Platform operator) Outreach prospects with per-status counts
 */
export const listProspects = async (params?: ListProspectsParams, options?: RequestInit): Promise<ProspectList> => {

  return customFetch<ProspectList>(getListProspectsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProspectsQueryKey = (params?: ListProspectsParams,) => {
    return [
    `/api/admin/prospects`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProspectsQueryOptions = <TData = Awaited<ReturnType<typeof listProspects>>, TError = ErrorType<ForbiddenResponse>>(params?: ListProspectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProspects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProspectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProspects>>> = ({ signal }) => listProspects(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProspects>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProspectsQueryResult = NonNullable<Awaited<ReturnType<typeof listProspects>>>
export type ListProspectsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) Outreach prospects with per-status counts
 */

export function useListProspects<TData = Awaited<ReturnType<typeof listProspects>>, TError = ErrorType<ForbiddenResponse>>(
 params?: ListProspectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProspects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProspectsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateProspectUrl = () => {




  return `/api/admin/prospects`
}

/**
 * @summary (Platform operator) Add an outreach prospect
 */
export const createProspect = async (prospectInput: ProspectInput, options?: RequestInit): Promise<Prospect> => {

  return customFetch<Prospect>(getCreateProspectUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      prospectInput,)
  }
);}




export const getCreateProspectMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProspect>>, TError,{data: BodyType<ProspectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProspect>>, TError,{data: BodyType<ProspectInput>}, TContext> => {

const mutationKey = ['createProspect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProspect>>, {data: BodyType<ProspectInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProspect(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProspectMutationResult = NonNullable<Awaited<ReturnType<typeof createProspect>>>
    export type CreateProspectMutationBody = BodyType<ProspectInput>
    export type CreateProspectMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | ConflictResponse>

    /**
 * @summary (Platform operator) Add an outreach prospect
 */
export const useCreateProspect = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProspect>>, TError,{data: BodyType<ProspectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProspect>>,
        TError,
        {data: BodyType<ProspectInput>},
        TContext
      > => {
      return useMutation(getCreateProspectMutationOptions(options));
    }

export const getImportProspectsCsvUrl = () => {




  return `/api/admin/prospects/import`
}

/**
 * @summary (Platform operator) Bulk-import prospects from the outreach CSV layout (dedupes by company+country)
 */
export const importProspectsCsv = async (prospectImportInput: ProspectImportInput, options?: RequestInit): Promise<ProspectImportResult> => {

  return customFetch<ProspectImportResult>(getImportProspectsCsvUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      prospectImportInput,)
  }
);}




export const getImportProspectsCsvMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importProspectsCsv>>, TError,{data: BodyType<ProspectImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importProspectsCsv>>, TError,{data: BodyType<ProspectImportInput>}, TContext> => {

const mutationKey = ['importProspectsCsv'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importProspectsCsv>>, {data: BodyType<ProspectImportInput>}> = (props) => {
          const {data} = props ?? {};

          return  importProspectsCsv(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportProspectsCsvMutationResult = NonNullable<Awaited<ReturnType<typeof importProspectsCsv>>>
    export type ImportProspectsCsvMutationBody = BodyType<ProspectImportInput>
    export type ImportProspectsCsvMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary (Platform operator) Bulk-import prospects from the outreach CSV layout (dedupes by company+country)
 */
export const useImportProspectsCsv = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importProspectsCsv>>, TError,{data: BodyType<ProspectImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importProspectsCsv>>,
        TError,
        {data: BodyType<ProspectImportInput>},
        TContext
      > => {
      return useMutation(getImportProspectsCsvMutationOptions(options));
    }

export const getExportProspectsCsvUrl = () => {




  return `/api/admin/prospects/export`
}

/**
 * @summary (Platform operator) Export all prospects as CSV (outreach column layout + status)
 */
export const exportProspectsCsv = async ( options?: RequestInit): Promise<string> => {

  return customFetch<string>(getExportProspectsCsvUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportProspectsCsvQueryKey = () => {
    return [
    `/api/admin/prospects/export`
    ] as const;
    }


export const getExportProspectsCsvQueryOptions = <TData = Awaited<ReturnType<typeof exportProspectsCsv>>, TError = ErrorType<ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportProspectsCsv>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportProspectsCsvQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportProspectsCsv>>> = ({ signal }) => exportProspectsCsv({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportProspectsCsv>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportProspectsCsvQueryResult = NonNullable<Awaited<ReturnType<typeof exportProspectsCsv>>>
export type ExportProspectsCsvQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) Export all prospects as CSV (outreach column layout + status)
 */

export function useExportProspectsCsv<TData = Awaited<ReturnType<typeof exportProspectsCsv>>, TError = ErrorType<ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportProspectsCsv>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportProspectsCsvQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateProspectUrl = (prospectId: string,) => {




  return `/api/admin/prospects/${prospectId}`
}

/**
 * @summary (Platform operator) Update a prospect (status transition, notes, next action, ...)
 */
export const updateProspect = async (prospectId: string,
    prospectUpdate: ProspectUpdate, options?: RequestInit): Promise<Prospect> => {

  return customFetch<Prospect>(getUpdateProspectUrl(prospectId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      prospectUpdate,)
  }
);}




export const getUpdateProspectMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProspect>>, TError,{prospectId: string;data: BodyType<ProspectUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProspect>>, TError,{prospectId: string;data: BodyType<ProspectUpdate>}, TContext> => {

const mutationKey = ['updateProspect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProspect>>, {prospectId: string;data: BodyType<ProspectUpdate>}> = (props) => {
          const {prospectId,data} = props ?? {};

          return  updateProspect(prospectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProspectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProspect>>>
    export type UpdateProspectMutationBody = BodyType<ProspectUpdate>
    export type UpdateProspectMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Update a prospect (status transition, notes, next action, ...)
 */
export const useUpdateProspect = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProspect>>, TError,{prospectId: string;data: BodyType<ProspectUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProspect>>,
        TError,
        {prospectId: string;data: BodyType<ProspectUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProspectMutationOptions(options));
    }

export const getDeleteProspectUrl = (prospectId: string,) => {




  return `/api/admin/prospects/${prospectId}`
}

/**
 * @summary (Platform operator) Delete a prospect
 */
export const deleteProspect = async (prospectId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProspectUrl(prospectId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProspectMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProspect>>, TError,{prospectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProspect>>, TError,{prospectId: string}, TContext> => {

const mutationKey = ['deleteProspect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProspect>>, {prospectId: string}> = (props) => {
          const {prospectId} = props ?? {};

          return  deleteProspect(prospectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProspectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProspect>>>

    export type DeleteProspectMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary (Platform operator) Delete a prospect
 */
export const useDeleteProspect = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProspect>>, TError,{prospectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProspect>>,
        TError,
        {prospectId: string},
        TContext
      > => {
      return useMutation(getDeleteProspectMutationOptions(options));
    }

export const getListProvisioningProfilesUrl = (params?: ListProvisioningProfilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/provisioning-profiles?${stringifiedParams}` : `/api/admin/provisioning-profiles`
}

/**
 * @summary (Platform operator) Provision-on-first-login profiles
 */
export const listProvisioningProfiles = async (params?: ListProvisioningProfilesParams, options?: RequestInit): Promise<ProvisioningProfileList> => {

  return customFetch<ProvisioningProfileList>(getListProvisioningProfilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProvisioningProfilesQueryKey = (params?: ListProvisioningProfilesParams,) => {
    return [
    `/api/admin/provisioning-profiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProvisioningProfilesQueryOptions = <TData = Awaited<ReturnType<typeof listProvisioningProfiles>>, TError = ErrorType<ForbiddenResponse>>(params?: ListProvisioningProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProvisioningProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProvisioningProfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProvisioningProfiles>>> = ({ signal }) => listProvisioningProfiles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProvisioningProfiles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProvisioningProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listProvisioningProfiles>>>
export type ListProvisioningProfilesQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) Provision-on-first-login profiles
 */

export function useListProvisioningProfiles<TData = Awaited<ReturnType<typeof listProvisioningProfiles>>, TError = ErrorType<ForbiddenResponse>>(
 params?: ListProvisioningProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProvisioningProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProvisioningProfilesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateProvisioningProfileUrl = () => {




  return `/api/admin/provisioning-profiles`
}

/**
 * @summary (Platform operator) Prepare a workspace to be provisioned on a prospect's first sign-in
 */
export const createProvisioningProfile = async (provisioningProfileInput: ProvisioningProfileInput, options?: RequestInit): Promise<ProvisioningProfile> => {

  return customFetch<ProvisioningProfile>(getCreateProvisioningProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      provisioningProfileInput,)
  }
);}




export const getCreateProvisioningProfileMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvisioningProfile>>, TError,{data: BodyType<ProvisioningProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProvisioningProfile>>, TError,{data: BodyType<ProvisioningProfileInput>}, TContext> => {

const mutationKey = ['createProvisioningProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProvisioningProfile>>, {data: BodyType<ProvisioningProfileInput>}> = (props) => {
          const {data} = props ?? {};

          return  createProvisioningProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProvisioningProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createProvisioningProfile>>>
    export type CreateProvisioningProfileMutationBody = BodyType<ProvisioningProfileInput>
    export type CreateProvisioningProfileMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | ConflictResponse>

    /**
 * @summary (Platform operator) Prepare a workspace to be provisioned on a prospect's first sign-in
 */
export const useCreateProvisioningProfile = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvisioningProfile>>, TError,{data: BodyType<ProvisioningProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProvisioningProfile>>,
        TError,
        {data: BodyType<ProvisioningProfileInput>},
        TContext
      > => {
      return useMutation(getCreateProvisioningProfileMutationOptions(options));
    }

export const getUpdateProvisioningProfileUrl = (profileId: string,) => {




  return `/api/admin/provisioning-profiles/${profileId}`
}

/**
 * @summary (Platform operator) Update a provisioning profile (only while pending)
 */
export const updateProvisioningProfile = async (profileId: string,
    provisioningProfileUpdate: ProvisioningProfileUpdate, options?: RequestInit): Promise<ProvisioningProfile> => {

  return customFetch<ProvisioningProfile>(getUpdateProvisioningProfileUrl(profileId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      provisioningProfileUpdate,)
  }
);}




export const getUpdateProvisioningProfileMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProvisioningProfile>>, TError,{profileId: string;data: BodyType<ProvisioningProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProvisioningProfile>>, TError,{profileId: string;data: BodyType<ProvisioningProfileUpdate>}, TContext> => {

const mutationKey = ['updateProvisioningProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProvisioningProfile>>, {profileId: string;data: BodyType<ProvisioningProfileUpdate>}> = (props) => {
          const {profileId,data} = props ?? {};

          return  updateProvisioningProfile(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProvisioningProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProvisioningProfile>>>
    export type UpdateProvisioningProfileMutationBody = BodyType<ProvisioningProfileUpdate>
    export type UpdateProvisioningProfileMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse>

    /**
 * @summary (Platform operator) Update a provisioning profile (only while pending)
 */
export const useUpdateProvisioningProfile = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProvisioningProfile>>, TError,{profileId: string;data: BodyType<ProvisioningProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProvisioningProfile>>,
        TError,
        {profileId: string;data: BodyType<ProvisioningProfileUpdate>},
        TContext
      > => {
      return useMutation(getUpdateProvisioningProfileMutationOptions(options));
    }

export const getCancelProvisioningProfileUrl = (profileId: string,) => {




  return `/api/admin/provisioning-profiles/${profileId}`
}

/**
 * @summary (Platform operator) Cancel a pending provisioning profile (kept as history)
 */
export const cancelProvisioningProfile = async (profileId: string, options?: RequestInit): Promise<ProvisioningProfile> => {

  return customFetch<ProvisioningProfile>(getCancelProvisioningProfileUrl(profileId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getCancelProvisioningProfileMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelProvisioningProfile>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelProvisioningProfile>>, TError,{profileId: string}, TContext> => {

const mutationKey = ['cancelProvisioningProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelProvisioningProfile>>, {profileId: string}> = (props) => {
          const {profileId} = props ?? {};

          return  cancelProvisioningProfile(profileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelProvisioningProfileMutationResult = NonNullable<Awaited<ReturnType<typeof cancelProvisioningProfile>>>

    export type CancelProvisioningProfileMutationError = ErrorType<ForbiddenResponse | NotFoundResponse | ConflictResponse>

    /**
 * @summary (Platform operator) Cancel a pending provisioning profile (kept as history)
 */
export const useCancelProvisioningProfile = <TError = ErrorType<ForbiddenResponse | NotFoundResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelProvisioningProfile>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelProvisioningProfile>>,
        TError,
        {profileId: string},
        TContext
      > => {
      return useMutation(getCancelProvisioningProfileMutationOptions(options));
    }

export const getPreviewProvisioningProfileUrl = (profileId: string,) => {




  return `/api/admin/provisioning-profiles/${profileId}/preview`
}

/**
 * @summary (Platform operator) What the first sign-in would create for this profile
 */
export const previewProvisioningProfile = async (profileId: string, options?: RequestInit): Promise<ProvisioningPreview> => {

  return customFetch<ProvisioningPreview>(getPreviewProvisioningProfileUrl(profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPreviewProvisioningProfileQueryKey = (profileId: string,) => {
    return [
    `/api/admin/provisioning-profiles/${profileId}/preview`
    ] as const;
    }


export const getPreviewProvisioningProfileQueryOptions = <TData = Awaited<ReturnType<typeof previewProvisioningProfile>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(profileId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewProvisioningProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewProvisioningProfileQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewProvisioningProfile>>> = ({ signal }) => previewProvisioningProfile(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(profileId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewProvisioningProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type PreviewProvisioningProfileQueryResult = NonNullable<Awaited<ReturnType<typeof previewProvisioningProfile>>>
export type PreviewProvisioningProfileQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary (Platform operator) What the first sign-in would create for this profile
 */

export function usePreviewProvisioningProfile<TData = Awaited<ReturnType<typeof previewProvisioningProfile>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 profileId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewProvisioningProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPreviewProvisioningProfileQueryOptions(profileId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSendProvisioningProfileInviteUrl = (profileId: string,) => {




  return `/api/admin/provisioning-profiles/${profileId}/send-invite`
}

/**
 * @summary (Platform operator) (Re)send the "workspace is waiting" email for a pending profile
 */
export const sendProvisioningProfileInvite = async (profileId: string, options?: RequestInit): Promise<ProvisioningInviteResult> => {

  return customFetch<ProvisioningInviteResult>(getSendProvisioningProfileInviteUrl(profileId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSendProvisioningProfileInviteMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendProvisioningProfileInvite>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendProvisioningProfileInvite>>, TError,{profileId: string}, TContext> => {

const mutationKey = ['sendProvisioningProfileInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendProvisioningProfileInvite>>, {profileId: string}> = (props) => {
          const {profileId} = props ?? {};

          return  sendProvisioningProfileInvite(profileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendProvisioningProfileInviteMutationResult = NonNullable<Awaited<ReturnType<typeof sendProvisioningProfileInvite>>>

    export type SendProvisioningProfileInviteMutationError = ErrorType<ForbiddenResponse | NotFoundResponse | ConflictResponse>

    /**
 * @summary (Platform operator) (Re)send the "workspace is waiting" email for a pending profile
 */
export const useSendProvisioningProfileInvite = <TError = ErrorType<ForbiddenResponse | NotFoundResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendProvisioningProfileInvite>>, TError,{profileId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendProvisioningProfileInvite>>,
        TError,
        {profileId: string},
        TContext
      > => {
      return useMutation(getSendProvisioningProfileInviteMutationOptions(options));
    }

export const getListPlatformAuditUrl = (params?: ListPlatformAuditParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/audit?${stringifiedParams}` : `/api/admin/audit`
}

/**
 * @summary (Platform operator) Platform-admin action audit trail, newest first
 */
export const listPlatformAudit = async (params?: ListPlatformAuditParams, options?: RequestInit): Promise<PlatformAuditLogList> => {

  return customFetch<PlatformAuditLogList>(getListPlatformAuditUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformAuditQueryKey = (params?: ListPlatformAuditParams,) => {
    return [
    `/api/admin/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPlatformAuditQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformAudit>>, TError = ErrorType<ForbiddenResponse>>(params?: ListPlatformAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformAuditQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformAudit>>> = ({ signal }) => listPlatformAudit(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPlatformAuditQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformAudit>>>
export type ListPlatformAuditQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary (Platform operator) Platform-admin action audit trail, newest first
 */

export function useListPlatformAudit<TData = Awaited<ReturnType<typeof listPlatformAudit>>, TError = ErrorType<ForbiddenResponse>>(
 params?: ListPlatformAuditParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPlatformAuditQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getBrowseAdMarketplaceInventoryUrl = (workspaceId: string,
    params?: BrowseAdMarketplaceInventoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/ad-marketplace/inventory?${stringifiedParams}` : `/api/workspaces/${workspaceId}/ad-marketplace/inventory`
}

/**
 * @summary Browse venues across all hosts that have opted into ad rental
 */
export const browseAdMarketplaceInventory = async (workspaceId: string,
    params?: BrowseAdMarketplaceInventoryParams, options?: RequestInit): Promise<MarketplaceInventoryItem[]> => {

  return customFetch<MarketplaceInventoryItem[]>(getBrowseAdMarketplaceInventoryUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBrowseAdMarketplaceInventoryQueryKey = (workspaceId: string,
    params?: BrowseAdMarketplaceInventoryParams,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-marketplace/inventory`, ...(params ? [params] : [])
    ] as const;
    }


export const getBrowseAdMarketplaceInventoryQueryOptions = <TData = Awaited<ReturnType<typeof browseAdMarketplaceInventory>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: BrowseAdMarketplaceInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof browseAdMarketplaceInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBrowseAdMarketplaceInventoryQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof browseAdMarketplaceInventory>>> = ({ signal }) => browseAdMarketplaceInventory(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof browseAdMarketplaceInventory>>, TError, TData> & { queryKey: QueryKey }
}

export type BrowseAdMarketplaceInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof browseAdMarketplaceInventory>>>
export type BrowseAdMarketplaceInventoryQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Browse venues across all hosts that have opted into ad rental
 */

export function useBrowseAdMarketplaceInventory<TData = Awaited<ReturnType<typeof browseAdMarketplaceInventory>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: BrowseAdMarketplaceInventoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof browseAdMarketplaceInventory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getBrowseAdMarketplaceInventoryQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAdCampaignsUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns`
}

/**
 * @summary List this advertiser's campaigns with placement rollups
 */
export const listAdCampaigns = async (workspaceId: string, options?: RequestInit): Promise<AdCampaignSummary[]> => {

  return customFetch<AdCampaignSummary[]>(getListAdCampaignsUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdCampaignsQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-campaigns`
    ] as const;
    }


export const getListAdCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listAdCampaigns>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdCampaignsQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdCampaigns>>> = ({ signal }) => listAdCampaigns(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdCampaigns>>>
export type ListAdCampaignsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List this advertiser's campaigns with placement rollups
 */

export function useListAdCampaigns<TData = Awaited<ReturnType<typeof listAdCampaigns>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdCampaignsQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAdCampaignUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns`
}

/**
 * @summary Create a draft campaign (name + creative set + defaults)
 */
export const createAdCampaign = async (workspaceId: string,
    adCampaignInput: AdCampaignInput, options?: RequestInit): Promise<AdCampaign> => {

  return customFetch<AdCampaign>(getCreateAdCampaignUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adCampaignInput,)
  }
);}




export const getCreateAdCampaignMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdCampaign>>, TError,{workspaceId: string;data: BodyType<AdCampaignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdCampaign>>, TError,{workspaceId: string;data: BodyType<AdCampaignInput>}, TContext> => {

const mutationKey = ['createAdCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdCampaign>>, {workspaceId: string;data: BodyType<AdCampaignInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createAdCampaign(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createAdCampaign>>>
    export type CreateAdCampaignMutationBody = BodyType<AdCampaignInput>
    export type CreateAdCampaignMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Create a draft campaign (name + creative set + defaults)
 */
export const useCreateAdCampaign = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdCampaign>>, TError,{workspaceId: string;data: BodyType<AdCampaignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdCampaign>>,
        TError,
        {workspaceId: string;data: BodyType<AdCampaignInput>},
        TContext
      > => {
      return useMutation(getCreateAdCampaignMutationOptions(options));
    }

export const getGetAdCampaignDashboardUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns/dashboard`
}

/**
 * @summary Aggregate advertiser dashboard (spend + proof-of-play across all placements)
 */
export const getAdCampaignDashboard = async (workspaceId: string, options?: RequestInit): Promise<AdCampaignDashboard> => {

  return customFetch<AdCampaignDashboard>(getGetAdCampaignDashboardUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdCampaignDashboardQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-campaigns/dashboard`
    ] as const;
    }


export const getGetAdCampaignDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getAdCampaignDashboard>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdCampaignDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdCampaignDashboardQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdCampaignDashboard>>> = ({ signal }) => getAdCampaignDashboard(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdCampaignDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdCampaignDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getAdCampaignDashboard>>>
export type GetAdCampaignDashboardQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Aggregate advertiser dashboard (spend + proof-of-play across all placements)
 */

export function useGetAdCampaignDashboard<TData = Awaited<ReturnType<typeof getAdCampaignDashboard>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdCampaignDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdCampaignDashboardQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdCampaignUrl = (workspaceId: string,
    campaignId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}`
}

/**
 * @summary Get one campaign with its creatives + placements
 */
export const getAdCampaign = async (workspaceId: string,
    campaignId: string, options?: RequestInit): Promise<AdCampaign> => {

  return customFetch<AdCampaign>(getGetAdCampaignUrl(workspaceId,campaignId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdCampaignQueryKey = (workspaceId: string,
    campaignId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}`
    ] as const;
    }


export const getGetAdCampaignQueryOptions = <TData = Awaited<ReturnType<typeof getAdCampaign>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    campaignId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdCampaign>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdCampaignQueryKey(workspaceId,campaignId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdCampaign>>> = ({ signal }) => getAdCampaign(workspaceId,campaignId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && campaignId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdCampaign>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getAdCampaign>>>
export type GetAdCampaignQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get one campaign with its creatives + placements
 */

export function useGetAdCampaign<TData = Awaited<ReturnType<typeof getAdCampaign>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    campaignId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdCampaign>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdCampaignQueryOptions(workspaceId,campaignId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAdCampaignUrl = (workspaceId: string,
    campaignId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}`
}

/**
 * @summary Edit a campaign (name, objective, defaults, creative set)
 */
export const updateAdCampaign = async (workspaceId: string,
    campaignId: string,
    adCampaignUpdate: AdCampaignUpdate, options?: RequestInit): Promise<AdCampaign> => {

  return customFetch<AdCampaign>(getUpdateAdCampaignUrl(workspaceId,campaignId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adCampaignUpdate,)
  }
);}




export const getUpdateAdCampaignMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdCampaign>>, TError,{workspaceId: string;campaignId: string;data: BodyType<AdCampaignUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdCampaign>>, TError,{workspaceId: string;campaignId: string;data: BodyType<AdCampaignUpdate>}, TContext> => {

const mutationKey = ['updateAdCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdCampaign>>, {workspaceId: string;campaignId: string;data: BodyType<AdCampaignUpdate>}> = (props) => {
          const {workspaceId,campaignId,data} = props ?? {};

          return  updateAdCampaign(workspaceId,campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdCampaign>>>
    export type UpdateAdCampaignMutationBody = BodyType<AdCampaignUpdate>
    export type UpdateAdCampaignMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Edit a campaign (name, objective, defaults, creative set)
 */
export const useUpdateAdCampaign = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdCampaign>>, TError,{workspaceId: string;campaignId: string;data: BodyType<AdCampaignUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdCampaign>>,
        TError,
        {workspaceId: string;campaignId: string;data: BodyType<AdCampaignUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAdCampaignMutationOptions(options));
    }

export const getAddAdPlacementsUrl = (workspaceId: string,
    campaignId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}/placements`
}

/**
 * @summary Add one or more venue placements to a campaign
 */
export const addAdPlacements = async (workspaceId: string,
    campaignId: string,
    adPlacementsInput: AdPlacementsInput, options?: RequestInit): Promise<AdCampaign> => {

  return customFetch<AdCampaign>(getAddAdPlacementsUrl(workspaceId,campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adPlacementsInput,)
  }
);}




export const getAddAdPlacementsMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAdPlacements>>, TError,{workspaceId: string;campaignId: string;data: BodyType<AdPlacementsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addAdPlacements>>, TError,{workspaceId: string;campaignId: string;data: BodyType<AdPlacementsInput>}, TContext> => {

const mutationKey = ['addAdPlacements'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAdPlacements>>, {workspaceId: string;campaignId: string;data: BodyType<AdPlacementsInput>}> = (props) => {
          const {workspaceId,campaignId,data} = props ?? {};

          return  addAdPlacements(workspaceId,campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddAdPlacementsMutationResult = NonNullable<Awaited<ReturnType<typeof addAdPlacements>>>
    export type AddAdPlacementsMutationBody = BodyType<AdPlacementsInput>
    export type AddAdPlacementsMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Add one or more venue placements to a campaign
 */
export const useAddAdPlacements = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAdPlacements>>, TError,{workspaceId: string;campaignId: string;data: BodyType<AdPlacementsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addAdPlacements>>,
        TError,
        {workspaceId: string;campaignId: string;data: BodyType<AdPlacementsInput>},
        TContext
      > => {
      return useMutation(getAddAdPlacementsMutationOptions(options));
    }

export const getSubmitAdCampaignUrl = (workspaceId: string,
    campaignId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}/submit`
}

/**
 * @summary Submit all draft placements of a campaign for host approval
 */
export const submitAdCampaign = async (workspaceId: string,
    campaignId: string,
    adCampaignSubmitInput: AdCampaignSubmitInput, options?: RequestInit): Promise<AdCampaign> => {

  return customFetch<AdCampaign>(getSubmitAdCampaignUrl(workspaceId,campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adCampaignSubmitInput,)
  }
);}




export const getSubmitAdCampaignMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAdCampaign>>, TError,{workspaceId: string;campaignId: string;data: BodyType<AdCampaignSubmitInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitAdCampaign>>, TError,{workspaceId: string;campaignId: string;data: BodyType<AdCampaignSubmitInput>}, TContext> => {

const mutationKey = ['submitAdCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAdCampaign>>, {workspaceId: string;campaignId: string;data: BodyType<AdCampaignSubmitInput>}> = (props) => {
          const {workspaceId,campaignId,data} = props ?? {};

          return  submitAdCampaign(workspaceId,campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitAdCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof submitAdCampaign>>>
    export type SubmitAdCampaignMutationBody = BodyType<AdCampaignSubmitInput>
    export type SubmitAdCampaignMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Submit all draft placements of a campaign for host approval
 */
export const useSubmitAdCampaign = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAdCampaign>>, TError,{workspaceId: string;campaignId: string;data: BodyType<AdCampaignSubmitInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitAdCampaign>>,
        TError,
        {workspaceId: string;campaignId: string;data: BodyType<AdCampaignSubmitInput>},
        TContext
      > => {
      return useMutation(getSubmitAdCampaignMutationOptions(options));
    }

export const getRemoveAdPlacementUrl = (workspaceId: string,
    campaignId: string,
    placementId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}/placements/${placementId}`
}

/**
 * @summary Remove a draft placement from a campaign
 */
export const removeAdPlacement = async (workspaceId: string,
    campaignId: string,
    placementId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRemoveAdPlacementUrl(workspaceId,campaignId,placementId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveAdPlacementMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdPlacement>>, TError,{workspaceId: string;campaignId: string;placementId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeAdPlacement>>, TError,{workspaceId: string;campaignId: string;placementId: string}, TContext> => {

const mutationKey = ['removeAdPlacement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAdPlacement>>, {workspaceId: string;campaignId: string;placementId: string}> = (props) => {
          const {workspaceId,campaignId,placementId} = props ?? {};

          return  removeAdPlacement(workspaceId,campaignId,placementId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAdPlacementMutationResult = NonNullable<Awaited<ReturnType<typeof removeAdPlacement>>>

    export type RemoveAdPlacementMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Remove a draft placement from a campaign
 */
export const useRemoveAdPlacement = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdPlacement>>, TError,{workspaceId: string;campaignId: string;placementId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeAdPlacement>>,
        TError,
        {workspaceId: string;campaignId: string;placementId: string},
        TContext
      > => {
      return useMutation(getRemoveAdPlacementMutationOptions(options));
    }

export const getCheckoutAdCampaignUrl = (workspaceId: string,
    campaignId: string,
    placementId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}/placements/${placementId}/checkout`
}

/**
 * @summary Pay for an approved placement (Stripe Checkout destination charge)
 */
export const checkoutAdCampaign = async (workspaceId: string,
    campaignId: string,
    placementId: string, options?: RequestInit): Promise<AdBookingCheckoutResponse> => {

  return customFetch<AdBookingCheckoutResponse>(getCheckoutAdCampaignUrl(workspaceId,campaignId,placementId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCheckoutAdCampaignMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkoutAdCampaign>>, TError,{workspaceId: string;campaignId: string;placementId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof checkoutAdCampaign>>, TError,{workspaceId: string;campaignId: string;placementId: string}, TContext> => {

const mutationKey = ['checkoutAdCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkoutAdCampaign>>, {workspaceId: string;campaignId: string;placementId: string}> = (props) => {
          const {workspaceId,campaignId,placementId} = props ?? {};

          return  checkoutAdCampaign(workspaceId,campaignId,placementId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckoutAdCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof checkoutAdCampaign>>>

    export type CheckoutAdCampaignMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ServiceUnavailableResponse>

    /**
 * @summary Pay for an approved placement (Stripe Checkout destination charge)
 */
export const useCheckoutAdCampaign = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkoutAdCampaign>>, TError,{workspaceId: string;campaignId: string;placementId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof checkoutAdCampaign>>,
        TError,
        {workspaceId: string;campaignId: string;placementId: string},
        TContext
      > => {
      return useMutation(getCheckoutAdCampaignMutationOptions(options));
    }

export const getResubmitAdPlacementUrl = (workspaceId: string,
    campaignId: string,
    placementId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}/placements/${placementId}/resubmit`
}

/**
 * @summary Clone a rejected placement into a new draft (rejected stays terminal)
 */
export const resubmitAdPlacement = async (workspaceId: string,
    campaignId: string,
    placementId: string,
    adPlacementResubmitInput?: AdPlacementResubmitInput, options?: RequestInit): Promise<AdCampaign> => {

  return customFetch<AdCampaign>(getResubmitAdPlacementUrl(workspaceId,campaignId,placementId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adPlacementResubmitInput,)
  }
);}




export const getResubmitAdPlacementMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resubmitAdPlacement>>, TError,{workspaceId: string;campaignId: string;placementId: string;data?: BodyType<AdPlacementResubmitInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resubmitAdPlacement>>, TError,{workspaceId: string;campaignId: string;placementId: string;data?: BodyType<AdPlacementResubmitInput>}, TContext> => {

const mutationKey = ['resubmitAdPlacement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resubmitAdPlacement>>, {workspaceId: string;campaignId: string;placementId: string;data?: BodyType<AdPlacementResubmitInput>}> = (props) => {
          const {workspaceId,campaignId,placementId,data} = props ?? {};

          return  resubmitAdPlacement(workspaceId,campaignId,placementId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResubmitAdPlacementMutationResult = NonNullable<Awaited<ReturnType<typeof resubmitAdPlacement>>>
    export type ResubmitAdPlacementMutationBody = BodyType<AdPlacementResubmitInput> | undefined
    export type ResubmitAdPlacementMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Clone a rejected placement into a new draft (rejected stays terminal)
 */
export const useResubmitAdPlacement = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resubmitAdPlacement>>, TError,{workspaceId: string;campaignId: string;placementId: string;data?: BodyType<AdPlacementResubmitInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resubmitAdPlacement>>,
        TError,
        {workspaceId: string;campaignId: string;placementId: string;data?: BodyType<AdPlacementResubmitInput>},
        TContext
      > => {
      return useMutation(getResubmitAdPlacementMutationOptions(options));
    }

export const getGetAdCampaignReportUrl = (workspaceId: string,
    campaignId: string,
    placementId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}/placements/${placementId}/report`
}

/**
 * @summary Proof-of-play report for a placement (plays aggregated per day)
 */
export const getAdCampaignReport = async (workspaceId: string,
    campaignId: string,
    placementId: string, options?: RequestInit): Promise<AdBookingReport> => {

  return customFetch<AdBookingReport>(getGetAdCampaignReportUrl(workspaceId,campaignId,placementId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdCampaignReportQueryKey = (workspaceId: string,
    campaignId: string,
    placementId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}/placements/${placementId}/report`
    ] as const;
    }


export const getGetAdCampaignReportQueryOptions = <TData = Awaited<ReturnType<typeof getAdCampaignReport>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    campaignId: string,
    placementId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdCampaignReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdCampaignReportQueryKey(workspaceId,campaignId,placementId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdCampaignReport>>> = ({ signal }) => getAdCampaignReport(workspaceId,campaignId,placementId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && campaignId && placementId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdCampaignReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdCampaignReportQueryResult = NonNullable<Awaited<ReturnType<typeof getAdCampaignReport>>>
export type GetAdCampaignReportQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Proof-of-play report for a placement (plays aggregated per day)
 */

export function useGetAdCampaignReport<TData = Awaited<ReturnType<typeof getAdCampaignReport>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    campaignId: string,
    placementId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdCampaignReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdCampaignReportQueryOptions(workspaceId,campaignId,placementId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCancelAdPlacementUrl = (workspaceId: string,
    campaignId: string,
    placementId: string,) => {




  return `/api/workspaces/${workspaceId}/ad-campaigns/${campaignId}/placements/${placementId}/cancel`
}

/**
 * @summary Cancel a placement (refunds if already paid)
 */
export const cancelAdPlacement = async (workspaceId: string,
    campaignId: string,
    placementId: string, options?: RequestInit): Promise<AdBooking> => {

  return customFetch<AdBooking>(getCancelAdPlacementUrl(workspaceId,campaignId,placementId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCancelAdPlacementMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAdPlacement>>, TError,{workspaceId: string;campaignId: string;placementId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelAdPlacement>>, TError,{workspaceId: string;campaignId: string;placementId: string}, TContext> => {

const mutationKey = ['cancelAdPlacement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAdPlacement>>, {workspaceId: string;campaignId: string;placementId: string}> = (props) => {
          const {workspaceId,campaignId,placementId} = props ?? {};

          return  cancelAdPlacement(workspaceId,campaignId,placementId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelAdPlacementMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAdPlacement>>>

    export type CancelAdPlacementMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Cancel a placement (refunds if already paid)
 */
export const useCancelAdPlacement = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAdPlacement>>, TError,{workspaceId: string;campaignId: string;placementId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelAdPlacement>>,
        TError,
        {workspaceId: string;campaignId: string;placementId: string},
        TContext
      > => {
      return useMutation(getCancelAdPlacementMutationOptions(options));
    }

export const getListChannelsUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/channels`
}

/**
 * @summary List the workspace's channels
 */
export const listChannels = async (workspaceId: string, options?: RequestInit): Promise<Channel[]> => {

  return customFetch<Channel[]>(getListChannelsUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListChannelsQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/channels`
    ] as const;
    }


export const getListChannelsQueryOptions = <TData = Awaited<ReturnType<typeof listChannels>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListChannelsQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listChannels>>> = ({ signal }) => listChannels(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData> & { queryKey: QueryKey }
}

export type ListChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof listChannels>>>
export type ListChannelsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List the workspace's channels
 */

export function useListChannels<TData = Awaited<ReturnType<typeof listChannels>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListChannelsQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateChannelUrl = (workspaceId: string,
    channelId: string,) => {




  return `/api/workspaces/${workspaceId}/channels/${channelId}`
}

/**
 * @summary Update a channel
 */
export const updateChannel = async (workspaceId: string,
    channelId: string,
    channelUpdate: ChannelUpdate, options?: RequestInit): Promise<Channel> => {

  return customFetch<Channel>(getUpdateChannelUrl(workspaceId,channelId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      channelUpdate,)
  }
);}




export const getUpdateChannelMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChannel>>, TError,{workspaceId: string;channelId: string;data: BodyType<ChannelUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateChannel>>, TError,{workspaceId: string;channelId: string;data: BodyType<ChannelUpdate>}, TContext> => {

const mutationKey = ['updateChannel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChannel>>, {workspaceId: string;channelId: string;data: BodyType<ChannelUpdate>}> = (props) => {
          const {workspaceId,channelId,data} = props ?? {};

          return  updateChannel(workspaceId,channelId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateChannelMutationResult = NonNullable<Awaited<ReturnType<typeof updateChannel>>>
    export type UpdateChannelMutationBody = BodyType<ChannelUpdate>
    export type UpdateChannelMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a channel
 */
export const useUpdateChannel = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChannel>>, TError,{workspaceId: string;channelId: string;data: BodyType<ChannelUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateChannel>>,
        TError,
        {workspaceId: string;channelId: string;data: BodyType<ChannelUpdate>},
        TContext
      > => {
      return useMutation(getUpdateChannelMutationOptions(options));
    }

export const getUpdateDeviceActivationUrl = (workspaceId: string,
    deviceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/${deviceId}/activation`
}

/**
 * @summary Enable or disable (billable) a player device
 */
export const updateDeviceActivation = async (workspaceId: string,
    deviceId: string,
    deviceActivationUpdate: DeviceActivationUpdate, options?: RequestInit): Promise<Device> => {

  return customFetch<Device>(getUpdateDeviceActivationUrl(workspaceId,deviceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceActivationUpdate,)
  }
);}




export const getUpdateDeviceActivationMutationOptions = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceActivation>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceActivationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDeviceActivation>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceActivationUpdate>}, TContext> => {

const mutationKey = ['updateDeviceActivation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDeviceActivation>>, {workspaceId: string;deviceId: string;data: BodyType<DeviceActivationUpdate>}> = (props) => {
          const {workspaceId,deviceId,data} = props ?? {};

          return  updateDeviceActivation(workspaceId,deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDeviceActivationMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeviceActivation>>>
    export type UpdateDeviceActivationMutationBody = BodyType<DeviceActivationUpdate>
    export type UpdateDeviceActivationMutationError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Enable or disable (billable) a player device
 */
export const useUpdateDeviceActivation = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceActivation>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceActivationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDeviceActivation>>,
        TError,
        {workspaceId: string;deviceId: string;data: BodyType<DeviceActivationUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDeviceActivationMutationOptions(options));
    }

export const getUpdateDeviceChannelsUrl = (workspaceId: string,
    deviceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/${deviceId}/channels`
}

/**
 * @summary Set which channels are enabled (billable) on a device
 */
export const updateDeviceChannels = async (workspaceId: string,
    deviceId: string,
    deviceChannelsUpdate: DeviceChannelsUpdate, options?: RequestInit): Promise<Device> => {

  return customFetch<Device>(getUpdateDeviceChannelsUrl(workspaceId,deviceId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceChannelsUpdate,)
  }
);}




export const getUpdateDeviceChannelsMutationOptions = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceChannels>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceChannelsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDeviceChannels>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceChannelsUpdate>}, TContext> => {

const mutationKey = ['updateDeviceChannels'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDeviceChannels>>, {workspaceId: string;deviceId: string;data: BodyType<DeviceChannelsUpdate>}> = (props) => {
          const {workspaceId,deviceId,data} = props ?? {};

          return  updateDeviceChannels(workspaceId,deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDeviceChannelsMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeviceChannels>>>
    export type UpdateDeviceChannelsMutationBody = BodyType<DeviceChannelsUpdate>
    export type UpdateDeviceChannelsMutationError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Set which channels are enabled (billable) on a device
 */
export const useUpdateDeviceChannels = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceChannels>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceChannelsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDeviceChannels>>,
        TError,
        {workspaceId: string;deviceId: string;data: BodyType<DeviceChannelsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDeviceChannelsMutationOptions(options));
    }

export const getGetBillingOverviewUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/billing`
}

/**
 * @summary Current subscription, usage breakdown and projected charges
 */
export const getBillingOverview = async (workspaceId: string, options?: RequestInit): Promise<BillingOverview> => {

  return customFetch<BillingOverview>(getGetBillingOverviewUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingOverviewQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/billing`
    ] as const;
    }


export const getGetBillingOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getBillingOverview>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingOverviewQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingOverview>>> = ({ signal }) => getBillingOverview(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBillingOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingOverview>>>
export type GetBillingOverviewQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Current subscription, usage breakdown and projected charges
 */

export function useGetBillingOverview<TData = Awaited<ReturnType<typeof getBillingOverview>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBillingOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBillingOverviewQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBillingCheckoutUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/billing/checkout`
}

/**
 * @summary Start a Stripe Checkout session to subscribe (owner only)
 */
export const createBillingCheckout = async (workspaceId: string,
    billingCheckoutInput?: BillingCheckoutInput, options?: RequestInit): Promise<BillingSession> => {

  return customFetch<BillingSession>(getCreateBillingCheckoutUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      billingCheckoutInput,)
  }
);}




export const getCreateBillingCheckoutMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingCheckout>>, TError,{workspaceId: string;data?: BodyType<BillingCheckoutInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBillingCheckout>>, TError,{workspaceId: string;data?: BodyType<BillingCheckoutInput>}, TContext> => {

const mutationKey = ['createBillingCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBillingCheckout>>, {workspaceId: string;data?: BodyType<BillingCheckoutInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createBillingCheckout(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBillingCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof createBillingCheckout>>>
    export type CreateBillingCheckoutMutationBody = BodyType<BillingCheckoutInput> | undefined
    export type CreateBillingCheckoutMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>

    /**
 * @summary Start a Stripe Checkout session to subscribe (owner only)
 */
export const useCreateBillingCheckout = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingCheckout>>, TError,{workspaceId: string;data?: BodyType<BillingCheckoutInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBillingCheckout>>,
        TError,
        {workspaceId: string;data?: BodyType<BillingCheckoutInput>},
        TContext
      > => {
      return useMutation(getCreateBillingCheckoutMutationOptions(options));
    }

export const getCreateHardwareCheckoutUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/billing/hardware-checkout`
}

/**
 * @summary Start a Stripe Checkout to buy physical player hardware (owner only)
 */
export const createHardwareCheckout = async (workspaceId: string,
    hardwareCheckoutInput: HardwareCheckoutInput, options?: RequestInit): Promise<BillingSession> => {

  return customFetch<BillingSession>(getCreateHardwareCheckoutUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      hardwareCheckoutInput,)
  }
);}




export const getCreateHardwareCheckoutMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHardwareCheckout>>, TError,{workspaceId: string;data: BodyType<HardwareCheckoutInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHardwareCheckout>>, TError,{workspaceId: string;data: BodyType<HardwareCheckoutInput>}, TContext> => {

const mutationKey = ['createHardwareCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHardwareCheckout>>, {workspaceId: string;data: BodyType<HardwareCheckoutInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createHardwareCheckout(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHardwareCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof createHardwareCheckout>>>
    export type CreateHardwareCheckoutMutationBody = BodyType<HardwareCheckoutInput>
    export type CreateHardwareCheckoutMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>

    /**
 * @summary Start a Stripe Checkout to buy physical player hardware (owner only)
 */
export const useCreateHardwareCheckout = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHardwareCheckout>>, TError,{workspaceId: string;data: BodyType<HardwareCheckoutInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createHardwareCheckout>>,
        TError,
        {workspaceId: string;data: BodyType<HardwareCheckoutInput>},
        TContext
      > => {
      return useMutation(getCreateHardwareCheckoutMutationOptions(options));
    }

export const getCreateBillingPortalUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/billing/portal`
}

/**
 * @summary Open the Stripe Billing Portal to manage payment method (owner only)
 */
export const createBillingPortal = async (workspaceId: string,
    billingRedirectInput?: BillingRedirectInput, options?: RequestInit): Promise<BillingSession> => {

  return customFetch<BillingSession>(getCreateBillingPortalUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      billingRedirectInput,)
  }
);}




export const getCreateBillingPortalMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingPortal>>, TError,{workspaceId: string;data?: BodyType<BillingRedirectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBillingPortal>>, TError,{workspaceId: string;data?: BodyType<BillingRedirectInput>}, TContext> => {

const mutationKey = ['createBillingPortal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBillingPortal>>, {workspaceId: string;data?: BodyType<BillingRedirectInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createBillingPortal(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBillingPortalMutationResult = NonNullable<Awaited<ReturnType<typeof createBillingPortal>>>
    export type CreateBillingPortalMutationBody = BodyType<BillingRedirectInput> | undefined
    export type CreateBillingPortalMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>

    /**
 * @summary Open the Stripe Billing Portal to manage payment method (owner only)
 */
export const useCreateBillingPortal = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingPortal>>, TError,{workspaceId: string;data?: BodyType<BillingRedirectInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBillingPortal>>,
        TError,
        {workspaceId: string;data?: BodyType<BillingRedirectInput>},
        TContext
      > => {
      return useMutation(getCreateBillingPortalMutationOptions(options));
    }

export const getSyncBillingUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/billing/sync`
}

/**
 * @summary Recompute usage and push quantities to Stripe (owner only)
 */
export const syncBilling = async (workspaceId: string, options?: RequestInit): Promise<BillingOverview> => {

  return customFetch<BillingOverview>(getSyncBillingUrl(workspaceId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSyncBillingMutationOptions = <TError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncBilling>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncBilling>>, TError,{workspaceId: string}, TContext> => {

const mutationKey = ['syncBilling'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncBilling>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  syncBilling(workspaceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncBillingMutationResult = NonNullable<Awaited<ReturnType<typeof syncBilling>>>

    export type SyncBillingMutationError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>

    /**
 * @summary Recompute usage and push quantities to Stripe (owner only)
 */
export const useSyncBilling = <TError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncBilling>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncBilling>>,
        TError,
        {workspaceId: string},
        TContext
      > => {
      return useMutation(getSyncBillingMutationOptions(options));
    }

export const getUpdateDevicePolicyUrl = (workspaceId: string,
    deviceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/${deviceId}/policy`
}

/**
 * @summary Update on-device control policy and kiosk exit PIN
 */
export const updateDevicePolicy = async (workspaceId: string,
    deviceId: string,
    devicePolicyUpdate: DevicePolicyUpdate, options?: RequestInit): Promise<Device> => {

  return customFetch<Device>(getUpdateDevicePolicyUrl(workspaceId,deviceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      devicePolicyUpdate,)
  }
);}




export const getUpdateDevicePolicyMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDevicePolicy>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DevicePolicyUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDevicePolicy>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DevicePolicyUpdate>}, TContext> => {

const mutationKey = ['updateDevicePolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDevicePolicy>>, {workspaceId: string;deviceId: string;data: BodyType<DevicePolicyUpdate>}> = (props) => {
          const {workspaceId,deviceId,data} = props ?? {};

          return  updateDevicePolicy(workspaceId,deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDevicePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof updateDevicePolicy>>>
    export type UpdateDevicePolicyMutationBody = BodyType<DevicePolicyUpdate>
    export type UpdateDevicePolicyMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update on-device control policy and kiosk exit PIN
 */
export const useUpdateDevicePolicy = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDevicePolicy>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DevicePolicyUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDevicePolicy>>,
        TError,
        {workspaceId: string;deviceId: string;data: BodyType<DevicePolicyUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDevicePolicyMutationOptions(options));
    }

export const getUpdateDeviceFeaturesUrl = (workspaceId: string,
    deviceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/${deviceId}/features`
}

/**
 * @summary Toggle premium features (live broadcast, DJ mode) on a device
 */
export const updateDeviceFeatures = async (workspaceId: string,
    deviceId: string,
    deviceFeaturesUpdate: DeviceFeaturesUpdate, options?: RequestInit): Promise<Device> => {

  return customFetch<Device>(getUpdateDeviceFeaturesUrl(workspaceId,deviceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceFeaturesUpdate,)
  }
);}




export const getUpdateDeviceFeaturesMutationOptions = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceFeatures>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceFeaturesUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDeviceFeatures>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceFeaturesUpdate>}, TContext> => {

const mutationKey = ['updateDeviceFeatures'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDeviceFeatures>>, {workspaceId: string;deviceId: string;data: BodyType<DeviceFeaturesUpdate>}> = (props) => {
          const {workspaceId,deviceId,data} = props ?? {};

          return  updateDeviceFeatures(workspaceId,deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDeviceFeaturesMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeviceFeatures>>>
    export type UpdateDeviceFeaturesMutationBody = BodyType<DeviceFeaturesUpdate>
    export type UpdateDeviceFeaturesMutationError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Toggle premium features (live broadcast, DJ mode) on a device
 */
export const useUpdateDeviceFeatures = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceFeatures>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceFeaturesUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDeviceFeatures>>,
        TError,
        {workspaceId: string;deviceId: string;data: BodyType<DeviceFeaturesUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDeviceFeaturesMutationOptions(options));
    }

export const getUpdateDeviceDisplayUrl = (workspaceId: string,
    deviceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/${deviceId}/display`
}

/**
 * @summary Update display/output settings (aspect fit, orientation, zoom, volume, mute)
 */
export const updateDeviceDisplay = async (workspaceId: string,
    deviceId: string,
    deviceDisplaySettingsInput: DeviceDisplaySettingsInput, options?: RequestInit): Promise<Device> => {

  return customFetch<Device>(getUpdateDeviceDisplayUrl(workspaceId,deviceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceDisplaySettingsInput,)
  }
);}




export const getUpdateDeviceDisplayMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceDisplay>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceDisplaySettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDeviceDisplay>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceDisplaySettingsInput>}, TContext> => {

const mutationKey = ['updateDeviceDisplay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDeviceDisplay>>, {workspaceId: string;deviceId: string;data: BodyType<DeviceDisplaySettingsInput>}> = (props) => {
          const {workspaceId,deviceId,data} = props ?? {};

          return  updateDeviceDisplay(workspaceId,deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDeviceDisplayMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeviceDisplay>>>
    export type UpdateDeviceDisplayMutationBody = BodyType<DeviceDisplaySettingsInput>
    export type UpdateDeviceDisplayMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update display/output settings (aspect fit, orientation, zoom, volume, mute)
 */
export const useUpdateDeviceDisplay = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeviceDisplay>>, TError,{workspaceId: string;deviceId: string;data: BodyType<DeviceDisplaySettingsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDeviceDisplay>>,
        TError,
        {workspaceId: string;deviceId: string;data: BodyType<DeviceDisplaySettingsInput>},
        TContext
      > => {
      return useMutation(getUpdateDeviceDisplayMutationOptions(options));
    }

export const getListBroadcastsUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/broadcasts`
}

/**
 * @summary Broadcast history (most recent first)
 */
export const listBroadcasts = async (workspaceId: string, options?: RequestInit): Promise<BroadcastListItem[]> => {

  return customFetch<BroadcastListItem[]>(getListBroadcastsUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBroadcastsQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/broadcasts`
    ] as const;
    }


export const getListBroadcastsQueryOptions = <TData = Awaited<ReturnType<typeof listBroadcasts>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBroadcasts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBroadcastsQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBroadcasts>>> = ({ signal }) => listBroadcasts(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBroadcasts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBroadcastsQueryResult = NonNullable<Awaited<ReturnType<typeof listBroadcasts>>>
export type ListBroadcastsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Broadcast history (most recent first)
 */

export function useListBroadcasts<TData = Awaited<ReturnType<typeof listBroadcasts>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBroadcasts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBroadcastsQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getStartBroadcastUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/broadcasts`
}

/**
 * @summary Start a live broadcast to targeted devices (manager+, paid feature)
 */
export const startBroadcast = async (workspaceId: string,
    broadcastStartInput: BroadcastStartInput, options?: RequestInit): Promise<BroadcastStartResponse> => {

  return customFetch<BroadcastStartResponse>(getStartBroadcastUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      broadcastStartInput,)
  }
);}




export const getStartBroadcastMutationOptions = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startBroadcast>>, TError,{workspaceId: string;data: BodyType<BroadcastStartInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startBroadcast>>, TError,{workspaceId: string;data: BodyType<BroadcastStartInput>}, TContext> => {

const mutationKey = ['startBroadcast'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startBroadcast>>, {workspaceId: string;data: BodyType<BroadcastStartInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  startBroadcast(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartBroadcastMutationResult = NonNullable<Awaited<ReturnType<typeof startBroadcast>>>
    export type StartBroadcastMutationBody = BodyType<BroadcastStartInput>
    export type StartBroadcastMutationError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | ErrorResponse>

    /**
 * @summary Start a live broadcast to targeted devices (manager+, paid feature)
 */
export const useStartBroadcast = <TError = ErrorType<BadRequestResponse | PaymentRequiredResponse | ForbiddenResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startBroadcast>>, TError,{workspaceId: string;data: BodyType<BroadcastStartInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startBroadcast>>,
        TError,
        {workspaceId: string;data: BodyType<BroadcastStartInput>},
        TContext
      > => {
      return useMutation(getStartBroadcastMutationOptions(options));
    }

export const getGetBroadcastIceServersUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/broadcasts/ice-servers`
}

/**
 * @summary ICE servers (STUN/TURN) for originating a broadcast
 */
export const getBroadcastIceServers = async (workspaceId: string, options?: RequestInit): Promise<IceServersResponse> => {

  return customFetch<IceServersResponse>(getGetBroadcastIceServersUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBroadcastIceServersQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/broadcasts/ice-servers`
    ] as const;
    }


export const getGetBroadcastIceServersQueryOptions = <TData = Awaited<ReturnType<typeof getBroadcastIceServers>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBroadcastIceServers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBroadcastIceServersQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBroadcastIceServers>>> = ({ signal }) => getBroadcastIceServers(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBroadcastIceServers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBroadcastIceServersQueryResult = NonNullable<Awaited<ReturnType<typeof getBroadcastIceServers>>>
export type GetBroadcastIceServersQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary ICE servers (STUN/TURN) for originating a broadcast
 */

export function useGetBroadcastIceServers<TData = Awaited<ReturnType<typeof getBroadcastIceServers>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBroadcastIceServers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBroadcastIceServersQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getEndBroadcastUrl = (workspaceId: string,
    broadcastId: string,) => {




  return `/api/workspaces/${workspaceId}/broadcasts/${broadcastId}/end`
}

/**
 * @summary End a live broadcast and record its duration
 */
export const endBroadcast = async (workspaceId: string,
    broadcastId: string, options?: RequestInit): Promise<Broadcast> => {

  return customFetch<Broadcast>(getEndBroadcastUrl(workspaceId,broadcastId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getEndBroadcastMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endBroadcast>>, TError,{workspaceId: string;broadcastId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof endBroadcast>>, TError,{workspaceId: string;broadcastId: string}, TContext> => {

const mutationKey = ['endBroadcast'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endBroadcast>>, {workspaceId: string;broadcastId: string}> = (props) => {
          const {workspaceId,broadcastId} = props ?? {};

          return  endBroadcast(workspaceId,broadcastId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndBroadcastMutationResult = NonNullable<Awaited<ReturnType<typeof endBroadcast>>>

    export type EndBroadcastMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary End a live broadcast and record its duration
 */
export const useEndBroadcast = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endBroadcast>>, TError,{workspaceId: string;broadcastId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof endBroadcast>>,
        TError,
        {workspaceId: string;broadcastId: string},
        TContext
      > => {
      return useMutation(getEndBroadcastMutationOptions(options));
    }

export const getListPlayLogsUrl = (workspaceId: string,
    params?: ListPlayLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/play-logs?${stringifiedParams}` : `/api/workspaces/${workspaceId}/play-logs`
}

/**
 * @summary Playback history (what played, where, when) — most recent first
 */
export const listPlayLogs = async (workspaceId: string,
    params?: ListPlayLogsParams, options?: RequestInit): Promise<PlayLog[] | string> => {

  return customFetch<PlayLog[] | string>(getListPlayLogsUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlayLogsQueryKey = (workspaceId: string,
    params?: ListPlayLogsParams,) => {
    return [
    `/api/workspaces/${workspaceId}/play-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPlayLogsQueryOptions = <TData = Awaited<ReturnType<typeof listPlayLogs>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: ListPlayLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlayLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlayLogsQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlayLogs>>> = ({ signal }) => listPlayLogs(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlayLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPlayLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlayLogs>>>
export type ListPlayLogsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Playback history (what played, where, when) — most recent first
 */

export function useListPlayLogs<TData = Awaited<ReturnType<typeof listPlayLogs>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: ListPlayLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlayLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPlayLogsQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListDeviceEventsUrl = (workspaceId: string,
    params?: ListDeviceEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/device-events?${stringifiedParams}` : `/api/workspaces/${workspaceId}/device-events`
}

/**
 * @summary Device event history (heartbeat, status, errors, commands) — most recent first
 */
export const listDeviceEvents = async (workspaceId: string,
    params?: ListDeviceEventsParams, options?: RequestInit): Promise<DeviceEvent[] | string> => {

  return customFetch<DeviceEvent[] | string>(getListDeviceEventsUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDeviceEventsQueryKey = (workspaceId: string,
    params?: ListDeviceEventsParams,) => {
    return [
    `/api/workspaces/${workspaceId}/device-events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDeviceEventsQueryOptions = <TData = Awaited<ReturnType<typeof listDeviceEvents>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: ListDeviceEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDeviceEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDeviceEventsQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDeviceEvents>>> = ({ signal }) => listDeviceEvents(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDeviceEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDeviceEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listDeviceEvents>>>
export type ListDeviceEventsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Device event history (heartbeat, status, errors, commands) — most recent first
 */

export function useListDeviceEvents<TData = Awaited<ReturnType<typeof listDeviceEvents>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: ListDeviceEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDeviceEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDeviceEventsQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAuditLogsUrl = (workspaceId: string,
    params?: ListAuditLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/audit-logs?${stringifiedParams}` : `/api/workspaces/${workspaceId}/audit-logs`
}

/**
 * People-only history: every audited mutation with its actor resolved to a name. Device telemetry (heartbeats, now-playing) is deliberately not merged in — it lives in the device-events feed and would otherwise bury every human action. Scoped operators see changes to the players and locations in their scope plus their own actions.
 * @summary Audit trail — who changed what, most recent first
 */
export const listAuditLogs = async (workspaceId: string,
    params?: ListAuditLogsParams, options?: RequestInit): Promise<AuditLogList | string> => {

  return customFetch<AuditLogList | string>(getListAuditLogsUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditLogsQueryKey = (workspaceId: string,
    params?: ListAuditLogsParams,) => {
    return [
    `/api/workspaces/${workspaceId}/audit-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: ListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogsQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({ signal }) => listAuditLogs(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogs>>>
export type ListAuditLogsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Audit trail — who changed what, most recent first
 */

export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: ListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAuditLogsQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetPlaysReportUrl = (workspaceId: string,
    params?: GetPlaysReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/reports/plays?${stringifiedParams}` : `/api/workspaces/${workspaceId}/reports/plays`
}

/**
 * @summary Aggregated play counts (proof-of-play) grouped by track, playlist, device, or location
 */
export const getPlaysReport = async (workspaceId: string,
    params?: GetPlaysReportParams, options?: RequestInit): Promise<PlayReportRow[] | string> => {

  return customFetch<PlayReportRow[] | string>(getGetPlaysReportUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlaysReportQueryKey = (workspaceId: string,
    params?: GetPlaysReportParams,) => {
    return [
    `/api/workspaces/${workspaceId}/reports/plays`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlaysReportQueryOptions = <TData = Awaited<ReturnType<typeof getPlaysReport>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: GetPlaysReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlaysReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlaysReportQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlaysReport>>> = ({ signal }) => getPlaysReport(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlaysReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlaysReportQueryResult = NonNullable<Awaited<ReturnType<typeof getPlaysReport>>>
export type GetPlaysReportQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Aggregated play counts (proof-of-play) grouped by track, playlist, device, or location
 */

export function useGetPlaysReport<TData = Awaited<ReturnType<typeof getPlaysReport>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: GetPlaysReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlaysReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlaysReportQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetUptimeReportUrl = (workspaceId: string,
    params?: GetUptimeReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/reports/uptime?${stringifiedParams}` : `/api/workspaces/${workspaceId}/reports/uptime`
}

/**
 * @summary Per-device connectivity report paired from connect/disconnect events
 */
export const getUptimeReport = async (workspaceId: string,
    params?: GetUptimeReportParams, options?: RequestInit): Promise<DeviceUptimeRow[] | string> => {

  return customFetch<DeviceUptimeRow[] | string>(getGetUptimeReportUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUptimeReportQueryKey = (workspaceId: string,
    params?: GetUptimeReportParams,) => {
    return [
    `/api/workspaces/${workspaceId}/reports/uptime`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUptimeReportQueryOptions = <TData = Awaited<ReturnType<typeof getUptimeReport>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: GetUptimeReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUptimeReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUptimeReportQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUptimeReport>>> = ({ signal }) => getUptimeReport(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUptimeReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUptimeReportQueryResult = NonNullable<Awaited<ReturnType<typeof getUptimeReport>>>
export type GetUptimeReportQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Per-device connectivity report paired from connect/disconnect events
 */

export function useGetUptimeReport<TData = Awaited<ReturnType<typeof getUptimeReport>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: GetUptimeReportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUptimeReport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUptimeReportQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetWorkspaceUsageUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/usage`
}

/**
 * @summary Rollup of everything bundled in the flat plan — storage, broadcasts, devices, TTS
 */
export const getWorkspaceUsage = async (workspaceId: string, options?: RequestInit): Promise<WorkspaceUsage> => {

  return customFetch<WorkspaceUsage>(getGetWorkspaceUsageUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkspaceUsageQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/usage`
    ] as const;
    }


export const getGetWorkspaceUsageQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceUsage>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceUsageQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceUsage>>> = ({ signal }) => getWorkspaceUsage(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkspaceUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceUsage>>>
export type GetWorkspaceUsageQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Rollup of everything bundled in the flat plan — storage, broadcasts, devices, TTS
 */

export function useGetWorkspaceUsage<TData = Awaited<ReturnType<typeof getWorkspaceUsage>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWorkspaceUsageQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDeviceDiagnosticsUrl = (workspaceId: string,
    deviceId: string,) => {




  return `/api/workspaces/${workspaceId}/devices/${deviceId}/diagnostics`
}

/**
 * @summary Per-device diagnostics composed from heartbeat/status/playback/events
 */
export const getDeviceDiagnostics = async (workspaceId: string,
    deviceId: string, options?: RequestInit): Promise<DeviceDiagnostics> => {

  return customFetch<DeviceDiagnostics>(getGetDeviceDiagnosticsUrl(workspaceId,deviceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDeviceDiagnosticsQueryKey = (workspaceId: string,
    deviceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/devices/${deviceId}/diagnostics`
    ] as const;
    }


export const getGetDeviceDiagnosticsQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceDiagnostics>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    deviceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceDiagnostics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceDiagnosticsQueryKey(workspaceId,deviceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceDiagnostics>>> = ({ signal }) => getDeviceDiagnostics(workspaceId,deviceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && deviceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceDiagnostics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDeviceDiagnosticsQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceDiagnostics>>>
export type GetDeviceDiagnosticsQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Per-device diagnostics composed from heartbeat/status/playback/events
 */

export function useGetDeviceDiagnostics<TData = Awaited<ReturnType<typeof getDeviceDiagnostics>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    deviceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceDiagnostics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDeviceDiagnosticsQueryOptions(workspaceId,deviceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getProvisionOnboardingUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/onboarding`
}

/**
 * @summary Provision a first working setup from a venue profile (admin+)
 */
export const provisionOnboarding = async (workspaceId: string,
    onboardingInput: OnboardingInput, options?: RequestInit): Promise<OnboardingResult> => {

  return customFetch<OnboardingResult>(getProvisionOnboardingUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      onboardingInput,)
  }
);}




export const getProvisionOnboardingMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionOnboarding>>, TError,{workspaceId: string;data: BodyType<OnboardingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof provisionOnboarding>>, TError,{workspaceId: string;data: BodyType<OnboardingInput>}, TContext> => {

const mutationKey = ['provisionOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof provisionOnboarding>>, {workspaceId: string;data: BodyType<OnboardingInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  provisionOnboarding(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProvisionOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof provisionOnboarding>>>
    export type ProvisionOnboardingMutationBody = BodyType<OnboardingInput>
    export type ProvisionOnboardingMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Provision a first working setup from a venue profile (admin+)
 */
export const useProvisionOnboarding = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionOnboarding>>, TError,{workspaceId: string;data: BodyType<OnboardingInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof provisionOnboarding>>,
        TError,
        {workspaceId: string;data: BodyType<OnboardingInput>},
        TContext
      > => {
      return useMutation(getProvisionOnboardingMutationOptions(options));
    }

export const getSkipOnboardingUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/onboarding/skip`
}

/**
 * @summary Mark onboarding as completed without provisioning (admin+)
 */
export const skipOnboarding = async (workspaceId: string, options?: RequestInit): Promise<OnboardingResult> => {

  return customFetch<OnboardingResult>(getSkipOnboardingUrl(workspaceId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSkipOnboardingMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipOnboarding>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skipOnboarding>>, TError,{workspaceId: string}, TContext> => {

const mutationKey = ['skipOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipOnboarding>>, {workspaceId: string}> = (props) => {
          const {workspaceId} = props ?? {};

          return  skipOnboarding(workspaceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof skipOnboarding>>>

    export type SkipOnboardingMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Mark onboarding as completed without provisioning (admin+)
 */
export const useSkipOnboarding = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipOnboarding>>, TError,{workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof skipOnboarding>>,
        TError,
        {workspaceId: string},
        TContext
      > => {
      return useMutation(getSkipOnboardingMutationOptions(options));
    }

export const getListCalendarPresetsUrl = (workspaceId: string,
    params?: ListCalendarPresetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/calendar/presets?${stringifiedParams}` : `/api/workspaces/${workspaceId}/calendar/presets`
}

/**
 * @summary List preset calendar days for exceptions and overrides
 */
export const listCalendarPresets = async (workspaceId: string,
    params?: ListCalendarPresetsParams, options?: RequestInit): Promise<ListCalendarPresetsResponse> => {

  return customFetch<ListCalendarPresetsResponse>(getListCalendarPresetsUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCalendarPresetsQueryKey = (workspaceId: string,
    params?: ListCalendarPresetsParams,) => {
    return [
    `/api/workspaces/${workspaceId}/calendar/presets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCalendarPresetsQueryOptions = <TData = Awaited<ReturnType<typeof listCalendarPresets>>, TError = ErrorType<BadRequestResponse>>(workspaceId: string,
    params?: ListCalendarPresetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarPresets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCalendarPresetsQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendarPresets>>> = ({ signal }) => listCalendarPresets(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCalendarPresets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCalendarPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendarPresets>>>
export type ListCalendarPresetsQueryError = ErrorType<BadRequestResponse>


/**
 * @summary List preset calendar days for exceptions and overrides
 */

export function useListCalendarPresets<TData = Awaited<ReturnType<typeof listCalendarPresets>>, TError = ErrorType<BadRequestResponse>>(
 workspaceId: string,
    params?: ListCalendarPresetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarPresets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCalendarPresetsQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListTicketsUrl = (workspaceId: string,
    params?: ListTicketsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/tickets?${stringifiedParams}` : `/api/workspaces/${workspaceId}/tickets`
}

/**
 * @summary List support tickets (most recent first)
 */
export const listTickets = async (workspaceId: string,
    params?: ListTicketsParams, options?: RequestInit): Promise<SupportTicket[]> => {

  return customFetch<SupportTicket[]>(getListTicketsUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTicketsQueryKey = (workspaceId: string,
    params?: ListTicketsParams,) => {
    return [
    `/api/workspaces/${workspaceId}/tickets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTicketsQueryOptions = <TData = Awaited<ReturnType<typeof listTickets>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: ListTicketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTickets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTicketsQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTickets>>> = ({ signal }) => listTickets(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTickets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTicketsQueryResult = NonNullable<Awaited<ReturnType<typeof listTickets>>>
export type ListTicketsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List support tickets (most recent first)
 */

export function useListTickets<TData = Awaited<ReturnType<typeof listTickets>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: ListTicketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTickets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTicketsQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTicketUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/tickets`
}

/**
 * @summary Open a support ticket
 */
export const createTicket = async (workspaceId: string,
    ticketInput: TicketInput, options?: RequestInit): Promise<SupportTicket> => {

  return customFetch<SupportTicket>(getCreateTicketUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketInput,)
  }
);}




export const getCreateTicketMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTicket>>, TError,{workspaceId: string;data: BodyType<TicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTicket>>, TError,{workspaceId: string;data: BodyType<TicketInput>}, TContext> => {

const mutationKey = ['createTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTicket>>, {workspaceId: string;data: BodyType<TicketInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createTicket(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTicketMutationResult = NonNullable<Awaited<ReturnType<typeof createTicket>>>
    export type CreateTicketMutationBody = BodyType<TicketInput>
    export type CreateTicketMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Open a support ticket
 */
export const useCreateTicket = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTicket>>, TError,{workspaceId: string;data: BodyType<TicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTicket>>,
        TError,
        {workspaceId: string;data: BodyType<TicketInput>},
        TContext
      > => {
      return useMutation(getCreateTicketMutationOptions(options));
    }

export const getGetTicketUrl = (workspaceId: string,
    ticketId: string,) => {




  return `/api/workspaces/${workspaceId}/tickets/${ticketId}`
}

/**
 * @summary Get a support ticket with its comment thread
 */
export const getTicket = async (workspaceId: string,
    ticketId: string, options?: RequestInit): Promise<TicketDetail> => {

  return customFetch<TicketDetail>(getGetTicketUrl(workspaceId,ticketId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTicketQueryKey = (workspaceId: string,
    ticketId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/tickets/${ticketId}`
    ] as const;
    }


export const getGetTicketQueryOptions = <TData = Awaited<ReturnType<typeof getTicket>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    ticketId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTicket>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTicketQueryKey(workspaceId,ticketId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTicket>>> = ({ signal }) => getTicket(workspaceId,ticketId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && ticketId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTicket>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTicketQueryResult = NonNullable<Awaited<ReturnType<typeof getTicket>>>
export type GetTicketQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get a support ticket with its comment thread
 */

export function useGetTicket<TData = Awaited<ReturnType<typeof getTicket>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    ticketId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTicket>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTicketQueryOptions(workspaceId,ticketId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateTicketUrl = (workspaceId: string,
    ticketId: string,) => {




  return `/api/workspaces/${workspaceId}/tickets/${ticketId}`
}

/**
 * @summary Update a ticket's status or priority (admin+)
 */
export const updateTicket = async (workspaceId: string,
    ticketId: string,
    ticketUpdate: TicketUpdate, options?: RequestInit): Promise<SupportTicket> => {

  return customFetch<SupportTicket>(getUpdateTicketUrl(workspaceId,ticketId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketUpdate,)
  }
);}




export const getUpdateTicketMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTicket>>, TError,{workspaceId: string;ticketId: string;data: BodyType<TicketUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTicket>>, TError,{workspaceId: string;ticketId: string;data: BodyType<TicketUpdate>}, TContext> => {

const mutationKey = ['updateTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTicket>>, {workspaceId: string;ticketId: string;data: BodyType<TicketUpdate>}> = (props) => {
          const {workspaceId,ticketId,data} = props ?? {};

          return  updateTicket(workspaceId,ticketId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTicketMutationResult = NonNullable<Awaited<ReturnType<typeof updateTicket>>>
    export type UpdateTicketMutationBody = BodyType<TicketUpdate>
    export type UpdateTicketMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a ticket's status or priority (admin+)
 */
export const useUpdateTicket = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTicket>>, TError,{workspaceId: string;ticketId: string;data: BodyType<TicketUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTicket>>,
        TError,
        {workspaceId: string;ticketId: string;data: BodyType<TicketUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTicketMutationOptions(options));
    }

export const getCreateTicketCommentUrl = (workspaceId: string,
    ticketId: string,) => {




  return `/api/workspaces/${workspaceId}/tickets/${ticketId}/comments`
}

/**
 * @summary Add a comment to a support ticket
 */
export const createTicketComment = async (workspaceId: string,
    ticketId: string,
    ticketCommentInput: TicketCommentInput, options?: RequestInit): Promise<TicketComment> => {

  return customFetch<TicketComment>(getCreateTicketCommentUrl(workspaceId,ticketId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketCommentInput,)
  }
);}




export const getCreateTicketCommentMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTicketComment>>, TError,{workspaceId: string;ticketId: string;data: BodyType<TicketCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTicketComment>>, TError,{workspaceId: string;ticketId: string;data: BodyType<TicketCommentInput>}, TContext> => {

const mutationKey = ['createTicketComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTicketComment>>, {workspaceId: string;ticketId: string;data: BodyType<TicketCommentInput>}> = (props) => {
          const {workspaceId,ticketId,data} = props ?? {};

          return  createTicketComment(workspaceId,ticketId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTicketCommentMutationResult = NonNullable<Awaited<ReturnType<typeof createTicketComment>>>
    export type CreateTicketCommentMutationBody = BodyType<TicketCommentInput>
    export type CreateTicketCommentMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Add a comment to a support ticket
 */
export const useCreateTicketComment = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTicketComment>>, TError,{workspaceId: string;ticketId: string;data: BodyType<TicketCommentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTicketComment>>,
        TError,
        {workspaceId: string;ticketId: string;data: BodyType<TicketCommentInput>},
        TContext
      > => {
      return useMutation(getCreateTicketCommentMutationOptions(options));
    }

export const getEscalateTicketUrl = (workspaceId: string,
    ticketId: string,) => {




  return `/api/workspaces/${workspaceId}/tickets/${ticketId}/escalate`
}

/**
 * Marks the ticket escalated so it appears in the platform operator's cross-tenant support inbox. Idempotence: a second call returns 409 (the ticket is already escalated). The operator notification email is best-effort — escalation records even when email is not configured.

 * @summary Escalate a ticket to the OmniMedia platform team (author or manage.support)
 */
export const escalateTicket = async (workspaceId: string,
    ticketId: string, options?: RequestInit): Promise<SupportTicket> => {

  return customFetch<SupportTicket>(getEscalateTicketUrl(workspaceId,ticketId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getEscalateTicketMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof escalateTicket>>, TError,{workspaceId: string;ticketId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof escalateTicket>>, TError,{workspaceId: string;ticketId: string}, TContext> => {

const mutationKey = ['escalateTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof escalateTicket>>, {workspaceId: string;ticketId: string}> = (props) => {
          const {workspaceId,ticketId} = props ?? {};

          return  escalateTicket(workspaceId,ticketId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EscalateTicketMutationResult = NonNullable<Awaited<ReturnType<typeof escalateTicket>>>

    export type EscalateTicketMutationError = ErrorType<ForbiddenResponse | NotFoundResponse | ConflictResponse>

    /**
 * @summary Escalate a ticket to the OmniMedia platform team (author or manage.support)
 */
export const useEscalateTicket = <TError = ErrorType<ForbiddenResponse | NotFoundResponse | ConflictResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof escalateTicket>>, TError,{workspaceId: string;ticketId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof escalateTicket>>,
        TError,
        {workspaceId: string;ticketId: string},
        TContext
      > => {
      return useMutation(getEscalateTicketMutationOptions(options));
    }

export const getListPlaylistsUrl = (workspaceId: string,
    params?: ListPlaylistsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/playlists?${stringifiedParams}` : `/api/workspaces/${workspaceId}/playlists`
}

/**
 * @summary List playlists
 */
export const listPlaylists = async (workspaceId: string,
    params?: ListPlaylistsParams, options?: RequestInit): Promise<Playlist[]> => {

  return customFetch<Playlist[]>(getListPlaylistsUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlaylistsQueryKey = (workspaceId: string,
    params?: ListPlaylistsParams,) => {
    return [
    `/api/workspaces/${workspaceId}/playlists`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPlaylistsQueryOptions = <TData = Awaited<ReturnType<typeof listPlaylists>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: ListPlaylistsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlaylists>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlaylistsQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlaylists>>> = ({ signal }) => listPlaylists(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlaylists>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPlaylistsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlaylists>>>
export type ListPlaylistsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List playlists
 */

export function useListPlaylists<TData = Awaited<ReturnType<typeof listPlaylists>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: ListPlaylistsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlaylists>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPlaylistsQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePlaylistUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists`
}

/**
 * @summary Create a playlist
 */
export const createPlaylist = async (workspaceId: string,
    playlistInput: PlaylistInput, options?: RequestInit): Promise<Playlist> => {

  return customFetch<Playlist>(getCreatePlaylistUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      playlistInput,)
  }
);}




export const getCreatePlaylistMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlaylist>>, TError,{workspaceId: string;data: BodyType<PlaylistInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPlaylist>>, TError,{workspaceId: string;data: BodyType<PlaylistInput>}, TContext> => {

const mutationKey = ['createPlaylist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlaylist>>, {workspaceId: string;data: BodyType<PlaylistInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createPlaylist(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePlaylistMutationResult = NonNullable<Awaited<ReturnType<typeof createPlaylist>>>
    export type CreatePlaylistMutationBody = BodyType<PlaylistInput>
    export type CreatePlaylistMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Create a playlist
 */
export const useCreatePlaylist = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlaylist>>, TError,{workspaceId: string;data: BodyType<PlaylistInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPlaylist>>,
        TError,
        {workspaceId: string;data: BodyType<PlaylistInput>},
        TContext
      > => {
      return useMutation(getCreatePlaylistMutationOptions(options));
    }

export const getMergePlaylistsUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists/merge`
}

/**
 * @summary Merge playlists into a new editable user playlist
 */
export const mergePlaylists = async (workspaceId: string,
    mergePlaylistsInput: MergePlaylistsInput, options?: RequestInit): Promise<Playlist> => {

  return customFetch<Playlist>(getMergePlaylistsUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mergePlaylistsInput,)
  }
);}




export const getMergePlaylistsMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergePlaylists>>, TError,{workspaceId: string;data: BodyType<MergePlaylistsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mergePlaylists>>, TError,{workspaceId: string;data: BodyType<MergePlaylistsInput>}, TContext> => {

const mutationKey = ['mergePlaylists'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergePlaylists>>, {workspaceId: string;data: BodyType<MergePlaylistsInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  mergePlaylists(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MergePlaylistsMutationResult = NonNullable<Awaited<ReturnType<typeof mergePlaylists>>>
    export type MergePlaylistsMutationBody = BodyType<MergePlaylistsInput>
    export type MergePlaylistsMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Merge playlists into a new editable user playlist
 */
export const useMergePlaylists = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergePlaylists>>, TError,{workspaceId: string;data: BodyType<MergePlaylistsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof mergePlaylists>>,
        TError,
        {workspaceId: string;data: BodyType<MergePlaylistsInput>},
        TContext
      > => {
      return useMutation(getMergePlaylistsMutationOptions(options));
    }

export const getPreviewSmartPlaylistRulesUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists/preview-rules`
}

/**
 * @summary Preview how many catalogue tracks a set of station rules selects
 */
export const previewSmartPlaylistRules = async (workspaceId: string,
    playlistRulesPreviewInput: PlaylistRulesPreviewInput, options?: RequestInit): Promise<PlaylistRulesPreview> => {

  return customFetch<PlaylistRulesPreview>(getPreviewSmartPlaylistRulesUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      playlistRulesPreviewInput,)
  }
);}




export const getPreviewSmartPlaylistRulesMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewSmartPlaylistRules>>, TError,{workspaceId: string;data: BodyType<PlaylistRulesPreviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewSmartPlaylistRules>>, TError,{workspaceId: string;data: BodyType<PlaylistRulesPreviewInput>}, TContext> => {

const mutationKey = ['previewSmartPlaylistRules'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewSmartPlaylistRules>>, {workspaceId: string;data: BodyType<PlaylistRulesPreviewInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  previewSmartPlaylistRules(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewSmartPlaylistRulesMutationResult = NonNullable<Awaited<ReturnType<typeof previewSmartPlaylistRules>>>
    export type PreviewSmartPlaylistRulesMutationBody = BodyType<PlaylistRulesPreviewInput>
    export type PreviewSmartPlaylistRulesMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Preview how many catalogue tracks a set of station rules selects
 */
export const usePreviewSmartPlaylistRules = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewSmartPlaylistRules>>, TError,{workspaceId: string;data: BodyType<PlaylistRulesPreviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewSmartPlaylistRules>>,
        TError,
        {workspaceId: string;data: BodyType<PlaylistRulesPreviewInput>},
        TContext
      > => {
      return useMutation(getPreviewSmartPlaylistRulesMutationOptions(options));
    }

export const getBuildStationFromPromptUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists/build-from-prompt`
}

/**
 * Turns a free-text vibe description ("laid-back Sunday brunch, no vocals, mid tempo") into proposed smart-playlist rules. Every proposed value is validated against the live catalogue facet vocabulary (/catalogue/facets); values the model invented are stripped from `rules` and reported in `dropped`. Nothing is created — feed the returned rules into the normal station create/update flow. Requires the music-channel playlist capability (stations are music-only).

 * @summary Draft station rules from a natural-language description (AI)
 */
export const buildStationFromPrompt = async (workspaceId: string,
    stationBuildInput: StationBuildInput, options?: RequestInit): Promise<StationBuildResult> => {

  return customFetch<StationBuildResult>(getBuildStationFromPromptUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      stationBuildInput,)
  }
);}




export const getBuildStationFromPromptMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | BadGatewayResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof buildStationFromPrompt>>, TError,{workspaceId: string;data: BodyType<StationBuildInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof buildStationFromPrompt>>, TError,{workspaceId: string;data: BodyType<StationBuildInput>}, TContext> => {

const mutationKey = ['buildStationFromPrompt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof buildStationFromPrompt>>, {workspaceId: string;data: BodyType<StationBuildInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  buildStationFromPrompt(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BuildStationFromPromptMutationResult = NonNullable<Awaited<ReturnType<typeof buildStationFromPrompt>>>
    export type BuildStationFromPromptMutationBody = BodyType<StationBuildInput>
    export type BuildStationFromPromptMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | BadGatewayResponse | ServiceUnavailableResponse>

    /**
 * @summary Draft station rules from a natural-language description (AI)
 */
export const useBuildStationFromPrompt = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | BadGatewayResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof buildStationFromPrompt>>, TError,{workspaceId: string;data: BodyType<StationBuildInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof buildStationFromPrompt>>,
        TError,
        {workspaceId: string;data: BodyType<StationBuildInput>},
        TContext
      > => {
      return useMutation(getBuildStationFromPromptMutationOptions(options));
    }

export const getGetPlaylistUrl = (workspaceId: string,
    playlistId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists/${playlistId}`
}

/**
 * @summary Get a playlist with its items
 */
export const getPlaylist = async (workspaceId: string,
    playlistId: string, options?: RequestInit): Promise<PlaylistDetail> => {

  return customFetch<PlaylistDetail>(getGetPlaylistUrl(workspaceId,playlistId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlaylistQueryKey = (workspaceId: string,
    playlistId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/playlists/${playlistId}`
    ] as const;
    }


export const getGetPlaylistQueryOptions = <TData = Awaited<ReturnType<typeof getPlaylist>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    playlistId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlaylist>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlaylistQueryKey(workspaceId,playlistId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlaylist>>> = ({ signal }) => getPlaylist(workspaceId,playlistId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && playlistId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlaylist>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlaylistQueryResult = NonNullable<Awaited<ReturnType<typeof getPlaylist>>>
export type GetPlaylistQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get a playlist with its items
 */

export function useGetPlaylist<TData = Awaited<ReturnType<typeof getPlaylist>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    playlistId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlaylist>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlaylistQueryOptions(workspaceId,playlistId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePlaylistUrl = (workspaceId: string,
    playlistId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists/${playlistId}`
}

/**
 * @summary Update a playlist
 */
export const updatePlaylist = async (workspaceId: string,
    playlistId: string,
    playlistUpdate: PlaylistUpdate, options?: RequestInit): Promise<Playlist> => {

  return customFetch<Playlist>(getUpdatePlaylistUrl(workspaceId,playlistId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      playlistUpdate,)
  }
);}




export const getUpdatePlaylistMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlaylist>>, TError,{workspaceId: string;playlistId: string;data: BodyType<PlaylistUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePlaylist>>, TError,{workspaceId: string;playlistId: string;data: BodyType<PlaylistUpdate>}, TContext> => {

const mutationKey = ['updatePlaylist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlaylist>>, {workspaceId: string;playlistId: string;data: BodyType<PlaylistUpdate>}> = (props) => {
          const {workspaceId,playlistId,data} = props ?? {};

          return  updatePlaylist(workspaceId,playlistId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlaylistMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlaylist>>>
    export type UpdatePlaylistMutationBody = BodyType<PlaylistUpdate>
    export type UpdatePlaylistMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a playlist
 */
export const useUpdatePlaylist = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlaylist>>, TError,{workspaceId: string;playlistId: string;data: BodyType<PlaylistUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlaylist>>,
        TError,
        {workspaceId: string;playlistId: string;data: BodyType<PlaylistUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePlaylistMutationOptions(options));
    }

export const getDeletePlaylistUrl = (workspaceId: string,
    playlistId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists/${playlistId}`
}

/**
 * @summary Delete a playlist
 */
export const deletePlaylist = async (workspaceId: string,
    playlistId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeletePlaylistUrl(workspaceId,playlistId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePlaylistMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlaylist>>, TError,{workspaceId: string;playlistId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePlaylist>>, TError,{workspaceId: string;playlistId: string}, TContext> => {

const mutationKey = ['deletePlaylist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePlaylist>>, {workspaceId: string;playlistId: string}> = (props) => {
          const {workspaceId,playlistId} = props ?? {};

          return  deletePlaylist(workspaceId,playlistId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePlaylistMutationResult = NonNullable<Awaited<ReturnType<typeof deletePlaylist>>>

    export type DeletePlaylistMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Delete a playlist
 */
export const useDeletePlaylist = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePlaylist>>, TError,{workspaceId: string;playlistId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePlaylist>>,
        TError,
        {workspaceId: string;playlistId: string},
        TContext
      > => {
      return useMutation(getDeletePlaylistMutationOptions(options));
    }

export const getAddPlaylistItemUrl = (workspaceId: string,
    playlistId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists/${playlistId}/items`
}

/**
 * @summary Add an item to a playlist
 */
export const addPlaylistItem = async (workspaceId: string,
    playlistId: string,
    playlistItemInput: PlaylistItemInput, options?: RequestInit): Promise<PlaylistItem> => {

  return customFetch<PlaylistItem>(getAddPlaylistItemUrl(workspaceId,playlistId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      playlistItemInput,)
  }
);}




export const getAddPlaylistItemMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPlaylistItem>>, TError,{workspaceId: string;playlistId: string;data: BodyType<PlaylistItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addPlaylistItem>>, TError,{workspaceId: string;playlistId: string;data: BodyType<PlaylistItemInput>}, TContext> => {

const mutationKey = ['addPlaylistItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPlaylistItem>>, {workspaceId: string;playlistId: string;data: BodyType<PlaylistItemInput>}> = (props) => {
          const {workspaceId,playlistId,data} = props ?? {};

          return  addPlaylistItem(workspaceId,playlistId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPlaylistItemMutationResult = NonNullable<Awaited<ReturnType<typeof addPlaylistItem>>>
    export type AddPlaylistItemMutationBody = BodyType<PlaylistItemInput>
    export type AddPlaylistItemMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Add an item to a playlist
 */
export const useAddPlaylistItem = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPlaylistItem>>, TError,{workspaceId: string;playlistId: string;data: BodyType<PlaylistItemInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addPlaylistItem>>,
        TError,
        {workspaceId: string;playlistId: string;data: BodyType<PlaylistItemInput>},
        TContext
      > => {
      return useMutation(getAddPlaylistItemMutationOptions(options));
    }

export const getReorderPlaylistItemsUrl = (workspaceId: string,
    playlistId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists/${playlistId}/items`
}

/**
 * @summary Reorder playlist items
 */
export const reorderPlaylistItems = async (workspaceId: string,
    playlistId: string,
    playlistReorderInput: PlaylistReorderInput, options?: RequestInit): Promise<PlaylistItem[]> => {

  return customFetch<PlaylistItem[]>(getReorderPlaylistItemsUrl(workspaceId,playlistId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      playlistReorderInput,)
  }
);}




export const getReorderPlaylistItemsMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderPlaylistItems>>, TError,{workspaceId: string;playlistId: string;data: BodyType<PlaylistReorderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderPlaylistItems>>, TError,{workspaceId: string;playlistId: string;data: BodyType<PlaylistReorderInput>}, TContext> => {

const mutationKey = ['reorderPlaylistItems'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderPlaylistItems>>, {workspaceId: string;playlistId: string;data: BodyType<PlaylistReorderInput>}> = (props) => {
          const {workspaceId,playlistId,data} = props ?? {};

          return  reorderPlaylistItems(workspaceId,playlistId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderPlaylistItemsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderPlaylistItems>>>
    export type ReorderPlaylistItemsMutationBody = BodyType<PlaylistReorderInput>
    export type ReorderPlaylistItemsMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Reorder playlist items
 */
export const useReorderPlaylistItems = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderPlaylistItems>>, TError,{workspaceId: string;playlistId: string;data: BodyType<PlaylistReorderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reorderPlaylistItems>>,
        TError,
        {workspaceId: string;playlistId: string;data: BodyType<PlaylistReorderInput>},
        TContext
      > => {
      return useMutation(getReorderPlaylistItemsMutationOptions(options));
    }

export const getUpdatePlaylistItemUrl = (workspaceId: string,
    playlistId: string,
    itemId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists/${playlistId}/items/${itemId}`
}

/**
 * @summary Update a playlist item (weight, position)
 */
export const updatePlaylistItem = async (workspaceId: string,
    playlistId: string,
    itemId: string,
    playlistItemUpdate: PlaylistItemUpdate, options?: RequestInit): Promise<PlaylistItem> => {

  return customFetch<PlaylistItem>(getUpdatePlaylistItemUrl(workspaceId,playlistId,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      playlistItemUpdate,)
  }
);}




export const getUpdatePlaylistItemMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlaylistItem>>, TError,{workspaceId: string;playlistId: string;itemId: string;data: BodyType<PlaylistItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePlaylistItem>>, TError,{workspaceId: string;playlistId: string;itemId: string;data: BodyType<PlaylistItemUpdate>}, TContext> => {

const mutationKey = ['updatePlaylistItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlaylistItem>>, {workspaceId: string;playlistId: string;itemId: string;data: BodyType<PlaylistItemUpdate>}> = (props) => {
          const {workspaceId,playlistId,itemId,data} = props ?? {};

          return  updatePlaylistItem(workspaceId,playlistId,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlaylistItemMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlaylistItem>>>
    export type UpdatePlaylistItemMutationBody = BodyType<PlaylistItemUpdate>
    export type UpdatePlaylistItemMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a playlist item (weight, position)
 */
export const useUpdatePlaylistItem = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlaylistItem>>, TError,{workspaceId: string;playlistId: string;itemId: string;data: BodyType<PlaylistItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlaylistItem>>,
        TError,
        {workspaceId: string;playlistId: string;itemId: string;data: BodyType<PlaylistItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePlaylistItemMutationOptions(options));
    }

export const getRemovePlaylistItemUrl = (workspaceId: string,
    playlistId: string,
    itemId: string,) => {




  return `/api/workspaces/${workspaceId}/playlists/${playlistId}/items/${itemId}`
}

/**
 * @summary Remove a playlist item
 */
export const removePlaylistItem = async (workspaceId: string,
    playlistId: string,
    itemId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRemovePlaylistItemUrl(workspaceId,playlistId,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemovePlaylistItemMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePlaylistItem>>, TError,{workspaceId: string;playlistId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removePlaylistItem>>, TError,{workspaceId: string;playlistId: string;itemId: string}, TContext> => {

const mutationKey = ['removePlaylistItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removePlaylistItem>>, {workspaceId: string;playlistId: string;itemId: string}> = (props) => {
          const {workspaceId,playlistId,itemId} = props ?? {};

          return  removePlaylistItem(workspaceId,playlistId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemovePlaylistItemMutationResult = NonNullable<Awaited<ReturnType<typeof removePlaylistItem>>>

    export type RemovePlaylistItemMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Remove a playlist item
 */
export const useRemovePlaylistItem = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePlaylistItem>>, TError,{workspaceId: string;playlistId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removePlaylistItem>>,
        TError,
        {workspaceId: string;playlistId: string;itemId: string},
        TContext
      > => {
      return useMutation(getRemovePlaylistItemMutationOptions(options));
    }

export const getListMediaAssetsUrl = (workspaceId: string,
    params?: ListMediaAssetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/media?${stringifiedParams}` : `/api/workspaces/${workspaceId}/media`
}

/**
 * @summary List media assets
 */
export const listMediaAssets = async (workspaceId: string,
    params?: ListMediaAssetsParams, options?: RequestInit): Promise<MediaAssetList> => {

  return customFetch<MediaAssetList>(getListMediaAssetsUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMediaAssetsQueryKey = (workspaceId: string,
    params?: ListMediaAssetsParams,) => {
    return [
    `/api/workspaces/${workspaceId}/media`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMediaAssetsQueryOptions = <TData = Awaited<ReturnType<typeof listMediaAssets>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: ListMediaAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMediaAssets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMediaAssetsQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMediaAssets>>> = ({ signal }) => listMediaAssets(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMediaAssets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMediaAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof listMediaAssets>>>
export type ListMediaAssetsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List media assets
 */

export function useListMediaAssets<TData = Awaited<ReturnType<typeof listMediaAssets>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: ListMediaAssetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMediaAssets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMediaAssetsQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateMediaUploadUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/media`
}

/**
 * @summary Register a media upload and get a presigned upload URL
 */
export const createMediaUpload = async (workspaceId: string,
    mediaUploadInput: MediaUploadInput, options?: RequestInit): Promise<MediaUploadTicket> => {

  return customFetch<MediaUploadTicket>(getCreateMediaUploadUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mediaUploadInput,)
  }
);}




export const getCreateMediaUploadMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMediaUpload>>, TError,{workspaceId: string;data: BodyType<MediaUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMediaUpload>>, TError,{workspaceId: string;data: BodyType<MediaUploadInput>}, TContext> => {

const mutationKey = ['createMediaUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMediaUpload>>, {workspaceId: string;data: BodyType<MediaUploadInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createMediaUpload(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMediaUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createMediaUpload>>>
    export type CreateMediaUploadMutationBody = BodyType<MediaUploadInput>
    export type CreateMediaUploadMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>

    /**
 * @summary Register a media upload and get a presigned upload URL
 */
export const useCreateMediaUpload = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMediaUpload>>, TError,{workspaceId: string;data: BodyType<MediaUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMediaUpload>>,
        TError,
        {workspaceId: string;data: BodyType<MediaUploadInput>},
        TContext
      > => {
      return useMutation(getCreateMediaUploadMutationOptions(options));
    }

export const getBulkMediaActionUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/media/bulk`
}

/**
 * @summary Delete or re-purpose multiple media assets at once
 */
export const bulkMediaAction = async (workspaceId: string,
    mediaBulkActionInput: MediaBulkActionInput, options?: RequestInit): Promise<MediaBulkActionResult> => {

  return customFetch<MediaBulkActionResult>(getBulkMediaActionUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mediaBulkActionInput,)
  }
);}




export const getBulkMediaActionMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMediaAction>>, TError,{workspaceId: string;data: BodyType<MediaBulkActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkMediaAction>>, TError,{workspaceId: string;data: BodyType<MediaBulkActionInput>}, TContext> => {

const mutationKey = ['bulkMediaAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkMediaAction>>, {workspaceId: string;data: BodyType<MediaBulkActionInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  bulkMediaAction(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkMediaActionMutationResult = NonNullable<Awaited<ReturnType<typeof bulkMediaAction>>>
    export type BulkMediaActionMutationBody = BodyType<MediaBulkActionInput>
    export type BulkMediaActionMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Delete or re-purpose multiple media assets at once
 */
export const useBulkMediaAction = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkMediaAction>>, TError,{workspaceId: string;data: BodyType<MediaBulkActionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkMediaAction>>,
        TError,
        {workspaceId: string;data: BodyType<MediaBulkActionInput>},
        TContext
      > => {
      return useMutation(getBulkMediaActionMutationOptions(options));
    }

export const getGetMediaAssetUrl = (workspaceId: string,
    assetId: string,) => {




  return `/api/workspaces/${workspaceId}/media/${assetId}`
}

/**
 * @summary Get a media asset
 */
export const getMediaAsset = async (workspaceId: string,
    assetId: string, options?: RequestInit): Promise<MediaAsset> => {

  return customFetch<MediaAsset>(getGetMediaAssetUrl(workspaceId,assetId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMediaAssetQueryKey = (workspaceId: string,
    assetId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/media/${assetId}`
    ] as const;
    }


export const getGetMediaAssetQueryOptions = <TData = Awaited<ReturnType<typeof getMediaAsset>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    assetId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMediaAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaAssetQueryKey(workspaceId,assetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaAsset>>> = ({ signal }) => getMediaAsset(workspaceId,assetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && assetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMediaAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMediaAssetQueryResult = NonNullable<Awaited<ReturnType<typeof getMediaAsset>>>
export type GetMediaAssetQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get a media asset
 */

export function useGetMediaAsset<TData = Awaited<ReturnType<typeof getMediaAsset>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    assetId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMediaAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMediaAssetQueryOptions(workspaceId,assetId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateMediaAssetUrl = (workspaceId: string,
    assetId: string,) => {




  return `/api/workspaces/${workspaceId}/media/${assetId}`
}

/**
 * @summary Update a media asset (e.g. mark ready)
 */
export const updateMediaAsset = async (workspaceId: string,
    assetId: string,
    mediaAssetUpdate: MediaAssetUpdate, options?: RequestInit): Promise<MediaAsset> => {

  return customFetch<MediaAsset>(getUpdateMediaAssetUrl(workspaceId,assetId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mediaAssetUpdate,)
  }
);}




export const getUpdateMediaAssetMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMediaAsset>>, TError,{workspaceId: string;assetId: string;data: BodyType<MediaAssetUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMediaAsset>>, TError,{workspaceId: string;assetId: string;data: BodyType<MediaAssetUpdate>}, TContext> => {

const mutationKey = ['updateMediaAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMediaAsset>>, {workspaceId: string;assetId: string;data: BodyType<MediaAssetUpdate>}> = (props) => {
          const {workspaceId,assetId,data} = props ?? {};

          return  updateMediaAsset(workspaceId,assetId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMediaAssetMutationResult = NonNullable<Awaited<ReturnType<typeof updateMediaAsset>>>
    export type UpdateMediaAssetMutationBody = BodyType<MediaAssetUpdate>
    export type UpdateMediaAssetMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a media asset (e.g. mark ready)
 */
export const useUpdateMediaAsset = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMediaAsset>>, TError,{workspaceId: string;assetId: string;data: BodyType<MediaAssetUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMediaAsset>>,
        TError,
        {workspaceId: string;assetId: string;data: BodyType<MediaAssetUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMediaAssetMutationOptions(options));
    }

export const getDeleteMediaAssetUrl = (workspaceId: string,
    assetId: string,) => {




  return `/api/workspaces/${workspaceId}/media/${assetId}`
}

/**
 * @summary Delete a media asset
 */
export const deleteMediaAsset = async (workspaceId: string,
    assetId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteMediaAssetUrl(workspaceId,assetId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMediaAssetMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMediaAsset>>, TError,{workspaceId: string;assetId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMediaAsset>>, TError,{workspaceId: string;assetId: string}, TContext> => {

const mutationKey = ['deleteMediaAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMediaAsset>>, {workspaceId: string;assetId: string}> = (props) => {
          const {workspaceId,assetId} = props ?? {};

          return  deleteMediaAsset(workspaceId,assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMediaAssetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMediaAsset>>>

    export type DeleteMediaAssetMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Delete a media asset
 */
export const useDeleteMediaAsset = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMediaAsset>>, TError,{workspaceId: string;assetId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMediaAsset>>,
        TError,
        {workspaceId: string;assetId: string},
        TContext
      > => {
      return useMutation(getDeleteMediaAssetMutationOptions(options));
    }

export const getGetMediaDownloadUrlUrl = (workspaceId: string,
    assetId: string,) => {




  return `/api/workspaces/${workspaceId}/media/${assetId}/download-url`
}

/**
 * @summary Get a presigned download URL for a ready media asset
 */
export const getMediaDownloadUrl = async (workspaceId: string,
    assetId: string, options?: RequestInit): Promise<MediaDownloadUrl> => {

  return customFetch<MediaDownloadUrl>(getGetMediaDownloadUrlUrl(workspaceId,assetId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMediaDownloadUrlQueryKey = (workspaceId: string,
    assetId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/media/${assetId}/download-url`
    ] as const;
    }


export const getGetMediaDownloadUrlQueryOptions = <TData = Awaited<ReturnType<typeof getMediaDownloadUrl>>, TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ServiceUnavailableResponse>>(workspaceId: string,
    assetId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMediaDownloadUrl>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaDownloadUrlQueryKey(workspaceId,assetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaDownloadUrl>>> = ({ signal }) => getMediaDownloadUrl(workspaceId,assetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && assetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMediaDownloadUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMediaDownloadUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getMediaDownloadUrl>>>
export type GetMediaDownloadUrlQueryError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ServiceUnavailableResponse>


/**
 * @summary Get a presigned download URL for a ready media asset
 */

export function useGetMediaDownloadUrl<TData = Awaited<ReturnType<typeof getMediaDownloadUrl>>, TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse | ServiceUnavailableResponse>>(
 workspaceId: string,
    assetId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMediaDownloadUrl>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMediaDownloadUrlQueryOptions(workspaceId,assetId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListSignageContentUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/signage-content`
}

/**
 * @summary List web pages / widgets for the screen library
 */
export const listSignageContent = async (workspaceId: string, options?: RequestInit): Promise<SignageContent[]> => {

  return customFetch<SignageContent[]>(getListSignageContentUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSignageContentQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/signage-content`
    ] as const;
    }


export const getListSignageContentQueryOptions = <TData = Awaited<ReturnType<typeof listSignageContent>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSignageContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSignageContentQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSignageContent>>> = ({ signal }) => listSignageContent(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSignageContent>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSignageContentQueryResult = NonNullable<Awaited<ReturnType<typeof listSignageContent>>>
export type ListSignageContentQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List web pages / widgets for the screen library
 */

export function useListSignageContent<TData = Awaited<ReturnType<typeof listSignageContent>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSignageContent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSignageContentQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateSignageContentUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/signage-content`
}

/**
 * @summary Create a web page or widget signage item
 */
export const createSignageContent = async (workspaceId: string,
    signageContentInput: SignageContentInput, options?: RequestInit): Promise<SignageContent> => {

  return customFetch<SignageContent>(getCreateSignageContentUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      signageContentInput,)
  }
);}




export const getCreateSignageContentMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSignageContent>>, TError,{workspaceId: string;data: BodyType<SignageContentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSignageContent>>, TError,{workspaceId: string;data: BodyType<SignageContentInput>}, TContext> => {

const mutationKey = ['createSignageContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSignageContent>>, {workspaceId: string;data: BodyType<SignageContentInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createSignageContent(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSignageContentMutationResult = NonNullable<Awaited<ReturnType<typeof createSignageContent>>>
    export type CreateSignageContentMutationBody = BodyType<SignageContentInput>
    export type CreateSignageContentMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Create a web page or widget signage item
 */
export const useCreateSignageContent = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSignageContent>>, TError,{workspaceId: string;data: BodyType<SignageContentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSignageContent>>,
        TError,
        {workspaceId: string;data: BodyType<SignageContentInput>},
        TContext
      > => {
      return useMutation(getCreateSignageContentMutationOptions(options));
    }

export const getUpdateSignageContentUrl = (workspaceId: string,
    signageContentId: string,) => {




  return `/api/workspaces/${workspaceId}/signage-content/${signageContentId}`
}

/**
 * @summary Update a signage item
 */
export const updateSignageContent = async (workspaceId: string,
    signageContentId: string,
    signageContentUpdate: SignageContentUpdate, options?: RequestInit): Promise<SignageContent> => {

  return customFetch<SignageContent>(getUpdateSignageContentUrl(workspaceId,signageContentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      signageContentUpdate,)
  }
);}




export const getUpdateSignageContentMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSignageContent>>, TError,{workspaceId: string;signageContentId: string;data: BodyType<SignageContentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSignageContent>>, TError,{workspaceId: string;signageContentId: string;data: BodyType<SignageContentUpdate>}, TContext> => {

const mutationKey = ['updateSignageContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSignageContent>>, {workspaceId: string;signageContentId: string;data: BodyType<SignageContentUpdate>}> = (props) => {
          const {workspaceId,signageContentId,data} = props ?? {};

          return  updateSignageContent(workspaceId,signageContentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSignageContentMutationResult = NonNullable<Awaited<ReturnType<typeof updateSignageContent>>>
    export type UpdateSignageContentMutationBody = BodyType<SignageContentUpdate>
    export type UpdateSignageContentMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a signage item
 */
export const useUpdateSignageContent = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSignageContent>>, TError,{workspaceId: string;signageContentId: string;data: BodyType<SignageContentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSignageContent>>,
        TError,
        {workspaceId: string;signageContentId: string;data: BodyType<SignageContentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSignageContentMutationOptions(options));
    }

export const getDeleteSignageContentUrl = (workspaceId: string,
    signageContentId: string,) => {




  return `/api/workspaces/${workspaceId}/signage-content/${signageContentId}`
}

/**
 * @summary Delete a signage item
 */
export const deleteSignageContent = async (workspaceId: string,
    signageContentId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteSignageContentUrl(workspaceId,signageContentId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSignageContentMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSignageContent>>, TError,{workspaceId: string;signageContentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSignageContent>>, TError,{workspaceId: string;signageContentId: string}, TContext> => {

const mutationKey = ['deleteSignageContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSignageContent>>, {workspaceId: string;signageContentId: string}> = (props) => {
          const {workspaceId,signageContentId} = props ?? {};

          return  deleteSignageContent(workspaceId,signageContentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSignageContentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSignageContent>>>

    export type DeleteSignageContentMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Delete a signage item
 */
export const useDeleteSignageContent = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSignageContent>>, TError,{workspaceId: string;signageContentId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSignageContent>>,
        TError,
        {workspaceId: string;signageContentId: string},
        TContext
      > => {
      return useMutation(getDeleteSignageContentMutationOptions(options));
    }

export const getListTtsVoicesUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/tts/voices`
}

/**
 * @summary Curated text-to-speech voices for the configured provider
 */
export const listTtsVoices = async (workspaceId: string, options?: RequestInit): Promise<TtsVoiceList> => {

  return customFetch<TtsVoiceList>(getListTtsVoicesUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTtsVoicesQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/tts/voices`
    ] as const;
    }


export const getListTtsVoicesQueryOptions = <TData = Awaited<ReturnType<typeof listTtsVoices>>, TError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTtsVoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTtsVoicesQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTtsVoices>>> = ({ signal }) => listTtsVoices(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTtsVoices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTtsVoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listTtsVoices>>>
export type ListTtsVoicesQueryError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>


/**
 * @summary Curated text-to-speech voices for the configured provider
 */

export function useListTtsVoices<TData = Awaited<ReturnType<typeof listTtsVoices>>, TError = ErrorType<ForbiddenResponse | ServiceUnavailableResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTtsVoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTtsVoicesQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTtsAnnouncementUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/tts/announcements`
}

/**
 * @summary Synthesize announcement speech and store it as a ready media asset
 */
export const createTtsAnnouncement = async (workspaceId: string,
    ttsAnnouncementInput: TtsAnnouncementInput, options?: RequestInit): Promise<MediaAsset> => {

  return customFetch<MediaAsset>(getCreateTtsAnnouncementUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ttsAnnouncementInput,)
  }
);}




export const getCreateTtsAnnouncementMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | TooManyRequestsResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTtsAnnouncement>>, TError,{workspaceId: string;data: BodyType<TtsAnnouncementInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTtsAnnouncement>>, TError,{workspaceId: string;data: BodyType<TtsAnnouncementInput>}, TContext> => {

const mutationKey = ['createTtsAnnouncement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTtsAnnouncement>>, {workspaceId: string;data: BodyType<TtsAnnouncementInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createTtsAnnouncement(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTtsAnnouncementMutationResult = NonNullable<Awaited<ReturnType<typeof createTtsAnnouncement>>>
    export type CreateTtsAnnouncementMutationBody = BodyType<TtsAnnouncementInput>
    export type CreateTtsAnnouncementMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | TooManyRequestsResponse | ServiceUnavailableResponse>

    /**
 * @summary Synthesize announcement speech and store it as a ready media asset
 */
export const useCreateTtsAnnouncement = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | TooManyRequestsResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTtsAnnouncement>>, TError,{workspaceId: string;data: BodyType<TtsAnnouncementInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTtsAnnouncement>>,
        TError,
        {workspaceId: string;data: BodyType<TtsAnnouncementInput>},
        TContext
      > => {
      return useMutation(getCreateTtsAnnouncementMutationOptions(options));
    }

export const getListTtsPresetsUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/tts/presets`
}

/**
 * @summary Curated announcement script presets plus the effective text limit
 */
export const listTtsPresets = async (workspaceId: string, options?: RequestInit): Promise<TtsPresetList> => {

  return customFetch<TtsPresetList>(getListTtsPresetsUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTtsPresetsQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/tts/presets`
    ] as const;
    }


export const getListTtsPresetsQueryOptions = <TData = Awaited<ReturnType<typeof listTtsPresets>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTtsPresets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTtsPresetsQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTtsPresets>>> = ({ signal }) => listTtsPresets(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTtsPresets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTtsPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof listTtsPresets>>>
export type ListTtsPresetsQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary Curated announcement script presets plus the effective text limit
 */

export function useListTtsPresets<TData = Awaited<ReturnType<typeof listTtsPresets>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTtsPresets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTtsPresetsQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTtsDraftUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/tts/draft`
}

/**
 * Text-only compute endpoint — nothing is stored and no audio is synthesized. One LLM call per request; gated by the ANNOUNCE_AI_* server configuration (503 when unconfigured).
 * @summary Draft an announcement script with AI from a short brief
 */
export const createTtsDraft = async (workspaceId: string,
    ttsDraftInput: TtsDraftInput, options?: RequestInit): Promise<TtsDraftResponse> => {

  return customFetch<TtsDraftResponse>(getCreateTtsDraftUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ttsDraftInput,)
  }
);}




export const getCreateTtsDraftMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | TooManyRequestsResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTtsDraft>>, TError,{workspaceId: string;data: BodyType<TtsDraftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTtsDraft>>, TError,{workspaceId: string;data: BodyType<TtsDraftInput>}, TContext> => {

const mutationKey = ['createTtsDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTtsDraft>>, {workspaceId: string;data: BodyType<TtsDraftInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createTtsDraft(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTtsDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createTtsDraft>>>
    export type CreateTtsDraftMutationBody = BodyType<TtsDraftInput>
    export type CreateTtsDraftMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | TooManyRequestsResponse | ServiceUnavailableResponse>

    /**
 * @summary Draft an announcement script with AI from a short brief
 */
export const useCreateTtsDraft = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | TooManyRequestsResponse | ServiceUnavailableResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTtsDraft>>, TError,{workspaceId: string;data: BodyType<TtsDraftInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTtsDraft>>,
        TError,
        {workspaceId: string;data: BodyType<TtsDraftInput>},
        TContext
      > => {
      return useMutation(getCreateTtsDraftMutationOptions(options));
    }

export const getListCatalogueTracksUrl = (params?: ListCatalogueTracksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalogue/tracks?${stringifiedParams}` : `/api/catalogue/tracks`
}

/**
 * @summary List catalogue tracks
 */
export const listCatalogueTracks = async (params?: ListCatalogueTracksParams, options?: RequestInit): Promise<CatalogueTrackList> => {

  return customFetch<CatalogueTrackList>(getListCatalogueTracksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCatalogueTracksQueryKey = (params?: ListCatalogueTracksParams,) => {
    return [
    `/api/catalogue/tracks`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCatalogueTracksQueryOptions = <TData = Awaited<ReturnType<typeof listCatalogueTracks>>, TError = ErrorType<UnauthorizedResponse>>(params?: ListCatalogueTracksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueTracks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCatalogueTracksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCatalogueTracks>>> = ({ signal }) => listCatalogueTracks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCatalogueTracks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCatalogueTracksQueryResult = NonNullable<Awaited<ReturnType<typeof listCatalogueTracks>>>
export type ListCatalogueTracksQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary List catalogue tracks
 */

export function useListCatalogueTracks<TData = Awaited<ReturnType<typeof listCatalogueTracks>>, TError = ErrorType<UnauthorizedResponse>>(
 params?: ListCatalogueTracksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueTracks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCatalogueTracksQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetCatalogueTrackUrl = (trackId: string,) => {




  return `/api/catalogue/tracks/${trackId}`
}

/**
 * @summary Get a catalogue track
 */
export const getCatalogueTrack = async (trackId: string, options?: RequestInit): Promise<CatalogueTrack> => {

  return customFetch<CatalogueTrack>(getGetCatalogueTrackUrl(trackId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCatalogueTrackQueryKey = (trackId: string,) => {
    return [
    `/api/catalogue/tracks/${trackId}`
    ] as const;
    }


export const getGetCatalogueTrackQueryOptions = <TData = Awaited<ReturnType<typeof getCatalogueTrack>>, TError = ErrorType<NotFoundResponse>>(trackId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueTrack>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCatalogueTrackQueryKey(trackId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogueTrack>>> = ({ signal }) => getCatalogueTrack(trackId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(trackId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCatalogueTrack>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCatalogueTrackQueryResult = NonNullable<Awaited<ReturnType<typeof getCatalogueTrack>>>
export type GetCatalogueTrackQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get a catalogue track
 */

export function useGetCatalogueTrack<TData = Awaited<ReturnType<typeof getCatalogueTrack>>, TError = ErrorType<NotFoundResponse>>(
 trackId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueTrack>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCatalogueTrackQueryOptions(trackId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSetCatalogueTrackReactionUrl = (workspaceId: string,
    trackId: string,) => {




  return `/api/workspaces/${workspaceId}/catalogue/tracks/${trackId}/reaction`
}

/**
 * @summary Set or clear the caller's reaction to a catalogue track
 */
export const setCatalogueTrackReaction = async (workspaceId: string,
    trackId: string,
    catalogueTrackReactionInput: CatalogueTrackReactionInput, options?: RequestInit): Promise<CatalogueTrackReactionState> => {

  return customFetch<CatalogueTrackReactionState>(getSetCatalogueTrackReactionUrl(workspaceId,trackId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      catalogueTrackReactionInput,)
  }
);}




export const getSetCatalogueTrackReactionMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCatalogueTrackReaction>>, TError,{workspaceId: string;trackId: string;data: BodyType<CatalogueTrackReactionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setCatalogueTrackReaction>>, TError,{workspaceId: string;trackId: string;data: BodyType<CatalogueTrackReactionInput>}, TContext> => {

const mutationKey = ['setCatalogueTrackReaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCatalogueTrackReaction>>, {workspaceId: string;trackId: string;data: BodyType<CatalogueTrackReactionInput>}> = (props) => {
          const {workspaceId,trackId,data} = props ?? {};

          return  setCatalogueTrackReaction(workspaceId,trackId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetCatalogueTrackReactionMutationResult = NonNullable<Awaited<ReturnType<typeof setCatalogueTrackReaction>>>
    export type SetCatalogueTrackReactionMutationBody = BodyType<CatalogueTrackReactionInput>
    export type SetCatalogueTrackReactionMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Set or clear the caller's reaction to a catalogue track
 */
export const useSetCatalogueTrackReaction = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCatalogueTrackReaction>>, TError,{workspaceId: string;trackId: string;data: BodyType<CatalogueTrackReactionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setCatalogueTrackReaction>>,
        TError,
        {workspaceId: string;trackId: string;data: BodyType<CatalogueTrackReactionInput>},
        TContext
      > => {
      return useMutation(getSetCatalogueTrackReactionMutationOptions(options));
    }

export const getGetCatalogueIndexInfoUrl = () => {




  return `/api/catalogue/index-info`
}

/**
 * @summary Catalogue index metadata (content hash, stats)
 */
export const getCatalogueIndexInfo = async ( options?: RequestInit): Promise<CatalogueIndexInfo> => {

  return customFetch<CatalogueIndexInfo>(getGetCatalogueIndexInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCatalogueIndexInfoQueryKey = () => {
    return [
    `/api/catalogue/index-info`
    ] as const;
    }


export const getGetCatalogueIndexInfoQueryOptions = <TData = Awaited<ReturnType<typeof getCatalogueIndexInfo>>, TError = ErrorType<NotFoundResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIndexInfo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCatalogueIndexInfoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogueIndexInfo>>> = ({ signal }) => getCatalogueIndexInfo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIndexInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCatalogueIndexInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getCatalogueIndexInfo>>>
export type GetCatalogueIndexInfoQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Catalogue index metadata (content hash, stats)
 */

export function useGetCatalogueIndexInfo<TData = Awaited<ReturnType<typeof getCatalogueIndexInfo>>, TError = ErrorType<NotFoundResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCatalogueIndexInfo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCatalogueIndexInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCatalogueGenresUrl = () => {




  return `/api/catalogue/genres`
}

/**
 * @summary List catalogue genres
 */
export const listCatalogueGenres = async ( options?: RequestInit): Promise<CatalogueGenre[]> => {

  return customFetch<CatalogueGenre[]>(getListCatalogueGenresUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCatalogueGenresQueryKey = () => {
    return [
    `/api/catalogue/genres`
    ] as const;
    }


export const getListCatalogueGenresQueryOptions = <TData = Awaited<ReturnType<typeof listCatalogueGenres>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueGenres>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCatalogueGenresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCatalogueGenres>>> = ({ signal }) => listCatalogueGenres({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCatalogueGenres>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCatalogueGenresQueryResult = NonNullable<Awaited<ReturnType<typeof listCatalogueGenres>>>
export type ListCatalogueGenresQueryError = ErrorType<unknown>


/**
 * @summary List catalogue genres
 */

export function useListCatalogueGenres<TData = Awaited<ReturnType<typeof listCatalogueGenres>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueGenres>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCatalogueGenresQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCatalogueFacetsUrl = () => {




  return `/api/catalogue/facets`
}

/**
 * @summary Distinct catalogue taxonomy values (for rule builders / filters)
 */
export const listCatalogueFacets = async ( options?: RequestInit): Promise<CatalogueFacets> => {

  return customFetch<CatalogueFacets>(getListCatalogueFacetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCatalogueFacetsQueryKey = () => {
    return [
    `/api/catalogue/facets`
    ] as const;
    }


export const getListCatalogueFacetsQueryOptions = <TData = Awaited<ReturnType<typeof listCatalogueFacets>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueFacets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCatalogueFacetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCatalogueFacets>>> = ({ signal }) => listCatalogueFacets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCatalogueFacets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCatalogueFacetsQueryResult = NonNullable<Awaited<ReturnType<typeof listCatalogueFacets>>>
export type ListCatalogueFacetsQueryError = ErrorType<unknown>


/**
 * @summary Distinct catalogue taxonomy values (for rule builders / filters)
 */

export function useListCatalogueFacets<TData = Awaited<ReturnType<typeof listCatalogueFacets>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueFacets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCatalogueFacetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCatalogueArtistsUrl = (params?: ListCatalogueArtistsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/catalogue/artists?${stringifiedParams}` : `/api/catalogue/artists`
}

/**
 * @summary List catalogue artists
 */
export const listCatalogueArtists = async (params?: ListCatalogueArtistsParams, options?: RequestInit): Promise<CatalogueArtist[]> => {

  return customFetch<CatalogueArtist[]>(getListCatalogueArtistsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCatalogueArtistsQueryKey = (params?: ListCatalogueArtistsParams,) => {
    return [
    `/api/catalogue/artists`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCatalogueArtistsQueryOptions = <TData = Awaited<ReturnType<typeof listCatalogueArtists>>, TError = ErrorType<unknown>>(params?: ListCatalogueArtistsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueArtists>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCatalogueArtistsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCatalogueArtists>>> = ({ signal }) => listCatalogueArtists(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCatalogueArtists>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCatalogueArtistsQueryResult = NonNullable<Awaited<ReturnType<typeof listCatalogueArtists>>>
export type ListCatalogueArtistsQueryError = ErrorType<unknown>


/**
 * @summary List catalogue artists
 */

export function useListCatalogueArtists<TData = Awaited<ReturnType<typeof listCatalogueArtists>>, TError = ErrorType<unknown>>(
 params?: ListCatalogueArtistsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCatalogueArtists>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCatalogueArtistsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListNowPlayingUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/now-playing`
}

/**
 * @summary List current playback state for all devices in the workspace
 */
export const listNowPlaying = async (workspaceId: string, options?: RequestInit): Promise<DevicePlayback[]> => {

  return customFetch<DevicePlayback[]>(getListNowPlayingUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNowPlayingQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/now-playing`
    ] as const;
    }


export const getListNowPlayingQueryOptions = <TData = Awaited<ReturnType<typeof listNowPlaying>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNowPlaying>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNowPlayingQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNowPlaying>>> = ({ signal }) => listNowPlaying(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNowPlaying>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNowPlayingQueryResult = NonNullable<Awaited<ReturnType<typeof listNowPlaying>>>
export type ListNowPlayingQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List current playback state for all devices in the workspace
 */

export function useListNowPlaying<TData = Awaited<ReturnType<typeof listNowPlaying>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNowPlaying>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNowPlayingQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListSchedulesUrl = (workspaceId: string,
    params?: ListSchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/schedules?${stringifiedParams}` : `/api/workspaces/${workspaceId}/schedules`
}

/**
 * @summary List schedules
 */
export const listSchedules = async (workspaceId: string,
    params?: ListSchedulesParams, options?: RequestInit): Promise<Schedule[]> => {

  return customFetch<Schedule[]>(getListSchedulesUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSchedulesQueryKey = (workspaceId: string,
    params?: ListSchedulesParams,) => {
    return [
    `/api/workspaces/${workspaceId}/schedules`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listSchedules>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string,
    params?: ListSchedulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSchedules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchedulesQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchedules>>> = ({ signal }) => listSchedules(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchedules>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listSchedules>>>
export type ListSchedulesQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List schedules
 */

export function useListSchedules<TData = Awaited<ReturnType<typeof listSchedules>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string,
    params?: ListSchedulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSchedules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSchedulesQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateScheduleUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/schedules`
}

/**
 * @summary Create a schedule
 */
export const createSchedule = async (workspaceId: string,
    scheduleInput: ScheduleInput, options?: RequestInit): Promise<Schedule> => {

  return customFetch<Schedule>(getCreateScheduleUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      scheduleInput,)
  }
);}




export const getCreateScheduleMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchedule>>, TError,{workspaceId: string;data: BodyType<ScheduleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchedule>>, TError,{workspaceId: string;data: BodyType<ScheduleInput>}, TContext> => {

const mutationKey = ['createSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchedule>>, {workspaceId: string;data: BodyType<ScheduleInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createSchedule(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof createSchedule>>>
    export type CreateScheduleMutationBody = BodyType<ScheduleInput>
    export type CreateScheduleMutationError = ErrorType<BadRequestResponse | ForbiddenResponse>

    /**
 * @summary Create a schedule
 */
export const useCreateSchedule = <TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchedule>>, TError,{workspaceId: string;data: BodyType<ScheduleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSchedule>>,
        TError,
        {workspaceId: string;data: BodyType<ScheduleInput>},
        TContext
      > => {
      return useMutation(getCreateScheduleMutationOptions(options));
    }

export const getGetScheduleUrl = (workspaceId: string,
    scheduleId: string,) => {




  return `/api/workspaces/${workspaceId}/schedules/${scheduleId}`
}

/**
 * @summary Get a schedule with its entries and audiences
 */
export const getSchedule = async (workspaceId: string,
    scheduleId: string, options?: RequestInit): Promise<Schedule> => {

  return customFetch<Schedule>(getGetScheduleUrl(workspaceId,scheduleId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScheduleQueryKey = (workspaceId: string,
    scheduleId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/schedules/${scheduleId}`
    ] as const;
    }


export const getGetScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getSchedule>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    scheduleId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleQueryKey(workspaceId,scheduleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedule>>> = ({ signal }) => getSchedule(workspaceId,scheduleId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type GetScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getSchedule>>>
export type GetScheduleQueryError = ErrorType<ForbiddenResponse | NotFoundResponse>


/**
 * @summary Get a schedule with its entries and audiences
 */

export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = ErrorType<ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    scheduleId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetScheduleQueryOptions(workspaceId,scheduleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateScheduleUrl = (workspaceId: string,
    scheduleId: string,) => {




  return `/api/workspaces/${workspaceId}/schedules/${scheduleId}`
}

/**
 * @summary Update a schedule
 */
export const updateSchedule = async (workspaceId: string,
    scheduleId: string,
    scheduleUpdate: ScheduleUpdate, options?: RequestInit): Promise<Schedule> => {

  return customFetch<Schedule>(getUpdateScheduleUrl(workspaceId,scheduleId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      scheduleUpdate,)
  }
);}




export const getUpdateScheduleMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchedule>>, TError,{workspaceId: string;scheduleId: string;data: BodyType<ScheduleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSchedule>>, TError,{workspaceId: string;scheduleId: string;data: BodyType<ScheduleUpdate>}, TContext> => {

const mutationKey = ['updateSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchedule>>, {workspaceId: string;scheduleId: string;data: BodyType<ScheduleUpdate>}> = (props) => {
          const {workspaceId,scheduleId,data} = props ?? {};

          return  updateSchedule(workspaceId,scheduleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchedule>>>
    export type UpdateScheduleMutationBody = BodyType<ScheduleUpdate>
    export type UpdateScheduleMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a schedule
 */
export const useUpdateSchedule = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchedule>>, TError,{workspaceId: string;scheduleId: string;data: BodyType<ScheduleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSchedule>>,
        TError,
        {workspaceId: string;scheduleId: string;data: BodyType<ScheduleUpdate>},
        TContext
      > => {
      return useMutation(getUpdateScheduleMutationOptions(options));
    }

export const getDeleteScheduleUrl = (workspaceId: string,
    scheduleId: string,) => {




  return `/api/workspaces/${workspaceId}/schedules/${scheduleId}`
}

/**
 * @summary Delete a schedule
 */
export const deleteSchedule = async (workspaceId: string,
    scheduleId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteScheduleUrl(workspaceId,scheduleId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteScheduleMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchedule>>, TError,{workspaceId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSchedule>>, TError,{workspaceId: string;scheduleId: string}, TContext> => {

const mutationKey = ['deleteSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSchedule>>, {workspaceId: string;scheduleId: string}> = (props) => {
          const {workspaceId,scheduleId} = props ?? {};

          return  deleteSchedule(workspaceId,scheduleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSchedule>>>

    export type DeleteScheduleMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Delete a schedule
 */
export const useDeleteSchedule = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchedule>>, TError,{workspaceId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSchedule>>,
        TError,
        {workspaceId: string;scheduleId: string},
        TContext
      > => {
      return useMutation(getDeleteScheduleMutationOptions(options));
    }

export const getActivateScheduleUrl = (workspaceId: string,
    scheduleId: string,) => {




  return `/api/workspaces/${workspaceId}/schedules/${scheduleId}/activate`
}

/**
 * @summary Activate a schedule
 */
export const activateSchedule = async (workspaceId: string,
    scheduleId: string, options?: RequestInit): Promise<Schedule> => {

  return customFetch<Schedule>(getActivateScheduleUrl(workspaceId,scheduleId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivateScheduleMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateSchedule>>, TError,{workspaceId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activateSchedule>>, TError,{workspaceId: string;scheduleId: string}, TContext> => {

const mutationKey = ['activateSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateSchedule>>, {workspaceId: string;scheduleId: string}> = (props) => {
          const {workspaceId,scheduleId} = props ?? {};

          return  activateSchedule(workspaceId,scheduleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof activateSchedule>>>

    export type ActivateScheduleMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Activate a schedule
 */
export const useActivateSchedule = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateSchedule>>, TError,{workspaceId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof activateSchedule>>,
        TError,
        {workspaceId: string;scheduleId: string},
        TContext
      > => {
      return useMutation(getActivateScheduleMutationOptions(options));
    }

export const getPauseScheduleUrl = (workspaceId: string,
    scheduleId: string,) => {




  return `/api/workspaces/${workspaceId}/schedules/${scheduleId}/pause`
}

/**
 * @summary Pause a schedule
 */
export const pauseSchedule = async (workspaceId: string,
    scheduleId: string, options?: RequestInit): Promise<Schedule> => {

  return customFetch<Schedule>(getPauseScheduleUrl(workspaceId,scheduleId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPauseScheduleMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseSchedule>>, TError,{workspaceId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pauseSchedule>>, TError,{workspaceId: string;scheduleId: string}, TContext> => {

const mutationKey = ['pauseSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseSchedule>>, {workspaceId: string;scheduleId: string}> = (props) => {
          const {workspaceId,scheduleId} = props ?? {};

          return  pauseSchedule(workspaceId,scheduleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PauseScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof pauseSchedule>>>

    export type PauseScheduleMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Pause a schedule
 */
export const usePauseSchedule = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseSchedule>>, TError,{workspaceId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof pauseSchedule>>,
        TError,
        {workspaceId: string;scheduleId: string},
        TContext
      > => {
      return useMutation(getPauseScheduleMutationOptions(options));
    }

export const getListQuickPlaysUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/quick-play`
}

/**
 * @summary List the workspace's active quick plays (expired ones are GC'd)
 */
export const listQuickPlays = async (workspaceId: string, options?: RequestInit): Promise<QuickPlay[]> => {

  return customFetch<QuickPlay[]>(getListQuickPlaysUrl(workspaceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQuickPlaysQueryKey = (workspaceId: string,) => {
    return [
    `/api/workspaces/${workspaceId}/quick-play`
    ] as const;
    }


export const getListQuickPlaysQueryOptions = <TData = Awaited<ReturnType<typeof listQuickPlays>>, TError = ErrorType<ForbiddenResponse>>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuickPlays>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuickPlaysQueryKey(workspaceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuickPlays>>> = ({ signal }) => listQuickPlays(workspaceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQuickPlays>>, TError, TData> & { queryKey: QueryKey }
}

export type ListQuickPlaysQueryResult = NonNullable<Awaited<ReturnType<typeof listQuickPlays>>>
export type ListQuickPlaysQueryError = ErrorType<ForbiddenResponse>


/**
 * @summary List the workspace's active quick plays (expired ones are GC'd)
 */

export function useListQuickPlays<TData = Awaited<ReturnType<typeof listQuickPlays>>, TError = ErrorType<ForbiddenResponse>>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listQuickPlays>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListQuickPlaysQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateQuickPlayUrl = (workspaceId: string,) => {




  return `/api/workspaces/${workspaceId}/quick-play`
}

/**
 * @summary Start an ephemeral timed override on a device or location
 */
export const createQuickPlay = async (workspaceId: string,
    quickPlayInput: QuickPlayInput, options?: RequestInit): Promise<QuickPlay> => {

  return customFetch<QuickPlay>(getCreateQuickPlayUrl(workspaceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      quickPlayInput,)
  }
);}




export const getCreateQuickPlayMutationOptions = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuickPlay>>, TError,{workspaceId: string;data: BodyType<QuickPlayInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createQuickPlay>>, TError,{workspaceId: string;data: BodyType<QuickPlayInput>}, TContext> => {

const mutationKey = ['createQuickPlay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createQuickPlay>>, {workspaceId: string;data: BodyType<QuickPlayInput>}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createQuickPlay(workspaceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateQuickPlayMutationResult = NonNullable<Awaited<ReturnType<typeof createQuickPlay>>>
    export type CreateQuickPlayMutationBody = BodyType<QuickPlayInput>
    export type CreateQuickPlayMutationError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Start an ephemeral timed override on a device or location
 */
export const useCreateQuickPlay = <TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuickPlay>>, TError,{workspaceId: string;data: BodyType<QuickPlayInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createQuickPlay>>,
        TError,
        {workspaceId: string;data: BodyType<QuickPlayInput>},
        TContext
      > => {
      return useMutation(getCreateQuickPlayMutationOptions(options));
    }

export const getDeleteQuickPlayUrl = (workspaceId: string,
    scheduleId: string,) => {




  return `/api/workspaces/${workspaceId}/quick-play/${scheduleId}`
}

/**
 * @summary Stop a quick play (deletes its hidden schedule + system audience)
 */
export const deleteQuickPlay = async (workspaceId: string,
    scheduleId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteQuickPlayUrl(workspaceId,scheduleId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteQuickPlayMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQuickPlay>>, TError,{workspaceId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteQuickPlay>>, TError,{workspaceId: string;scheduleId: string}, TContext> => {

const mutationKey = ['deleteQuickPlay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQuickPlay>>, {workspaceId: string;scheduleId: string}> = (props) => {
          const {workspaceId,scheduleId} = props ?? {};

          return  deleteQuickPlay(workspaceId,scheduleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteQuickPlayMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQuickPlay>>>

    export type DeleteQuickPlayMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Stop a quick play (deletes its hidden schedule + system audience)
 */
export const useDeleteQuickPlay = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQuickPlay>>, TError,{workspaceId: string;scheduleId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQuickPlay>>,
        TError,
        {workspaceId: string;scheduleId: string},
        TContext
      > => {
      return useMutation(getDeleteQuickPlayMutationOptions(options));
    }

export const getResolveScheduleUrl = (workspaceId: string,
    params?: ResolveScheduleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/schedule/resolve?${stringifiedParams}` : `/api/workspaces/${workspaceId}/schedule/resolve`
}

/**
 * @summary Resolve the effective plan (now/next per channel) for a target
 */
export const resolveSchedule = async (workspaceId: string,
    params?: ResolveScheduleParams, options?: RequestInit): Promise<ResolvedPlan> => {

  return customFetch<ResolvedPlan>(getResolveScheduleUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getResolveScheduleQueryKey = (workspaceId: string,
    params?: ResolveScheduleParams,) => {
    return [
    `/api/workspaces/${workspaceId}/schedule/resolve`, ...(params ? [params] : [])
    ] as const;
    }


export const getResolveScheduleQueryOptions = <TData = Awaited<ReturnType<typeof resolveSchedule>>, TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    params?: ResolveScheduleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof resolveSchedule>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveScheduleQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveSchedule>>> = ({ signal }) => resolveSchedule(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolveSchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type ResolveScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof resolveSchedule>>>
export type ResolveScheduleQueryError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>


/**
 * @summary Resolve the effective plan (now/next per channel) for a target
 */

export function useResolveSchedule<TData = Awaited<ReturnType<typeof resolveSchedule>>, TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    params?: ResolveScheduleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof resolveSchedule>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getResolveScheduleQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPreviewScheduleUrl = (workspaceId: string,
    params?: PreviewScheduleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workspaces/${workspaceId}/schedule/preview?${stringifiedParams}` : `/api/workspaces/${workspaceId}/schedule/preview`
}

/**
 * @summary Preview the composed playback timeline for a target over a window
 */
export const previewSchedule = async (workspaceId: string,
    params?: PreviewScheduleParams, options?: RequestInit): Promise<SchedulePreview> => {

  return customFetch<SchedulePreview>(getPreviewScheduleUrl(workspaceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPreviewScheduleQueryKey = (workspaceId: string,
    params?: PreviewScheduleParams,) => {
    return [
    `/api/workspaces/${workspaceId}/schedule/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getPreviewScheduleQueryOptions = <TData = Awaited<ReturnType<typeof previewSchedule>>, TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>>(workspaceId: string,
    params?: PreviewScheduleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewSchedule>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewScheduleQueryKey(workspaceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewSchedule>>> = ({ signal }) => previewSchedule(workspaceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewSchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type PreviewScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof previewSchedule>>>
export type PreviewScheduleQueryError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>


/**
 * @summary Preview the composed playback timeline for a target over a window
 */

export function usePreviewSchedule<TData = Awaited<ReturnType<typeof previewSchedule>>, TError = ErrorType<BadRequestResponse | ForbiddenResponse | NotFoundResponse>>(
 workspaceId: string,
    params?: PreviewScheduleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewSchedule>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPreviewScheduleQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







